import dictionaries from './dictionaries'
import glossarySurfacePhraseTranslations from './glossarySurfacePhraseTranslations'
import { DEFAULT_LANGUAGE } from './languages'
import reportAndGlossaryPhraseTranslations, {
  composableDirectionTranslations,
} from './reportAndGlossaryPhraseTranslations'
import sourceAuditRemainderTranslations from './sourceAuditRemainderTranslations'

export const phraseTranslations = {
  de: {
    '3D Image': '3D-Bild',
    '3D Images': '3D-Bilder',
    '3D Scan': '3D-Scan',
    '3D Scan Images': '3D-Scan-Bilder',
    '3D View': '3D-Ansicht',
    Access: 'Zugriff',
    'Access Request': 'Zugriffsanfrage',
    Account: 'Konto',
    'Account Settings': 'Kontoeinstellungen',
    'Active Users': 'Aktive Benutzer',
    Add: 'Hinzufügen',
    'Add Coaches': 'Coaches hinzufügen',
    'Add Metrics': 'Metriken hinzufügen',
    'Add New Client': 'Neuen Kunden hinzufügen',
    'Additional Metrics': 'Zusätzliche Metriken',
    Age: 'Alter',
    'All Scans': 'Alle Scans',
    'All Time': 'Gesamt',
    Apply: 'Anwenden',
    April: 'April',
    Arm: 'Arm',
    Arms: 'Arme',
    August: 'August',
    Balance: 'Balance',
    'Balance Report': 'Balance-Bericht',
    Baseline: 'Ausgangswert',
    'Baseline Scan': 'Ausgangsscan',
    'Birth Date': 'Geburtsdatum',
    Body: 'Körper',
    'Body Composition': 'Körperzusammensetzung',
    'Body Fat': 'Körperfett',
    'Body Fat %': 'Körperfett %',
    'Body Fat Percentage': 'Körperfettanteil',
    'Body Shape': 'Körperform',
    'Body Shape Rating': 'Körperformbewertung',
    'By clicking "request", you will send a request to the selected client.':
      'Wenn Sie auf "Anfragen" klicken, senden Sie eine Anfrage an den ausgewählten Kunden.',
    Cancel: 'Abbrechen',
    'Change Scan': 'Scan ändern',
    'Change Password': 'Passwort ändern',
    Click: 'Klicken Sie',
    Client: 'Kunde',
    'Client Information': 'Kundeninformationen',
    'Client Scan History': 'Scanverlauf des Kunden',
    'Client Scans': 'Kundenscans',
    Clients: 'Kunden',
    Close: 'Schließen',
    Coach: 'Trainer',
    'Coach Activity': 'Traineraktivität',
    'Coach Activity Challenge': 'Traineraktivitäts-Challenge',
    'Coach Activity Leaderboard - August 2018':
      'Traineraktivitäts-Bestenliste - August 2018',
    'Coach Activity Leaders': 'Führende Traineraktivität',
    'Coach Leaders (All Time)': 'Trainer-Rangliste (gesamt)',
    'Coach Leaders (Current Month)': 'Trainer-Rangliste (aktueller Monat)',
    Coaches: 'Trainer',
    'Coaches are ranked based on their ParQs completed and Wins (potential clients they have marked as interested).':
      'Trainer werden nach abgeschlossenen ParQs und Erfolgen bewertet (potenzielle Kunden, die sie als interessiert markiert haben).',
    Compare: 'Vergleichen',
    Comparison: 'Vergleich',
    'Completed Scans': 'Abgeschlossene Scans',
    Confirm: 'Bestätigen',
    'Confirm Password': 'Passwort bestätigen',
    Contact: 'Kontakt',
    Current: 'Aktuell',
    'Current Month': 'Aktueller Monat',
    'Current Scan': 'Aktueller Scan',
    Dashboard: 'Dashboard',
    Date: 'Datum',
    Day: 'Tag',
    December: 'Dezember',
    Delete: 'Löschen',
    'Demo Comparison': 'Demo-Vergleich',
    'Demo Report': 'Demo-Bericht',
    Download: 'Herunterladen',
    'Download Measurements': 'Messungen herunterladen',
    Edit: 'Bearbeiten',
    Email: 'E-Mail',
    'Email required': 'E-Mail erforderlich',
    'European/SI (cm/kg)': 'Europäisch/SI (cm/kg)',
    'Failed to request client access. Please contact support or try again.':
      'Kundenzugriff konnte nicht angefragt werden. Bitte kontaktieren Sie den Support oder versuchen Sie es erneut.',
    'Fat Mass': 'Fettmasse',
    February: 'Februar',
    Female: 'Weiblich',
    'First Name': 'Vorname',
    'First name required': 'Vorname erforderlich',
    Fitness: 'Fitness',
    'Fitness Goals': 'Fitnessziele',
    'Fit3D Body Shape Rating': 'Fit3D-Körperformbewertung',
    Glossary: 'Glossar',
    Goal: 'Ziel',
    Goals: 'Ziele',
    Green: 'Grün',
    Height: 'Größe',
    Help: 'Hilfe',
    'Hide Full Scans': 'Vollständige Scans ausblenden',
    History: 'Verlauf',
    Home: 'Startseite',
    Hips: 'Hüfte',
    Images: 'Bilder',
    'In Progress': 'In Bearbeitung',
    Interested: 'Interessiert',
    'Interested Later': 'Später interessiert',
    'Invalid email address': 'Ungültige E-Mail-Adresse',
    January: 'Januar',
    July: 'Juli',
    June: 'Juni',
    'Last Name': 'Nachname',
    'Last name required': 'Nachname erforderlich',
    Lean: 'Mager',
    'Lean Mass': 'Magermasse',
    Leg: 'Bein',
    Legs: 'Beine',
    Loading: 'Wird geladen',
    'Loading...': 'Wird geladen...',
    Logout: 'Abmelden',
    Male: 'Männlich',
    Manage: 'Verwalten',
    'Manage Coaches': 'Trainer verwalten',
    March: 'März',
    May: 'Mai',
    Measurements: 'Messungen',
    Maybe: 'Vielleicht',
    Metric: 'Metrik',
    'Metric/SI (cm/kg)': 'Metrisch/SI (cm/kg)',
    Metrics: 'Metriken',
    Month: 'Monat',
    'My Clients': 'Meine Kunden',
    'My Coaches': 'Meine Coaches',
    'My Profile': 'Mein Profil',
    'N/A': 'N/V',
    Name: 'Name',
    'New Scans': 'Neue Körperscans',
    'New Users': 'Neue Benutzer',
    Next: 'Weiter',
    No: 'Nein',
    'No available scans for report': 'Keine Scans für den Bericht verfügbar',
    'Not Interested': 'Nicht interessiert',
    'Not Visible': 'Nicht sichtbar',
    November: 'November',
    October: 'Oktober',
    Overview: 'Übersicht',
    Overlay: 'Überlagerung',
    PARQ: 'PARQ',
    PARQs: 'PARQ-Fragebögen',
    ParQ: 'ParQ',
    'PARQ Survey': 'PARQ-Umfrage',
    'Past Scans': 'Frühere Scans',
    Password: 'Passwort',
    'Password confirmation required': 'Passwortbestätigung erforderlich',
    'Password must be at least 8 characters':
      'Das Passwort muss mindestens 8 Zeichen lang sein',
    'Passwords do not match': 'Passwörter stimmen nicht überein',
    Phone: 'Telefon',
    "Please accept Fit3D's privacy policy to continue":
      'Bitte akzeptieren Sie die Datenschutzrichtlinie von Fit3D, um fortzufahren',
    'Please accept the Terms Agreement to continue':
      'Bitte akzeptieren Sie die Nutzungsbedingungen, um fortzufahren',
    'Please complete the security check':
      'Bitte schließen Sie die Sicherheitsprüfung ab',
    'Please enter a valid age': 'Bitte geben Sie ein gültiges Alter ein',
    Posture: 'Haltung',
    'Posture Comparison': 'Haltungsvergleich',
    'Posture Report': 'Haltungsbericht',
    Previous: 'Zurück',
    Print: 'Drucken',
    Printable: 'Druckbar',
    Profile: 'Profil',
    Red: 'Rot',
    Remove: 'Entfernen',
    'Request Full Access for': 'Vollzugriff anfragen für',
    'Requesting Access...': 'Zugriff wird angefragt...',
    Report: 'Bericht',
    Reports: 'Berichte',
    Request: 'Anfragen',
    'Request Access': 'Zugriff anfragen',
    Results: 'Ergebnisse',
    'Return to All Scans': 'Zurück zu allen Scans',
    Save: 'Speichern',
    Scan: 'Scan',
    'Scan Date': 'Scan-Datum',
    'Scan History': 'Scanverlauf',
    'Scan Report': 'Scan-Bericht',
    Scans: 'Körperscans',
    Search: 'Suchen',
    Select: 'Auswählen',
    '-- Select Gender --': '-- Geschlecht auswählen --',
    '-- Select Units --': '-- Einheiten auswählen --',
    September: 'September',
    Shoulder: 'Schulter',
    Shoulders: 'Schultern',
    'Show Full Scans': 'Vollständige Scans anzeigen',
    'Show Silhouettes': 'Silhouetten anzeigen',
    'Sign Out': 'Abmelden',
    Status: 'Status',
    Submit: 'Senden',
    Success: 'Erfolg',
    'Success Hub': 'Success Hub',
    Summary: 'Zusammenfassung',
    Tilt: 'Neigung',
    Time: 'Zeit',
    'Top Users': 'Top-Benutzer',
    Torso: 'Oberkörper',
    Trends: 'Trends',
    'Trunk Leg Vol Ratio': 'Rumpf-Bein-Volumenverhältnis',
    'Trunk to Leg Volume Ratio': 'Rumpf-Bein-Volumenverhältnis',
    'Unit type required': 'Einheitentyp erforderlich',
    'US (lb/inches)': 'US (lb/Zoll)',
    'Update Metrics': 'Metriken aktualisieren',
    'Updating...': 'Aktualisierung...',
    'Usage Dashboard': 'Nutzungsübersicht',
    Users: 'Benutzer',
    Value: 'Wert',
    'Very Active': 'Sehr aktiv',
    'Very Motivated': 'Sehr motiviert',
    'VAT Mass': 'VAT-Masse',
    View: 'Anzeigen',
    'View 3D Scan': '3D-Scan anzeigen',
    'View History': 'Verlauf anzeigen',
    'View Posture Comparison': 'Haltungsvergleich anzeigen',
    'View Scan Report': 'Scan-Bericht anzeigen',
    'View Waist Circumference Data': 'Taillenumfangsdaten anzeigen',
    'View Waist to Hip Ratio Data': 'Taille-Hüfte-Verhältnis-Daten anzeigen',
    'View Weight Trend': 'Gewichtstrend anzeigen',
    Visible: 'Sichtbar',
    Waist: 'Taille',
    'Waist Circumference': 'Taillenumfang',
    'Waist Data': 'Taillendaten',
    'Waist Hip Ratio': 'Taille-Hüfte-Verhältnis',
    'Waist to Hip Ratio': 'Taille-Hüfte-Verhältnis',
    Weight: 'Gewicht',
    'Weight / Height': 'Gewicht / Größe',
    Wellness: 'Wellness',
    'Wellness Comparison': 'Wellness-Vergleich',
    'Wellness Glossary': 'Wellness-Glossar',
    'Wellness Metric': 'Wellness-Metrik',
    'Wellness Metric Comparisons': 'Wellness-Metrikvergleiche',
    'Wellness Metrics': 'Wellness-Metriken',
    'What is Posture?': 'Was ist Haltung?',
    'What is it?': 'Was ist das?',
    'What is this?': 'Was ist das?',
    'WHO CAN ENTER:': 'WER TEILNEHMEN KANN:',
    Win: 'Gewinn',
    'Win Rate': 'Gewinnrate',
    'WINNERS:': 'GEWINNER:',
    Wins: 'Gewinne',
    Yellow: 'Gelb',
    Yes: 'Ja',
    Year: 'Jahr',
    'Your Average': 'Ihr Durchschnitt',
    'Your Dashboard': 'Ihr Dashboard',
    "Your Clients' Completed Scans": 'Abgeschlossene Scans Ihrer Kunden',
    'Your Facility': 'Ihre Einrichtung',
    'Your Fit3D Body Shape Rating': 'Ihre Fit3D-Körperformbewertung',
    'Your measurement trends': 'Ihre Messtrends',
    'Your Reports': 'Ihre Berichte',
    'Your Scan History': 'Ihr Scanverlauf',
    'Your Scans': 'Ihre Scans',
    'Your Wellness Page': 'Ihre Wellness-Seite',
    'Your Wellness Report': 'Ihr Wellness-Bericht',
    here: 'hier',
    'Click here': 'Hier klicken',
    'click here': 'hier klicken',
    "'s PARQ Survey": ' PARQ-Umfrage',
    "'s Scan": ' Scan',
    "'s Scan History": ' Scanverlauf',
    'Age is required': 'Alter ist erforderlich',
    'Age must be a whole number': 'Alter muss eine ganze Zahl sein',
    'Gender is required': 'Geschlecht ist erforderlich',
    'Must be at least 16 years old': 'Muss mindestens 16 Jahre alt sein',
    'to return home.': 'um zur Startseite zurückzukehren.',
    "to return to all clients' records page.":
      'um zur Datensatzseite aller Kunden zurückzukehren.',
    'to return to the posture page.': 'um zur Haltungsseite zurückzukehren.',
    'to return to the wellness page': 'um zur Wellness-Seite zurückzukehren.',
    'to return to your dashboard.': 'um zu Ihrem Dashboard zurückzukehren.',
    'to view scans.': 'um Scans anzuzeigen.',
    'to view your scans.': 'um Ihre Scans anzuzeigen.',
    'No data available': 'Keine Daten verfügbar',
    'No scans available': 'Keine Scans verfügbar',
    'No Scans Available': 'Keine Scans verfügbar',
    'There are no metrics associated with this scan':
      'Mit diesem Scan sind keine Metriken verknüpft',
    'Unavailable for this facility': 'Für diese Einrichtung nicht verfügbar',
    'Unable to retrieve information.':
      'Informationen konnten nicht abgerufen werden.',
    'Unable to get retrieve information.':
      'Informationen konnten nicht abgerufen werden.',
    'Update successful!': 'Aktualisierung erfolgreich!',
    'Value required': 'Wert erforderlich',
    'Use the form below to edit height and weight.':
      'Verwenden Sie das Formular unten, um Größe und Gewicht zu bearbeiten.',
    'View most recent scans at your facility - OR - search to filter by email/name.':
      'Zeigen Sie die neuesten Scans Ihrer Einrichtung an oder suchen Sie nach E-Mail/Name.',
    "We'll never share your email with anyone else.":
      'Wir geben Ihre E-Mail niemals an Dritte weiter.',
    'You have already requested access for this client. Your last request was sent on':
      'Sie haben bereits Zugriff für diesen Kunden angefragt. Ihre letzte Anfrage wurde gesendet am',
    'You may send one request to a client every 30 minutes.':
      'Sie können alle 30 Minuten eine Anfrage an einen Kunden senden.',
    'Your account has been created successfully. Log in to get started.':
      'Ihr Konto wurde erfolgreich erstellt. Melden Sie sich an, um loszulegen.',
    'minutes before trying again.': 'Minuten, bevor Sie es erneut versuchen.',
    years: 'Jahre',
  },
}

const supplementalPhraseTranslations = {
  fr: {
    'Account Settings': 'Paramètres du compte',
    'Active Users': 'Utilisateurs actifs',
    'Age is required': "L'âge est obligatoire",
    Click: 'Cliquez',
    'Coach Activity': 'Activité des coachs',
    'Coach Activity Leaders': "Leaders d'activité des coachs",
    'Coach Leaders (All Time)': 'Leaders coachs (total)',
    'Coach Leaders (Current Month)': 'Leaders coachs (mois en cours)',
    'Coaches are ranked based on their ParQs completed and Wins (potential clients they have marked as interested).':
      'Les coachs sont classés selon leurs ParQs complétés et leurs gains (clients potentiels marqués comme intéressés).',
    Additional: 'Supplémentaire',
    'Body Composition': 'Composition corporelle',
    'Body Fat Percentage': 'Pourcentage de graisse corporelle',
    'Body Shape': 'Forme corporelle',
    'Body Shape Rating': 'Note de forme corporelle',
    Bust: 'Buste',
    Chest: 'Poitrine',
    'Click a scan on the left to view more information!':
      'Cliquez sur un scan à gauche pour voir plus d’informations !',
    'Click on a scan panel to change reports!':
      'Cliquez sur un panneau de scan pour changer de rapport !',
    Capturing: 'Capture en cours',
    'Date Taken:': 'Date de prise :',
    'Demo Location Guide': 'Guide des emplacements de mesure',
    Delete: 'Supprimer',
    'Download Measurements': 'Télécharger les mesures',
    'Download Scan Gif': 'Télécharger le GIF du scan',
    'Download Scan Obj': 'Télécharger l’OBJ du scan',
    'Fat Mass': 'Masse grasse',
    Height: 'Taille',
    Hide: 'Masquer',
    'Hide Scan In Report': 'Masquer le scan dans le rapport',
    Hips: 'Hanches',
    Incomplete: 'Incomplet',
    Inches: 'pouces',
    'Lean Mass': 'Masse maigre',
    'Left Biceps': 'Biceps gauche',
    'Left Calf': 'Mollet gauche',
    'Left Forearm': 'Avant-bras gauche',
    'Left Thigh': 'Cuisse gauche',
    Maybe: 'Peut-être',
    Measurement: 'Mesure',
    Measurements: 'Mesures',
    'Metabolic Age': 'Âge métabolique',
    Metrics: 'Métriques',
    Name: 'Nom',
    Month: 'Mois',
    Neck: 'Cou',
    'New Scans': 'Nouveaux scans',
    'New Users': 'Nouveaux utilisateurs',
    'No available scans for report': 'Aucun scan disponible pour le rapport',
    'No data available': 'Aucune donnée disponible',
    'No scans available': 'Aucun scan disponible',
    ParQ: 'ParQ',
    PARQs: 'PARQs',
    Posture: 'Posture',
    'Posture Status': 'Statut de posture',
    'Posture Status:': 'Statut de posture :',
    'Posture processing is in progress':
      'Le traitement de la posture est en cours',
    'POSTURE PROCESSING IS IN PROGRESS':
      'LE TRAITEMENT DE LA POSTURE EST EN COURS',
    'Right Biceps': 'Biceps droit',
    'Right Calf': 'Mollet droit',
    'Right Forearm': 'Avant-bras droit',
    'Right Thigh': 'Cuisse droite',
    Scans: 'Scans',
    'SCAN INFO': 'INFORMATIONS DU SCAN',
    'Scan In Report': 'le scan dans le rapport',
    'Scan History': 'Historique des scans',
    'Scan Info': 'Informations du scan',
    Show: 'Afficher',
    'Show Scan In Report': 'Afficher le scan dans le rapport',
    Status: 'Statut',
    'Status:': 'Statut :',
    'Success Hub': 'Success Hub',
    Summary: 'Résumé',
    'Usage Dashboard': "Tableau de bord d'utilisation",
    'Unable to retrieve information.':
      'Impossible de récupérer les informations.',
    Value: 'Valeur',
    'VAT Mass': 'Masse de graisse viscérale',
    'View 3D Scan': 'Voir le scan 3D',
    'View History': "Voir l'historique",
    'View Scan Report': 'Voir le rapport de scan',
    '(Inches)': '(pouces)',
    'Value (Inches)': 'Valeur (pouces)',
    'Value Inches': 'Valeur en pouces',
    Visible: 'Visible',
    Waist: 'Taille',
    'Waist Circumference': 'Tour de taille',
    'Waist to Hip Ratio': 'Rapport taille-hanches',
    Weight: 'Poids',
    'What is this?': "Qu'est-ce que c'est ?",
    Win: 'Gain',
    'Win Rate': 'Taux de gain',
    Wins: 'Gains',
    'Your Scans': 'Vos scans',
    'Your Scan History': 'Votre historique de scans',
    'Your Wellness Report': 'Votre rapport de bien-être',
    here: 'ici',
    '* Note: The sample image is only used to display measurement locations and body parts. The table on the right displays your measurements.':
      "* Remarque : l'image d'exemple sert uniquement à afficher les emplacements de mesure et les parties du corps. Le tableau à droite affiche vos mesures.",
    'to return to your dashboard.': 'pour revenir à votre tableau de bord.',
  },
  es: {
    'Account Settings': 'Configuración de la cuenta',
    'Active Users': 'Usuarios activos',
    Access: 'Acceso',
    'Access Level': 'Nivel de acceso',
    'Account Created!': 'Cuenta creada.',
    Active: 'Activo',
    'Add Coaches': 'Añadir entrenadores',
    'Add Metric': 'Añadir métrica',
    'Add/Edit Additional Metrics': 'Añadir/editar métricas adicionales',
    'Add/Edit Metric(s)': 'Añadir/editar métrica(s)',
    Additional: 'Adicional',
    'Additional Info': 'Información adicional',
    'Additional Metrics': 'Métricas adicionales',
    'Additional Torso': 'Torso adicional',
    Actions: 'Acciones',
    Age: 'Edad',
    'Age is required': 'La edad es obligatoria',
    Allergies: 'Alergias',
    'Already have an account?': '¿Ya tienes una cuenta?',
    Always: 'Siempre',
    'American Indian or Alaska Native': 'Indígena americano o nativo de Alaska',
    Answer: 'Respuesta',
    Anxiety: 'Ansiedad',
    April: 'Abril',
    Arms: 'Brazos',
    'Are you sure you want to': '¿Seguro que quieres',
    Asian: 'Asiático',
    'Assessment Snapshots': 'Instantáneas de evaluación',
    Asthma: 'Asma',
    August: 'Agosto',
    Back: 'Atrás',
    'Basal Metabolic Rate (BMR)': 'Tasa metabólica basal (BMR)',
    Baseline: 'Referencia',
    'Biceps (L)': 'Bíceps (izq.)',
    'Biceps (R)': 'Bíceps (der.)',
    Birthdate: 'Fecha de nacimiento',
    'Black or African American': 'Negro o afroamericano',
    'Body Comp Access Unavailable':
      'Acceso a composición corporal no disponible',
    'Body Composition': 'Composición corporal',
    'Body Fat Percent': 'Porcentaje de grasa corporal',
    'Body Fat Percentage': 'Porcentaje de grasa corporal',
    'BODY FAT PERCENTAGE': 'PORCENTAJE DE GRASA CORPORAL',
    'Body Shape': 'Forma corporal',
    'Body Shape Rating': 'Calificación de forma corporal',
    'Body Shape Rating Percentile':
      'Percentil de calificación de forma corporal',
    "Body weight is a person's mass or weight.":
      'El peso corporal es la masa o el peso de una persona.',
    'Body weight is a person’s mass or weight.':
      'El peso corporal es la masa o el peso de una persona.',
    'Bodyshape Rating': 'Calificación de forma corporal',
    'Browse Marketplace': 'Explorar marketplace',
    Bust: 'Busto',
    Caucasian: 'Caucásico',
    Cancel: 'Cancelar',
    'Change E-mail': 'Cambiar correo electrónico',
    'Change Password': 'Cambiar contraseña',
    Chest: 'Pecho',
    Click: 'Haz clic',
    'Click a scan on the left to view more information!':
      'Haz clic en un escaneo a la izquierda para ver más información.',
    'Click on a scan panel to change reports!':
      'Haz clic en un panel de escaneo para cambiar de informe.',
    'Click to Close': 'Haz clic para cerrar',
    'Click to Enlarge Chart': 'Haz clic para ampliar el gráfico',
    'Click to Show Instructions': 'Haz clic para mostrar instrucciones',
    'Client Comparison': 'Comparación del cliente',
    'Client Comparison Page': 'Página de comparación del cliente',
    'Client PARQ Survey is unavailable':
      'La encuesta PARQ del cliente no está disponible',
    'Client Report': 'Informe del cliente',
    'Client Scan Report is not available':
      'El informe de escaneo del cliente no está disponible',
    'Client Scan History': 'Historial de escaneos del cliente',
    Close: 'Cerrar',
    'Coach Activity': 'Actividad de entrenadores',
    'Coach Activity Leaders': 'Líderes de actividad de entrenadores',
    'Coach Access Level': 'Nivel de acceso del entrenador',
    'Coach Leaders (All Time)': 'Líderes de entrenadores (total)',
    'Coach Leaders (Current Month)': 'Líderes de entrenadores (mes actual)',
    'Coaches are ranked based on their ParQs completed and Wins (potential clients they have marked as interested).':
      'Los entrenadores se clasifican según sus ParQs completados y sus ganancias (clientes potenciales marcados como interesados).',
    'Comparison Report': 'Informe de comparación',
    'Confirm Access': 'Confirmar acceso',
    'Confirm Access Removal': 'Confirmar eliminación de acceso',
    'Confirm New Email': 'Confirmar nuevo correo electrónico',
    'Confirm New Password': 'Confirmar nueva contraseña',
    'Confirm Password': 'Confirmar contraseña',
    'Confirm Remove Access': 'Confirmar eliminación de acceso',
    'Confirm Request': 'Confirmar solicitud',
    Confirm: 'Confirmar',
    Constipation: 'Estreñimiento',
    'Create a Fit3D Account': 'Crear una cuenta Fit3D',
    'Create Account': 'Crear cuenta',
    Current: 'Actual',
    'Current Password': 'Contraseña actual',
    'Customize your 3D print with Sculpteo':
      'Personaliza tu impresión 3D con Sculpteo',
    'Date (YYYY-MM-DD)': 'Fecha (AAAA-MM-DD)',
    'Date Scan Taken': 'Fecha del escaneo',
    'Date Taken:': 'Fecha tomada:',
    Day: 'Día',
    'Days since last scan': 'Días desde el último escaneo',
    December: 'Diciembre',
    Delete: 'Eliminar',
    'Demo Location Guide': 'Guía de ubicación de demostración',
    'Demo Location Guide (Sample Image)*':
      'Guía de ubicación de demostración (imagen de muestra)*',
    Depression: 'Depresión',
    'Description:': 'Descripción:',
    Diarrhea: 'Diarrea',
    Diff: 'Diferencia',
    Difference: 'Diferencia',
    'Difficulty Losing Weight': 'Dificultad para perder peso',
    Distribution: 'Distribución',
    Dizziness: 'Mareos',
    Download: 'Descargar',
    'Download Report': 'Descargar informe',
    'Download Scan': 'Descargar escaneo',
    'Download Scan (GIF)': 'Descargar escaneo (GIF)',
    'Download Scan (OBJ)': 'Descargar escaneo (OBJ)',
    'Download Scan Gif': 'Descargar GIF del escaneo',
    'Download Scan Obj': 'Descargar OBJ del escaneo',
    'E-mail': 'Correo electrónico',
    'Edit Email': 'Editar correo electrónico',
    'Edit Height & Weight': 'Editar estatura y peso',
    'Edit PARQ Survey': 'Editar encuesta PARQ',
    'Edit Password': 'Editar contraseña',
    'Edit Profile': 'Editar perfil',
    Elbow: 'Codo',
    'Error: Not Found': 'Error: no encontrado',
    Ethnicity: 'Etnicidad',
    'Failed to request client access. Please contact support or try again.':
      'No se pudo solicitar acceso al cliente. Contacta con soporte o inténtalo de nuevo.',
    'Failure to remove coach. Please try again or contact support.':
      'No se pudo eliminar el entrenador. Inténtalo de nuevo o contacta con soporte.',
    'Failure to update coach access level. Please try again or contact support.':
      'No se pudo actualizar el nivel de acceso del entrenador. Inténtalo de nuevo o contacta con soporte.',
    'Fat Mass': 'Masa grasa',
    'FAT MASS': 'MASA GRASA',
    Fatigue: 'Fatiga',
    February: 'Febrero',
    Female: 'Femenino',
    First: 'Primero',
    'First Name': 'Nombre',
    'Fitness Information': 'Información de fitness',
    'Fitness Level': 'Nivel de fitness',
    'Foot/Ankle': 'Pie/tobillo',
    Front: 'Frente',
    'Front/Back': 'Frente/espalda',
    'Full Access': 'Acceso completo',
    'Gain Weight Easily': 'Aumento de peso fácil',
    Gender: 'Género',
    Give: 'Dar',
    'Give your coach access to your Fit3D data':
      'Da acceso a tu entrenador a tus datos de Fit3D',
    'Go to Report': 'Ir al informe',
    'Go to comparison page': 'Ir a la página de comparación',
    Green: 'Verde',
    Headaches: 'Dolores de cabeza',
    'Health History': 'Historial de salud',
    'Heart Trouble': 'Problemas cardíacos',
    Height: 'Estatura',
    'Height/Weight': 'Estatura/peso',
    Hide: 'Ocultar',
    'Hide Image': 'Ocultar imagen',
    'Hide Images': 'Ocultar imágenes',
    'How Can Posture Affect You?': '¿Cómo puede afectarte la postura?',
    'How do I compare to other Fit3D users?':
      '¿Cómo me comparo con otros usuarios de Fit3D?',
    'How do I compare?': '¿Cómo me comparo?',
    'How do I improve my score?': '¿Cómo mejoro mi puntuación?',
    'How does your': '¿Cómo se compara tu',
    'I have read and accepted Fit3D’s':
      'He leído y acepto los términos de Fit3D',
    "I have read and accepted Fit3D's":
      'He leído y acepto los términos de Fit3D',
    Inches: 'Pulgadas',
    Indigestion: 'Indigestión',
    Insomnia: 'Insomnio',
    'Interest Level': 'Nivel de interés',
    Interested: 'Interesado',
    'Interested Later': 'Interesado más tarde',
    January: 'Enero',
    July: 'Julio',
    June: 'Junio',
    Knee: 'Rodilla',
    'Lack of Knowledge': 'Falta de conocimiento',
    Last: 'Último',
    'Last Name': 'Apellido',
    'Last scan attempt status:': 'Estado del último intento de escaneo:',
    'Last scan taken date': 'Fecha del último escaneo',
    'Leaving a field blank when submitting will not update the metric.':
      'Dejar un campo en blanco al enviar no actualizará la métrica.',
    Limited: 'Limitado',
    'Limited Access': 'Acceso limitado',
    Location: 'Ubicación',
    'Log In Now': 'Iniciar sesión ahora',
    'Log in': 'Iniciar sesión',
    'Manage Profile': 'Gestionar perfil',
    March: 'Marzo',
    May: 'Mayo',
    Measurement: 'Medición',
    'Measurement Comparison': 'Comparación de mediciones',
    'Measurement Comparisons': 'Comparaciones de mediciones',
    'Measurement Name': 'Nombre de la medición',
    'Measurements & Comparison': 'Mediciones y comparación',
    'Metric Name': 'Nombre de la métrica',
    Metric: 'Métrica',
    Metrics: 'Métricas',
    'Metric/SI (cm/kg)': 'Métrico/SI (cm/kg)',
    'Mid Back': 'Espalda media',
    Moderate: 'Moderado',
    Money: 'Dinero',
    'More Actions': 'Más acciones',
    Name: 'Nombre',
    'Native Hawaiian or Other Pacific Islander':
      'Nativo hawaiano u otro isleño del Pacífico',
    Navigation: 'Navegación',
    Neck: 'Cuello',
    Never: 'Nunca',
    'New Email': 'Nuevo correo electrónico',
    'New Password': 'Nueva contraseña',
    'No 3D color model available': 'No hay modelo 3D a color disponible',
    'No 3D color model available for this scan':
      'No hay modelo 3D a color disponible para este escaneo',
    'No Access': 'Sin acceso',
    'No additional metrics activated for this facility':
      'No hay métricas adicionales activadas para este centro',
    'No additional metrics for this client':
      'No hay métricas adicionales para este cliente',
    Maybe: 'Quizás',
    Month: 'Mes',
    'New Scans': 'Nuevos escaneos',
    'New Users': 'Nuevos usuarios',
    'No available scans for report':
      'No hay escaneos disponibles para el informe',
    'No data available': 'No hay datos disponibles',
    'No scans available': 'No hay escaneos disponibles',
    'No available measurements': 'No hay mediciones disponibles',
    'No available wellness metrics': 'No hay métricas de bienestar disponibles',
    'No Facility': 'Sin centro',
    'No posture data': 'No hay datos de postura',
    'No scans available to show': 'No hay escaneos disponibles para mostrar',
    'No tilt data for side view':
      'No hay datos de inclinación para la vista lateral',
    'No video available': 'No hay video disponible',
    'No viewable scans': 'No hay escaneos visibles',
    'No visible scans': 'No hay escaneos visibles',
    'Not Interested': 'No interesado',
    'Not Motivated': 'No motivado',
    'Not Often': 'No con frecuencia',
    'Not available. Please contact your facility to learn more!':
      'No disponible. Contacta con tu centro para obtener más información.',
    'Not enough completed posture assessments':
      'No hay suficientes evaluaciones de postura completadas',
    'Not enough scans to compare (minimum 2)':
      'No hay suficientes escaneos para comparar (mínimo 2)',
    'Not enough valid or visible scans':
      'No hay suficientes escaneos válidos o visibles',
    'Not enough viewable scans (minimum 2)':
      'No hay suficientes escaneos visibles (mínimo 2)',
    'Not enough visible scans': 'No hay suficientes escaneos visibles',
    'Not enough visible scans (minimum 2)':
      'No hay suficientes escaneos visibles (mínimo 2)',
    November: 'Noviembre',
    October: 'Octubre',
    Overview: 'Resumen',
    'Overlay Comparison': 'Comparación de superposición',
    'Password (8+ characters)': 'Contraseña (8+ caracteres)',
    'Percent (%)': 'Porcentaje (%)',
    Percentile: 'Percentil',
    'Please contact support for help or more information.':
      'Contacta con soporte para obtener ayuda o más información.',
    'Please take a scan to continue': 'Realiza un escaneo para continuar',
    'Please take follow up scans to compare posture assessments. Click':
      'Realiza escaneos de seguimiento para comparar evaluaciones de postura. Haz clic',
    'Please update your scan visibility to view your wellness information! Click':
      'Actualiza la visibilidad de tu escaneo para ver tu información de bienestar. Haz clic',
    'Posture processing is in progress':
      'El procesamiento de postura está en curso',
    'Posture Status': 'Estado de postura',
    'Posture Status:': 'Estado de postura:',
    'Posture:': 'Postura:',
    'Posture Comparison': 'Comparación de postura',
    Procrastination: 'Procrastinación',
    'Profile Overview': 'Resumen del perfil',
    Question: 'Pregunta',
    'Read More': 'Leer más',
    'Read more in the Fit3D Wellness Glossary':
      'Leer más en el glosario de bienestar de Fit3D',
    'Reload Client Records': 'Recargar registros de clientes',
    'Remove Access': 'Eliminar acceso',
    'Request Client Access': 'Solicitar acceso al cliente',
    'Request Date': 'Fecha de solicitud',
    'Request Full Access': 'Solicitar acceso completo',
    'Request Full Access for': 'Solicitar acceso completo para',
    'Request/Remove Clients': 'Solicitar/eliminar clientes',
    Request: 'Solicitar',
    'Requesting Access...': 'Solicitando acceso...',
    'Restless Sleep': 'Sueño inquieto',
    'Return to All Client Records': 'Volver a todos los registros de clientes',
    'Return to All Scans': 'Volver a todos los escaneos',
    'Return to Client Records': 'Volver a registros de clientes',
    'Return to Wellness Page': 'Volver a la página de bienestar',
    'Review My Wellness': 'Revisar mi bienestar',
    Regularly: 'Regularmente',
    Remove: 'Eliminar',
    Red: 'Rojo',
    'Scan Date': 'Fecha del escaneo',
    'Scan Date:': 'Fecha del escaneo:',
    'Scan Info': 'Información del escaneo',
    'Scan Preview': 'Vista previa del escaneo',
    'Scan Status': 'Estado del escaneo',
    'Scan Status:': 'Estado del escaneo:',
    ParQ: 'ParQ',
    PARQs: 'PARQs',
    Scans: 'Escaneos',
    'Success Hub': 'Success Hub',
    Summary: 'Resumen',
    'Usage Dashboard': 'Panel de uso',
    'Unable to retrieve information.': 'No se pudo recuperar la información.',
    'View 3D Scan': 'Ver escaneo 3D',
    'View History': 'Ver historial',
    'View Scan Report': 'Ver informe de escaneo',
    'What is this?': '¿Qué es esto?',
    Win: 'Ganancia',
    'Win Rate': 'Tasa de ganancia',
    Wins: 'Ganancias',
    'Your Scans': 'Tus escaneos',
    'Your Wellness Report': 'Tu informe de bienestar',
    here: 'aquí',
    'to return to your dashboard.': 'para volver a tu panel.',
  },
  pt: {
    'Account Settings': 'Configurações da conta',
    'Active Users': 'Usuários ativos',
    'Age is required': 'A idade é obrigatória',
    Click: 'Clique',
    'Coach Activity': 'Atividade dos coaches',
    'Coach Activity Leaders': 'Líderes de atividade dos coaches',
    'Coach Leaders (All Time)': 'Líderes de coaches (total)',
    'Coach Leaders (Current Month)': 'Líderes de coaches (mês atual)',
    'Coaches are ranked based on their ParQs completed and Wins (potential clients they have marked as interested).':
      'Os coaches são classificados com base nos ParQs concluídos e nas vitórias (clientes potenciais marcados como interessados).',
    Maybe: 'Talvez',
    Month: 'Mês',
    'New Scans': 'Novos scans',
    'New Users': 'Novos usuários',
    'No available scans for report': 'Nenhum scan disponível para o relatório',
    'No data available': 'Nenhum dado disponível',
    'No scans available': 'Nenhum scan disponível',
    ParQ: 'ParQ',
    PARQs: 'PARQs',
    Scans: 'Scans',
    'Success Hub': 'Success Hub',
    Summary: 'Resumo',
    'Usage Dashboard': 'Painel de uso',
    'Unable to retrieve information.':
      'Não foi possível recuperar as informações.',
    'View 3D Scan': 'Ver scan 3D',
    'View History': 'Ver histórico',
    'View Scan Report': 'Ver relatório do scan',
    'What is this?': 'O que é isto?',
    Win: 'Vitória',
    'Win Rate': 'Taxa de vitórias',
    Wins: 'Vitórias',
    'Your Scans': 'Seus escaneamentos',
    'Your Wellness Report': 'Seu relatório de bem-estar',
    here: 'aqui',
    'to return to your dashboard.': 'para voltar ao seu painel.',
  },
  zh_CN: {
    'Account Settings': '账户设置',
    'Active Users': '活跃用户',
    'Age is required': '年龄为必填项',
    Click: '点击',
    'Coach Activity': '教练活动',
    'Coach Activity Leaders': '教练活动排行榜',
    'Coach Leaders (All Time)': '教练排行榜（全部时间）',
    'Coach Leaders (Current Month)': '教练排行榜（本月）',
    'Coaches are ranked based on their ParQs completed and Wins (potential clients they have marked as interested).':
      '教练根据已完成的 ParQ 和赢单数排名（他们标记为感兴趣的潜在客户）。',
    Maybe: '也许',
    Month: '月份',
    'New Scans': '新扫描',
    'New Users': '新用户',
    'No available scans for report': '没有可用于报告的扫描',
    'No data available': '暂无数据',
    'No scans available': '没有可用扫描',
    ParQ: 'ParQ',
    PARQs: 'PARQs',
    Scans: '扫描',
    'Success Hub': 'Success Hub',
    Summary: '摘要',
    'Usage Dashboard': '使用情况仪表板',
    'Unable to retrieve information.': '无法检索信息。',
    'View 3D Scan': '查看 3D 扫描',
    'View History': '查看历史',
    'View Scan Report': '查看扫描报告',
    'What is this?': '这是什么？',
    Win: '赢单',
    'Win Rate': '赢单率',
    Wins: '赢单',
    'Your Scans': '您的扫描',
    'Your Wellness Report': '您的健康报告',
    here: '此处',
    'to return to your dashboard.': '返回您的仪表板。',
  },
  zh_TW: {
    'Account Settings': '帳戶設定',
    'Active Users': '活躍使用者',
    'Age is required': '年齡為必填項',
    Click: '點擊',
    'Coach Activity': '教練活動',
    'Coach Activity Leaders': '教練活動排行榜',
    'Coach Leaders (All Time)': '教練排行榜（全部時間）',
    'Coach Leaders (Current Month)': '教練排行榜（本月）',
    'Coaches are ranked based on their ParQs completed and Wins (potential clients they have marked as interested).':
      '教練依已完成的 ParQ 和成功數排名（他們標記為有興趣的潛在客戶）。',
    Maybe: '也許',
    Month: '月份',
    'New Scans': '新掃描',
    'New Users': '新使用者',
    'No available scans for report': '沒有可用於報告的掃描',
    'No data available': '沒有可用資料',
    'No scans available': '沒有可用掃描',
    ParQ: 'ParQ',
    PARQs: 'PARQs',
    Scans: '掃描',
    'Success Hub': 'Success Hub',
    Summary: '摘要',
    'Usage Dashboard': '使用情況儀表板',
    'Unable to retrieve information.': '無法擷取資訊。',
    'View 3D Scan': '查看 3D 掃描',
    'View History': '查看歷史',
    'View Scan Report': '查看掃描報告',
    'What is this?': '這是什麼？',
    Win: '成功',
    'Win Rate': '成功率',
    Wins: '成功',
    'Your Scans': '您的掃描',
    'Your Wellness Report': '您的健康報告',
    here: '這裡',
    'to return to your dashboard.': '返回您的儀表板。',
  },
  it: {
    'Account Settings': 'Impostazioni account',
    'Age is required': "L'età è obbligatoria",
    'Client Scans': 'Scansioni clienti',
    Click: 'Fai clic',
    'Coach Activity': 'Attività dei coach',
    'Coach Activity Leaders': 'Leader attività coach',
    'Coach Leaders (All Time)': 'Leader coach (totale)',
    'Coach Leaders (Current Month)': 'Leader coach (mese corrente)',
    'Coaches are ranked based on their ParQs completed and Wins (potential clients they have marked as interested).':
      'I coach sono classificati in base ai ParQ completati e alle vittorie (potenziali clienti segnati come interessati).',
    Dashboard: 'Pannello',
    'Demo Comparison': 'Confronto demo',
    'Demo Report': 'Rapporto demo',
    'Download Measurements': 'Scarica misure',
    'Download Report': 'Scarica rapporto',
    'Manage Coaches': 'Gestisci allenatori',
    Maybe: 'Forse',
    Month: 'Mese',
    'New Scans': 'Nuove scansioni',
    'New Users': 'Nuovi utenti',
    'No available scans for report':
      'Nessuna scansione disponibile per il rapporto',
    'No data available': 'Nessun dato disponibile',
    'No scans available': 'Nessuna scansione disponibile',
    ParQ: 'ParQ',
    PARQs: 'PARQs',
    'Scan History': 'Cronologia scansioni',
    'Success Hub': 'Success Hub',
    'Unable to retrieve information.':
      'Impossibile recuperare le informazioni.',
    'Read More': 'Leggi di più',
    'Scan Info': 'Info scansione',
    'Show Full Scans': 'Mostra scansioni complete',
    'Show Silhouettes': 'Mostra sagome',
    'Waist Circumference': 'Circonferenza vita',
    'Waist to Hip Ratio': 'Rapporto vita-fianchi',
    'View 3D Scan': 'Visualizza scansione 3D',
    'View History': 'Visualizza cronologia',
    'View Scan Report': 'Visualizza rapporto scansione',
    'Your Scans': 'Le tue scansioni',
    'Your Wellness Report': 'Il tuo rapporto benessere',
    'Your Metabolic Age': 'La tua età metabolica',
    here: 'qui',
    'to return to your dashboard.': 'per tornare alla dashboard.',
    years: 'anni',
  },
  ko: {
    'Account Settings': '계정 설정',
    'Active Users': '활성 사용자',
    'Age is required': '나이는 필수입니다',
    Click: '클릭',
    'Coach Activity': '코치 활동',
    'Coach Activity Leaders': '코치 활동 리더',
    'Coach Leaders (All Time)': '코치 리더(전체)',
    'Coach Leaders (Current Month)': '코치 리더(이번 달)',
    'Coaches are ranked based on their ParQs completed and Wins (potential clients they have marked as interested).':
      '코치는 완료한 ParQ와 성공 수(관심 있음으로 표시한 잠재 고객)를 기준으로 순위가 매겨집니다.',
    Maybe: '보류',
    Month: '월',
    'New Scans': '새 스캔',
    'New Users': '새 사용자',
    'No available scans for report': '보고서에 사용할 수 있는 스캔이 없습니다',
    'No data available': '사용 가능한 데이터가 없습니다',
    'No scans available': '사용 가능한 스캔이 없습니다',
    ParQ: 'ParQ',
    PARQs: 'PARQs',
    Scans: '스캔',
    'Success Hub': 'Success Hub',
    Summary: '요약',
    'Usage Dashboard': '사용 현황 대시보드',
    'Unable to retrieve information.': '정보를 가져올 수 없습니다.',
    'View 3D Scan': '3D 스캔 보기',
    'View History': '기록 보기',
    'View Scan Report': '스캔 보고서 보기',
    'What is this?': '이것은 무엇인가요?',
    Win: '성공',
    'Win Rate': '성공률',
    Wins: '성공',
    'Your Scans': '내 스캔',
    'Your Wellness Report': '내 웰니스 보고서',
    here: '여기',
    'to return to your dashboard.': '대시보드로 돌아가세요.',
  },
  nl: {
    'Account Settings': 'Accountinstellingen',
    'Active Users': 'Actieve gebruikers',
    'Age is required': 'Leeftijd is verplicht',
    Click: 'Klik',
    'Coach Activity': 'Coachactiviteit',
    'Coach Activity Leaders': 'Leiders coachactiviteit',
    'Coach Leaders (All Time)': 'Coachleiders (totaal)',
    'Coach Leaders (Current Month)': 'Coachleiders (huidige maand)',
    'Coaches are ranked based on their ParQs completed and Wins (potential clients they have marked as interested).':
      'Coaches worden gerangschikt op voltooide ParQ’s en wins (potentiële klanten die zij als geïnteresseerd hebben gemarkeerd).',
    Maybe: 'Misschien',
    Month: 'Maand',
    'New Scans': 'Nieuwe scans',
    'New Users': 'Nieuwe gebruikers',
    'No available scans for report': 'Geen scans beschikbaar voor rapport',
    'No data available': 'Geen gegevens beschikbaar',
    'No scans available': 'Geen scans beschikbaar',
    ParQ: 'ParQ',
    PARQs: 'PARQs',
    Scans: 'Scans',
    'Success Hub': 'Success Hub',
    Summary: 'Samenvatting',
    'Usage Dashboard': 'Gebruiksdashboard',
    'Unable to retrieve information.': 'Kan informatie niet ophalen.',
    'View 3D Scan': '3D-scan bekijken',
    'View History': 'Geschiedenis bekijken',
    'View Scan Report': 'Scanrapport bekijken',
    'What is this?': 'Wat is dit?',
    Win: 'Win',
    'Win Rate': 'Winpercentage',
    Wins: 'Wins',
    'Your Scans': 'Uw scans',
    'Your Wellness Report': 'Uw wellnessrapport',
    here: 'hier',
    'to return to your dashboard.': 'om terug te keren naar uw dashboard.',
  },
  fi: {
    'Account Settings': 'Tilin asetukset',
    'Active Users': 'Aktiiviset käyttäjät',
    'Age is required': 'Ikä on pakollinen',
    Click: 'Napsauta',
    'Coach Activity': 'Valmentajien aktiivisuus',
    'Coach Activity Leaders': 'Valmentaja-aktiivisuuden kärki',
    'Coach Leaders (All Time)': 'Valmentajajohtajat (kaikki ajat)',
    'Coach Leaders (Current Month)': 'Valmentajajohtajat (kuluva kuukausi)',
    'Coaches are ranked based on their ParQs completed and Wins (potential clients they have marked as interested).':
      'Valmentajat järjestetään valmiiden ParQ-lomakkeiden ja voittojen perusteella (potentiaaliset asiakkaat, jotka he ovat merkinneet kiinnostuneiksi).',
    Maybe: 'Ehkä',
    Month: 'Kuukausi',
    'New Scans': 'Uudet skannaukset',
    'New Users': 'Uudet käyttäjät',
    'No available scans for report':
      'Raporttia varten ei ole skannauksia saatavilla',
    'No data available': 'Tietoja ei saatavilla',
    'No scans available': 'Skannauksia ei saatavilla',
    ParQ: 'ParQ',
    PARQs: 'PARQt',
    Scans: 'Skannaukset',
    'Success Hub': 'Success Hub',
    Summary: 'Yhteenveto',
    'Usage Dashboard': 'Käytön hallintapaneeli',
    'Unable to retrieve information.': 'Tietoja ei voitu noutaa.',
    'View 3D Scan': 'Näytä 3D-skannaus',
    'View History': 'Näytä historia',
    'View Scan Report': 'Näytä skannausraportti',
    'What is this?': 'Mikä tämä on?',
    Win: 'Voitto',
    'Win Rate': 'Voittoprosentti',
    Wins: 'Voitot',
    'Your Scans': 'Skannauksesi',
    'Your Wellness Report': 'Hyvinvointiraporttisi',
    here: 'tästä',
    'to return to your dashboard.': 'palataksesi hallintapaneeliisi.',
  },
  ru: {
    'Account Settings': 'Настройки аккаунта',
    'Active Users': 'Активные пользователи',
    'Age is required': 'Возраст обязателен',
    Click: 'Нажмите',
    'Coach Activity': 'Активность тренеров',
    'Coach Activity Leaders': 'Лидеры активности тренеров',
    'Coach Leaders (All Time)': 'Лидеры тренеров (за все время)',
    'Coach Leaders (Current Month)': 'Лидеры тренеров (текущий месяц)',
    'Coaches are ranked based on their ParQs completed and Wins (potential clients they have marked as interested).':
      'Тренеры ранжируются по заполненным ParQ и победам (потенциальным клиентам, которых они отметили как заинтересованных).',
    Maybe: 'Возможно',
    Month: 'Месяц',
    'New Scans': 'Новые сканы',
    'New Users': 'Новые пользователи',
    'No available scans for report': 'Нет доступных сканов для отчета',
    'No data available': 'Нет доступных данных',
    'No scans available': 'Нет доступных сканов',
    ParQ: 'ParQ',
    PARQs: 'PARQs',
    Scans: 'Сканы',
    'Success Hub': 'Success Hub',
    Summary: 'Сводка',
    'Usage Dashboard': 'Панель использования',
    'Unable to retrieve information.': 'Не удалось получить информацию.',
    'View 3D Scan': 'Просмотреть 3D-скан',
    'View History': 'Просмотреть историю',
    'View Scan Report': 'Просмотреть отчет скана',
    'What is this?': 'Что это?',
    Win: 'Победа',
    'Win Rate': 'Процент побед',
    Wins: 'Победы',
    'Your Scans': 'Ваши сканы',
    'Your Wellness Report': 'Ваш отчет о здоровье',
    here: 'здесь',
    'to return to your dashboard.': 'чтобы вернуться на панель управления.',
  },
  sv: {
    'Account Settings': 'Kontoinställningar',
    'Active Users': 'Aktiva användare',
    'Age is required': 'Ålder krävs',
    Click: 'Klicka',
    'Coach Activity': 'Coachaktivitet',
    'Coach Activity Leaders': 'Ledare för coachaktivitet',
    'Coach Leaders (All Time)': 'Coachledare (alla tider)',
    'Coach Leaders (Current Month)': 'Coachledare (aktuell månad)',
    'Coaches are ranked based on their ParQs completed and Wins (potential clients they have marked as interested).':
      'Coacher rankas baserat på slutförda ParQ och vinster (potentiella kunder som de har markerat som intresserade).',
    Maybe: 'Kanske',
    Month: 'Månad',
    'New Scans': 'Nya skanningar',
    'New Users': 'Nya användare',
    'No available scans for report':
      'Inga skanningar tillgängliga för rapporten',
    'No data available': 'Inga data tillgängliga',
    'No scans available': 'Inga skanningar tillgängliga',
    ParQ: 'ParQ',
    PARQs: 'PARQs',
    Scans: 'Skanningar',
    'Success Hub': 'Success Hub',
    Summary: 'Sammanfattning',
    'Usage Dashboard': 'Användningspanel',
    'Unable to retrieve information.': 'Det gick inte att hämta information.',
    'View 3D Scan': 'Visa 3D-skanning',
    'View History': 'Visa historik',
    'View Scan Report': 'Visa skanningsrapport',
    'What is this?': 'Vad är detta?',
    Win: 'Vinst',
    'Win Rate': 'Vinstfrekvens',
    Wins: 'Vinster',
    'Your Scans': 'Dina skanningar',
    'Your Wellness Report': 'Din wellnessrapport',
    here: 'här',
    'to return to your dashboard.': 'för att återgå till din instrumentpanel.',
  },
  ja: {
    'Account Settings': 'アカウント設定',
    'Active Users': 'アクティブユーザー',
    'Age is required': '年齢は必須です',
    Click: 'クリック',
    'Coach Activity': 'コーチ活動',
    'Coach Activity Leaders': 'コーチ活動リーダー',
    'Coach Leaders (All Time)': 'コーチリーダー（全期間）',
    'Coach Leaders (Current Month)': 'コーチリーダー（今月）',
    'Coaches are ranked based on their ParQs completed and Wins (potential clients they have marked as interested).':
      'コーチは完了した ParQ と勝利数（興味ありとしてマークした見込み顧客）に基づいてランク付けされます。',
    Maybe: '未定',
    Month: '月',
    'New Scans': '新しいスキャン',
    'New Users': '新規ユーザー',
    'No available scans for report': 'レポートに利用可能なスキャンがありません',
    'No data available': '利用可能なデータはありません',
    'No scans available': '利用可能なスキャンはありません',
    ParQ: 'ParQ',
    PARQs: 'PARQs',
    Scans: 'スキャン',
    'Success Hub': 'Success Hub',
    Summary: '概要',
    'Usage Dashboard': '利用状況ダッシュボード',
    'Unable to retrieve information.': '情報を取得できません。',
    'View 3D Scan': '3Dスキャンを表示',
    'View History': '履歴を表示',
    'View Scan Report': 'スキャンレポートを表示',
    'What is this?': 'これは何ですか？',
    Win: '勝利',
    'Win Rate': '勝率',
    Wins: '勝利',
    'Your Scans': 'あなたのスキャン',
    'Your Wellness Report': 'あなたのウェルネスレポート',
    here: 'こちら',
    'to return to your dashboard.': 'ダッシュボードに戻ります。',
  },
  tr: {
    'Account Settings': 'Hesap ayarları',
    'Active Users': 'Aktif kullanıcılar',
    'Age is required': 'Yaş gereklidir',
    Click: 'Tıklayın',
    'Coach Activity': 'Koç etkinliği',
    'Coach Activity Leaders': 'Koç etkinliği liderleri',
    'Coach Leaders (All Time)': 'Koç liderleri (tüm zamanlar)',
    'Coach Leaders (Current Month)': 'Koç liderleri (geçerli ay)',
    'Coaches are ranked based on their ParQs completed and Wins (potential clients they have marked as interested).':
      'Koçlar, tamamlanan ParQ’lar ve kazanımlarına göre sıralanır (ilgileniyor olarak işaretledikleri potansiyel müşteriler).',
    Maybe: 'Belki',
    Month: 'Ay',
    'New Scans': 'Yeni taramalar',
    'New Users': 'Yeni kullanıcılar',
    'No available scans for report': 'Rapor için kullanılabilir tarama yok',
    'No data available': 'Veri yok',
    'No scans available': 'Tarama yok',
    ParQ: 'ParQ',
    PARQs: 'PARQ’lar',
    Scans: 'Taramalar',
    'Success Hub': 'Success Hub',
    Summary: 'Özet',
    'Usage Dashboard': 'Kullanım paneli',
    'Unable to retrieve information.': 'Bilgiler alınamadı.',
    'View 3D Scan': '3D taramayı görüntüle',
    'View History': 'Geçmişi görüntüle',
    'View Scan Report': 'Tarama raporunu görüntüle',
    'What is this?': 'Bu nedir?',
    Win: 'Kazanım',
    'Win Rate': 'Kazanım oranı',
    Wins: 'Kazanımlar',
    'Your Scans': 'Taramalarınız',
    'Your Wellness Report': 'Wellness raporunuz',
    here: 'buraya',
    'to return to your dashboard.': 'panelinize dönmek için.',
  },
  cs: {
    'Account Settings': 'Nastavení účtu',
    'Active Users': 'Aktivní uživatelé',
    'Age is required': 'Věk je povinný',
    Click: 'Klikněte',
    'Coach Activity': 'Aktivita koučů',
    'Coach Activity Leaders': 'Lídři aktivity koučů',
    'Coach Leaders (All Time)': 'Lídři koučů (celkem)',
    'Coach Leaders (Current Month)': 'Lídři koučů (aktuální měsíc)',
    'Coaches are ranked based on their ParQs completed and Wins (potential clients they have marked as interested).':
      'Kouči jsou řazeni podle dokončených ParQ a vítězství (potenciální klienti označení jako zájemci).',
    Maybe: 'Možná',
    Month: 'Měsíc',
    'New Scans': 'Nové skeny',
    'New Users': 'Noví uživatelé',
    'No available scans for report':
      'Pro zprávu nejsou k dispozici žádné skeny',
    'No data available': 'Žádná dostupná data',
    'No scans available': 'Žádné dostupné skeny',
    ParQ: 'ParQ',
    PARQs: 'PARQ',
    Scans: 'Skeny',
    'Success Hub': 'Success Hub',
    Summary: 'Souhrn',
    'Usage Dashboard': 'Přehled používání',
    'Unable to retrieve information.': 'Informace se nepodařilo načíst.',
    'View 3D Scan': 'Zobrazit 3D sken',
    'View History': 'Zobrazit historii',
    'View Scan Report': 'Zobrazit zprávu skenu',
    'What is this?': 'Co je to?',
    Win: 'Vítězství',
    'Win Rate': 'Míra vítězství',
    Wins: 'Vítězství',
    'Your Scans': 'Vaše skeny',
    'Your Wellness Report': 'Vaše wellness zpráva',
    here: 'zde',
    'to return to your dashboard.': 'pro návrat na váš přehled.',
  },
  el: {
    'Account Settings': 'Ρυθμίσεις λογαριασμού',
    'Active Users': 'Ενεργοί χρήστες',
    'Age is required': 'Η ηλικία είναι υποχρεωτική',
    Click: 'Κάντε κλικ',
    'Coach Activity': 'Δραστηριότητα προπονητών',
    'Coach Activity Leaders': 'Κορυφαίοι δραστηριότητας προπονητών',
    'Coach Leaders (All Time)': 'Κορυφαίοι προπονητές (συνολικά)',
    'Coach Leaders (Current Month)': 'Κορυφαίοι προπονητές (τρέχων μήνας)',
    'Coaches are ranked based on their ParQs completed and Wins (potential clients they have marked as interested).':
      'Οι προπονητές κατατάσσονται βάσει των ολοκληρωμένων ParQ και των επιτυχιών (δυνητικοί πελάτες που έχουν σημειώσει ως ενδιαφερόμενους).',
    Maybe: 'Ίσως',
    Month: 'Μήνας',
    'New Scans': 'Νέες σαρώσεις',
    'New Users': 'Νέοι χρήστες',
    'No available scans for report':
      'Δεν υπάρχουν διαθέσιμες σαρώσεις για την αναφορά',
    'No data available': 'Δεν υπάρχουν διαθέσιμα δεδομένα',
    'No scans available': 'Δεν υπάρχουν διαθέσιμες σαρώσεις',
    ParQ: 'ParQ',
    PARQs: 'PARQs',
    Scans: 'Σαρώσεις',
    'Success Hub': 'Success Hub',
    Summary: 'Σύνοψη',
    'Usage Dashboard': 'Πίνακας χρήσης',
    'Unable to retrieve information.':
      'Δεν ήταν δυνατή η ανάκτηση πληροφοριών.',
    'View 3D Scan': 'Προβολή 3D σάρωσης',
    'View History': 'Προβολή ιστορικού',
    'View Scan Report': 'Προβολή αναφοράς σάρωσης',
    'What is this?': 'Τι είναι αυτό;',
    Win: 'Επιτυχία',
    'Win Rate': 'Ποσοστό επιτυχίας',
    Wins: 'Επιτυχίες',
    'Your Scans': 'Οι σαρώσεις σας',
    'Your Wellness Report': 'Η αναφορά ευεξίας σας',
    here: 'εδώ',
    'to return to your dashboard.': 'για να επιστρέψετε στον πίνακά σας.',
  },
  hr: {
    'Account Settings': 'Postavke računa',
    'Active Users': 'Aktivni korisnici',
    'Age is required': 'Dob je obavezna',
    Click: 'Kliknite',
    'Coach Activity': 'Aktivnost trenera',
    'Coach Activity Leaders': 'Voditelji aktivnosti trenera',
    'Coach Leaders (All Time)': 'Voditelji trenera (ukupno)',
    'Coach Leaders (Current Month)': 'Voditelji trenera (trenutni mjesec)',
    'Coaches are ranked based on their ParQs completed and Wins (potential clients they have marked as interested).':
      'Treneri se rangiraju prema dovršenim ParQ-ovima i uspjesima (potencijalni klijenti označeni kao zainteresirani).',
    Maybe: 'Možda',
    Month: 'Mjesec',
    'New Scans': 'Nova skeniranja',
    'New Users': 'Novi korisnici',
    'No available scans for report': 'Nema dostupnih skeniranja za izvješće',
    'No data available': 'Nema dostupnih podataka',
    'No scans available': 'Nema dostupnih skeniranja',
    ParQ: 'ParQ',
    PARQs: 'PARQ-ovi',
    Scans: 'Skeniranja',
    'Success Hub': 'Success Hub',
    Summary: 'Sažetak',
    'Usage Dashboard': 'Nadzorna ploča korištenja',
    'Unable to retrieve information.': 'Nije moguće dohvatiti informacije.',
    'View 3D Scan': 'Prikaži 3D skeniranje',
    'View History': 'Prikaži povijest',
    'View Scan Report': 'Prikaži izvješće skeniranja',
    'What is this?': 'Što je ovo?',
    Win: 'Uspjeh',
    'Win Rate': 'Stopa uspjeha',
    Wins: 'Uspjesi',
    'Your Scans': 'Vaša skeniranja',
    'Your Wellness Report': 'Vaše wellness izvješće',
    here: 'ovdje',
    'to return to your dashboard.': 'za povratak na nadzornu ploču.',
  },
}

const comparisonEmptyStateTranslations = {
  de: {
    'No visible scans': 'Keine sichtbaren Scans',
    'No viewable scans': 'Keine anzeigbaren Scans',
    'Not enough scans to compare (minimum 2)':
      'Nicht genügend Scans zum Vergleichen (mindestens 2)',
    'Not enough valid or visible scans':
      'Nicht genügend gültige oder sichtbare Scans',
    'Not enough viewable scans (minimum 2)':
      'Nicht genügend anzeigbare Scans (mindestens 2)',
    'Not enough visible scans': 'Nicht genügend sichtbare Scans',
    'Not enough visible scans (minimum 2)':
      'Nicht genügend sichtbare Scans (mindestens 2)',
    'There needs to be at least 2 different validated/visible scans.':
      'Es müssen mindestens 2 verschiedene validierte/sichtbare Scans vorhanden sein.',
    'There needs to be at least 2 different validated/visible scans. Click':
      'Es müssen mindestens 2 verschiedene validierte/sichtbare Scans vorhanden sein. Klicken Sie',
    'There needs to be at least 2 different viewable scans.':
      'Es müssen mindestens 2 verschiedene anzeigbare Scans vorhanden sein.',
    'There needs to be at least 2 different viewable scans. Click':
      'Es müssen mindestens 2 verschiedene anzeigbare Scans vorhanden sein. Klicken Sie',
    'There needs to be at least 2 different visible scans.':
      'Es müssen mindestens 2 verschiedene sichtbare Scans vorhanden sein.',
    'There needs to be at least 2 different visible scans. Click':
      'Es müssen mindestens 2 verschiedene sichtbare Scans vorhanden sein. Klicken Sie',
    'to return to all client records.':
      'um zu allen Kundendatensätzen zurückzukehren.',
    "to return to all clients' records page.":
      'um zur Datensatzseite aller Kunden zurückzukehren.',
    'to return to the single report page.':
      'um zur einzelnen Berichtsseite zurückzukehren.',
    'to return to the single scan report |':
      'um zum einzelnen Scan-Bericht zurückzukehren |',
    'to view scans.': 'um Scans anzuzeigen.',
    'to view your scan history.': 'um Ihren Scanverlauf anzuzeigen.',
  },
  fr: {
    'No visible scans': 'Aucun scan visible',
    'No viewable scans': 'Aucun scan consultable',
    'Not enough scans to compare (minimum 2)':
      'Pas assez de scans à comparer (minimum 2)',
    'Not enough valid or visible scans':
      'Pas assez de scans valides ou visibles',
    'Not enough viewable scans (minimum 2)':
      'Pas assez de scans consultables (minimum 2)',
    'Not enough visible scans': 'Pas assez de scans visibles',
    'Not enough visible scans (minimum 2)':
      'Pas assez de scans visibles (minimum 2)',
    'There needs to be at least 2 different validated/visible scans.':
      'Il doit y avoir au moins 2 scans validés/visibles différents.',
    'There needs to be at least 2 different validated/visible scans. Click':
      'Il doit y avoir au moins 2 scans validés/visibles différents. Cliquez',
    'There needs to be at least 2 different viewable scans.':
      'Il doit y avoir au moins 2 scans consultables différents.',
    'There needs to be at least 2 different viewable scans. Click':
      'Il doit y avoir au moins 2 scans consultables différents. Cliquez',
    'There needs to be at least 2 different visible scans.':
      'Il doit y avoir au moins 2 scans visibles différents.',
    'There needs to be at least 2 different visible scans. Click':
      'Il doit y avoir au moins 2 scans visibles différents. Cliquez',
    'to return to all client records.':
      'pour revenir à tous les dossiers client.',
    "to return to all clients' records page.":
      'pour revenir à la page des dossiers de tous les clients.',
    'to return to the single report page.':
      'pour revenir à la page du rapport unique.',
    'to return to the single scan report |':
      'pour revenir au rapport de scan unique |',
    'to view scans.': 'pour voir les scans.',
    'to view your scan history.': 'pour voir votre historique de scans.',
  },
  es: {
    'No visible scans': 'No hay escaneos visibles',
    'No viewable scans': 'No hay escaneos visibles',
    'Not enough scans to compare (minimum 2)':
      'No hay suficientes escaneos para comparar (mínimo 2)',
    'Not enough valid or visible scans':
      'No hay suficientes escaneos válidos o visibles',
    'Not enough viewable scans (minimum 2)':
      'No hay suficientes escaneos visibles (mínimo 2)',
    'Not enough visible scans': 'No hay suficientes escaneos visibles',
    'Not enough visible scans (minimum 2)':
      'No hay suficientes escaneos visibles (mínimo 2)',
    'There needs to be at least 2 different validated/visible scans.':
      'Debe haber al menos 2 escaneos validados/visibles diferentes.',
    'There needs to be at least 2 different validated/visible scans. Click':
      'Debe haber al menos 2 escaneos validados/visibles diferentes. Haz clic',
    'There needs to be at least 2 different viewable scans.':
      'Debe haber al menos 2 escaneos visibles diferentes.',
    'There needs to be at least 2 different viewable scans. Click':
      'Debe haber al menos 2 escaneos visibles diferentes. Haz clic',
    'There needs to be at least 2 different visible scans.':
      'Debe haber al menos 2 escaneos visibles diferentes.',
    'There needs to be at least 2 different visible scans. Click':
      'Debe haber al menos 2 escaneos visibles diferentes. Haz clic',
    'to return to all client records.':
      'para volver a todos los registros de clientes.',
    "to return to all clients' records page.":
      'para volver a la página de registros de todos los clientes.',
    'to return to the single report page.':
      'para volver a la página del informe individual.',
    'to return to the single scan report |':
      'para volver al informe de escaneo individual |',
    'to view scans.': 'para ver escaneos.',
    'to view your scan history.': 'para ver tu historial de escaneos.',
  },
  pt: {
    'No visible scans': 'Nenhum scan visível',
    'No viewable scans': 'Nenhum scan visualizável',
    'Not enough scans to compare (minimum 2)':
      'Scans insuficientes para comparar (mínimo 2)',
    'Not enough valid or visible scans':
      'Scans válidos ou visíveis insuficientes',
    'Not enough viewable scans (minimum 2)':
      'Scans visualizáveis insuficientes (mínimo 2)',
    'Not enough visible scans': 'Scans visíveis insuficientes',
    'Not enough visible scans (minimum 2)':
      'Scans visíveis insuficientes (mínimo 2)',
    'There needs to be at least 2 different validated/visible scans.':
      'Deve haver pelo menos 2 scans validados/visíveis diferentes.',
    'There needs to be at least 2 different validated/visible scans. Click':
      'Deve haver pelo menos 2 scans validados/visíveis diferentes. Clique',
    'There needs to be at least 2 different viewable scans.':
      'Deve haver pelo menos 2 scans visualizáveis diferentes.',
    'There needs to be at least 2 different viewable scans. Click':
      'Deve haver pelo menos 2 scans visualizáveis diferentes. Clique',
    'There needs to be at least 2 different visible scans.':
      'Deve haver pelo menos 2 scans visíveis diferentes.',
    'There needs to be at least 2 different visible scans. Click':
      'Deve haver pelo menos 2 scans visíveis diferentes. Clique',
    'to return to all client records.':
      'para voltar a todos os registros de clientes.',
    "to return to all clients' records page.":
      'para voltar à página de registros de todos os clientes.',
    'to return to the single report page.':
      'para voltar à página do relatório individual.',
    'to return to the single scan report |':
      'para voltar ao relatório de scan individual |',
    'to view scans.': 'para ver scans.',
    'to view your scan history.': 'para ver seu histórico de scans.',
  },
  zh_CN: {
    'No visible scans': '没有可见扫描',
    'No viewable scans': '没有可查看扫描',
    'Not enough scans to compare (minimum 2)': '可比较的扫描不足（最少 2 个）',
    'Not enough valid or visible scans': '有效或可见扫描不足',
    'Not enough viewable scans (minimum 2)': '可查看扫描不足（最少 2 个）',
    'Not enough visible scans': '可见扫描不足',
    'Not enough visible scans (minimum 2)': '可见扫描不足（最少 2 个）',
    'There needs to be at least 2 different validated/visible scans.':
      '至少需要 2 个不同的已验证/可见扫描。',
    'There needs to be at least 2 different validated/visible scans. Click':
      '至少需要 2 个不同的已验证/可见扫描。点击',
    'There needs to be at least 2 different viewable scans.':
      '至少需要 2 个不同的可查看扫描。',
    'There needs to be at least 2 different viewable scans. Click':
      '至少需要 2 个不同的可查看扫描。点击',
    'There needs to be at least 2 different visible scans.':
      '至少需要 2 个不同的可见扫描。',
    'There needs to be at least 2 different visible scans. Click':
      '至少需要 2 个不同的可见扫描。点击',
    'to return to all client records.': '返回所有客户记录。',
    "to return to all clients' records page.": '返回所有客户记录页面。',
    'to return to the single report page.': '返回单个报告页面。',
    'to return to the single scan report |': '返回单个扫描报告 |',
    'to view scans.': '以查看扫描。',
    'to view your scan history.': '以查看您的扫描历史。',
  },
  zh_TW: {
    'No visible scans': '沒有可見掃描',
    'No viewable scans': '沒有可查看掃描',
    'Not enough scans to compare (minimum 2)': '可比較的掃描不足（最少 2 個）',
    'Not enough valid or visible scans': '有效或可見掃描不足',
    'Not enough viewable scans (minimum 2)': '可查看掃描不足（最少 2 個）',
    'Not enough visible scans': '可見掃描不足',
    'Not enough visible scans (minimum 2)': '可見掃描不足（最少 2 個）',
    'There needs to be at least 2 different validated/visible scans.':
      '至少需要 2 個不同的已驗證/可見掃描。',
    'There needs to be at least 2 different validated/visible scans. Click':
      '至少需要 2 個不同的已驗證/可見掃描。點擊',
    'There needs to be at least 2 different viewable scans.':
      '至少需要 2 個不同的可查看掃描。',
    'There needs to be at least 2 different viewable scans. Click':
      '至少需要 2 個不同的可查看掃描。點擊',
    'There needs to be at least 2 different visible scans.':
      '至少需要 2 個不同的可見掃描。',
    'There needs to be at least 2 different visible scans. Click':
      '至少需要 2 個不同的可見掃描。點擊',
    'to return to all client records.': '返回所有客戶記錄。',
    "to return to all clients' records page.": '返回所有客戶記錄頁面。',
    'to return to the single report page.': '返回單一報告頁面。',
    'to return to the single scan report |': '返回單一掃描報告 |',
    'to view scans.': '以查看掃描。',
    'to view your scan history.': '以查看您的掃描歷史。',
  },
  it: {
    'No visible scans': 'Nessuna scansione visibile',
    'No viewable scans': 'Nessuna scansione visualizzabile',
    'Not enough scans to compare (minimum 2)':
      'Scansioni insufficienti da confrontare (minimo 2)',
    'Not enough valid or visible scans':
      'Scansioni valide o visibili insufficienti',
    'Not enough viewable scans (minimum 2)':
      'Scansioni visualizzabili insufficienti (minimo 2)',
    'Not enough visible scans': 'Scansioni visibili insufficienti',
    'Not enough visible scans (minimum 2)':
      'Scansioni visibili insufficienti (minimo 2)',
    'There needs to be at least 2 different validated/visible scans.':
      'Devono esserci almeno 2 scansioni validate/visibili diverse.',
    'There needs to be at least 2 different validated/visible scans. Click':
      'Devono esserci almeno 2 scansioni validate/visibili diverse. Fai clic',
    'There needs to be at least 2 different viewable scans.':
      'Devono esserci almeno 2 scansioni visualizzabili diverse.',
    'There needs to be at least 2 different viewable scans. Click':
      'Devono esserci almeno 2 scansioni visualizzabili diverse. Fai clic',
    'There needs to be at least 2 different visible scans.':
      'Devono esserci almeno 2 scansioni visibili diverse.',
    'There needs to be at least 2 different visible scans. Click':
      'Devono esserci almeno 2 scansioni visibili diverse. Fai clic',
    'to return to all client records.':
      'per tornare a tutti i record dei clienti.',
    "to return to all clients' records page.":
      'per tornare alla pagina dei record di tutti i clienti.',
    'to return to the single report page.':
      'per tornare alla pagina del singolo rapporto.',
    'to return to the single scan report |':
      'per tornare al singolo rapporto di scansione |',
    'to view scans.': 'per visualizzare le scansioni.',
    'to view your scan history.':
      'per visualizzare la cronologia delle scansioni.',
  },
  ko: {
    'No visible scans': '표시 가능한 스캔이 없습니다',
    'No viewable scans': '볼 수 있는 스캔이 없습니다',
    'Not enough scans to compare (minimum 2)':
      '비교할 스캔이 충분하지 않습니다(최소 2개)',
    'Not enough valid or visible scans':
      '유효하거나 표시 가능한 스캔이 충분하지 않습니다',
    'Not enough viewable scans (minimum 2)':
      '볼 수 있는 스캔이 충분하지 않습니다(최소 2개)',
    'Not enough visible scans': '표시 가능한 스캔이 충분하지 않습니다',
    'Not enough visible scans (minimum 2)':
      '표시 가능한 스캔이 충분하지 않습니다(최소 2개)',
    'There needs to be at least 2 different validated/visible scans.':
      '서로 다른 검증된/표시 가능한 스캔이 2개 이상 있어야 합니다.',
    'There needs to be at least 2 different validated/visible scans. Click':
      '서로 다른 검증된/표시 가능한 스캔이 2개 이상 있어야 합니다. 클릭',
    'There needs to be at least 2 different viewable scans.':
      '서로 다른 볼 수 있는 스캔이 2개 이상 있어야 합니다.',
    'There needs to be at least 2 different viewable scans. Click':
      '서로 다른 볼 수 있는 스캔이 2개 이상 있어야 합니다. 클릭',
    'There needs to be at least 2 different visible scans.':
      '서로 다른 표시 가능한 스캔이 2개 이상 있어야 합니다.',
    'There needs to be at least 2 different visible scans. Click':
      '서로 다른 표시 가능한 스캔이 2개 이상 있어야 합니다. 클릭',
    'to return to all client records.': '모든 고객 기록으로 돌아가세요.',
    "to return to all clients' records page.":
      '모든 고객 기록 페이지로 돌아가세요.',
    'to return to the single report page.': '단일 보고서 페이지로 돌아가세요.',
    'to return to the single scan report |': '단일 스캔 보고서로 돌아가기 |',
    'to view scans.': '스캔을 보려면.',
    'to view your scan history.': '스캔 기록을 보려면.',
  },
  nl: {
    'No visible scans': 'Geen zichtbare scans',
    'No viewable scans': 'Geen bekijkbare scans',
    'Not enough scans to compare (minimum 2)':
      'Niet genoeg scans om te vergelijken (minimaal 2)',
    'Not enough valid or visible scans':
      'Niet genoeg geldige of zichtbare scans',
    'Not enough viewable scans (minimum 2)':
      'Niet genoeg bekijkbare scans (minimaal 2)',
    'Not enough visible scans': 'Niet genoeg zichtbare scans',
    'Not enough visible scans (minimum 2)':
      'Niet genoeg zichtbare scans (minimaal 2)',
    'There needs to be at least 2 different validated/visible scans.':
      'Er moeten ten minste 2 verschillende gevalideerde/zichtbare scans zijn.',
    'There needs to be at least 2 different validated/visible scans. Click':
      'Er moeten ten minste 2 verschillende gevalideerde/zichtbare scans zijn. Klik',
    'There needs to be at least 2 different viewable scans.':
      'Er moeten ten minste 2 verschillende bekijkbare scans zijn.',
    'There needs to be at least 2 different viewable scans. Click':
      'Er moeten ten minste 2 verschillende bekijkbare scans zijn. Klik',
    'There needs to be at least 2 different visible scans.':
      'Er moeten ten minste 2 verschillende zichtbare scans zijn.',
    'There needs to be at least 2 different visible scans. Click':
      'Er moeten ten minste 2 verschillende zichtbare scans zijn. Klik',
    'to return to all client records.':
      'om terug te keren naar alle klantrecords.',
    "to return to all clients' records page.":
      'om terug te keren naar de recordpagina van alle klanten.',
    'to return to the single report page.':
      'om terug te keren naar de enkele rapportpagina.',
    'to return to the single scan report |':
      'om terug te keren naar het enkele scanrapport |',
    'to view scans.': 'om scans te bekijken.',
    'to view your scan history.': 'om uw scanhistorie te bekijken.',
  },
  fi: {
    'No visible scans': 'Ei näkyviä skannauksia',
    'No viewable scans': 'Ei katsottavia skannauksia',
    'Not enough scans to compare (minimum 2)':
      'Ei tarpeeksi skannauksia vertailuun (vähintään 2)',
    'Not enough valid or visible scans':
      'Ei tarpeeksi kelvollisia tai näkyviä skannauksia',
    'Not enough viewable scans (minimum 2)':
      'Ei tarpeeksi katsottavia skannauksia (vähintään 2)',
    'Not enough visible scans': 'Ei tarpeeksi näkyviä skannauksia',
    'Not enough visible scans (minimum 2)':
      'Ei tarpeeksi näkyviä skannauksia (vähintään 2)',
    'There needs to be at least 2 different validated/visible scans.':
      'Vähintään 2 erilaista vahvistettua/näkyvää skannausta tarvitaan.',
    'There needs to be at least 2 different validated/visible scans. Click':
      'Vähintään 2 erilaista vahvistettua/näkyvää skannausta tarvitaan. Napsauta',
    'There needs to be at least 2 different viewable scans.':
      'Vähintään 2 erilaista katsottavaa skannausta tarvitaan.',
    'There needs to be at least 2 different viewable scans. Click':
      'Vähintään 2 erilaista katsottavaa skannausta tarvitaan. Napsauta',
    'There needs to be at least 2 different visible scans.':
      'Vähintään 2 erilaista näkyvää skannausta tarvitaan.',
    'There needs to be at least 2 different visible scans. Click':
      'Vähintään 2 erilaista näkyvää skannausta tarvitaan. Napsauta',
    'to return to all client records.':
      'palataksesi kaikkiin asiakastietueisiin.',
    "to return to all clients' records page.":
      'palataksesi kaikkien asiakkaiden tietuesivulle.',
    'to return to the single report page.':
      'palataksesi yksittäisen raportin sivulle.',
    'to return to the single scan report |':
      'palataksesi yksittäiseen skannausraporttiin |',
    'to view scans.': 'näyttääksesi skannaukset.',
    'to view your scan history.': 'näyttääksesi skannaushistoriasi.',
  },
  ru: {
    'No visible scans': 'Нет видимых сканов',
    'No viewable scans': 'Нет доступных для просмотра сканов',
    'Not enough scans to compare (minimum 2)':
      'Недостаточно сканов для сравнения (минимум 2)',
    'Not enough valid or visible scans':
      'Недостаточно действительных или видимых сканов',
    'Not enough viewable scans (minimum 2)':
      'Недостаточно доступных для просмотра сканов (минимум 2)',
    'Not enough visible scans': 'Недостаточно видимых сканов',
    'Not enough visible scans (minimum 2)':
      'Недостаточно видимых сканов (минимум 2)',
    'There needs to be at least 2 different validated/visible scans.':
      'Должно быть как минимум 2 разных подтвержденных/видимых скана.',
    'There needs to be at least 2 different validated/visible scans. Click':
      'Должно быть как минимум 2 разных подтвержденных/видимых скана. Нажмите',
    'There needs to be at least 2 different viewable scans.':
      'Должно быть как минимум 2 разных доступных для просмотра скана.',
    'There needs to be at least 2 different viewable scans. Click':
      'Должно быть как минимум 2 разных доступных для просмотра скана. Нажмите',
    'There needs to be at least 2 different visible scans.':
      'Должно быть как минимум 2 разных видимых скана.',
    'There needs to be at least 2 different visible scans. Click':
      'Должно быть как минимум 2 разных видимых скана. Нажмите',
    'to return to all client records.':
      'чтобы вернуться ко всем записям клиентов.',
    "to return to all clients' records page.":
      'чтобы вернуться на страницу записей всех клиентов.',
    'to return to the single report page.':
      'чтобы вернуться на страницу одного отчета.',
    'to return to the single scan report |':
      'чтобы вернуться к одному отчету скана |',
    'to view scans.': 'чтобы просмотреть сканы.',
    'to view your scan history.': 'чтобы просмотреть историю сканов.',
  },
  sv: {
    'No visible scans': 'Inga synliga skanningar',
    'No viewable scans': 'Inga visningsbara skanningar',
    'Not enough scans to compare (minimum 2)':
      'Inte tillräckligt med skanningar att jämföra (minst 2)',
    'Not enough valid or visible scans':
      'Inte tillräckligt med giltiga eller synliga skanningar',
    'Not enough viewable scans (minimum 2)':
      'Inte tillräckligt med visningsbara skanningar (minst 2)',
    'Not enough visible scans': 'Inte tillräckligt med synliga skanningar',
    'Not enough visible scans (minimum 2)':
      'Inte tillräckligt med synliga skanningar (minst 2)',
    'There needs to be at least 2 different validated/visible scans.':
      'Det måste finnas minst 2 olika validerade/synliga skanningar.',
    'There needs to be at least 2 different validated/visible scans. Click':
      'Det måste finnas minst 2 olika validerade/synliga skanningar. Klicka',
    'There needs to be at least 2 different viewable scans.':
      'Det måste finnas minst 2 olika visningsbara skanningar.',
    'There needs to be at least 2 different viewable scans. Click':
      'Det måste finnas minst 2 olika visningsbara skanningar. Klicka',
    'There needs to be at least 2 different visible scans.':
      'Det måste finnas minst 2 olika synliga skanningar.',
    'There needs to be at least 2 different visible scans. Click':
      'Det måste finnas minst 2 olika synliga skanningar. Klicka',
    'to return to all client records.':
      'för att återgå till alla klientposter.',
    "to return to all clients' records page.":
      'för att återgå till sidan med alla klientposter.',
    'to return to the single report page.':
      'för att återgå till den enskilda rapportsidan.',
    'to return to the single scan report |':
      'för att återgå till den enskilda skanningsrapporten |',
    'to view scans.': 'för att visa skanningar.',
    'to view your scan history.': 'för att visa din skanningshistorik.',
  },
  ja: {
    'No visible scans': '表示可能なスキャンがありません',
    'No viewable scans': '閲覧可能なスキャンがありません',
    'Not enough scans to compare (minimum 2)':
      '比較するスキャンが足りません（最低2件）',
    'Not enough valid or visible scans':
      '有効または表示可能なスキャンが足りません',
    'Not enough viewable scans (minimum 2)':
      '閲覧可能なスキャンが足りません（最低2件）',
    'Not enough visible scans': '表示可能なスキャンが足りません',
    'Not enough visible scans (minimum 2)':
      '表示可能なスキャンが足りません（最低2件）',
    'There needs to be at least 2 different validated/visible scans.':
      '少なくとも2つの異なる検証済み/表示可能なスキャンが必要です。',
    'There needs to be at least 2 different validated/visible scans. Click':
      '少なくとも2つの異なる検証済み/表示可能なスキャンが必要です。クリック',
    'There needs to be at least 2 different viewable scans.':
      '少なくとも2つの異なる閲覧可能なスキャンが必要です。',
    'There needs to be at least 2 different viewable scans. Click':
      '少なくとも2つの異なる閲覧可能なスキャンが必要です。クリック',
    'There needs to be at least 2 different visible scans.':
      '少なくとも2つの異なる表示可能なスキャンが必要です。',
    'There needs to be at least 2 different visible scans. Click':
      '少なくとも2つの異なる表示可能なスキャンが必要です。クリック',
    'to return to all client records.': 'すべてのクライアント記録に戻ります。',
    "to return to all clients' records page.":
      'すべてのクライアント記録ページに戻ります。',
    'to return to the single report page.': '単一レポートページに戻ります。',
    'to return to the single scan report |': '単一スキャンレポートに戻る |',
    'to view scans.': 'スキャンを表示します。',
    'to view your scan history.': 'スキャン履歴を表示します。',
  },
  tr: {
    'No visible scans': 'Görünür tarama yok',
    'No viewable scans': 'Görüntülenebilir tarama yok',
    'Not enough scans to compare (minimum 2)':
      'Karşılaştırmak için yeterli tarama yok (minimum 2)',
    'Not enough valid or visible scans':
      'Yeterli geçerli veya görünür tarama yok',
    'Not enough viewable scans (minimum 2)':
      'Yeterli görüntülenebilir tarama yok (minimum 2)',
    'Not enough visible scans': 'Yeterli görünür tarama yok',
    'Not enough visible scans (minimum 2)':
      'Yeterli görünür tarama yok (minimum 2)',
    'There needs to be at least 2 different validated/visible scans.':
      'En az 2 farklı doğrulanmış/görünür tarama olmalıdır.',
    'There needs to be at least 2 different validated/visible scans. Click':
      'En az 2 farklı doğrulanmış/görünür tarama olmalıdır. Tıklayın',
    'There needs to be at least 2 different viewable scans.':
      'En az 2 farklı görüntülenebilir tarama olmalıdır.',
    'There needs to be at least 2 different viewable scans. Click':
      'En az 2 farklı görüntülenebilir tarama olmalıdır. Tıklayın',
    'There needs to be at least 2 different visible scans.':
      'En az 2 farklı görünür tarama olmalıdır.',
    'There needs to be at least 2 different visible scans. Click':
      'En az 2 farklı görünür tarama olmalıdır. Tıklayın',
    'to return to all client records.': 'tüm müşteri kayıtlarına dönmek için.',
    "to return to all clients' records page.":
      'tüm müşterilerin kayıtları sayfasına dönmek için.',
    'to return to the single report page.': 'tek rapor sayfasına dönmek için.',
    'to return to the single scan report |':
      'tek tarama raporuna dönmek için |',
    'to view scans.': 'taramaları görüntülemek için.',
    'to view your scan history.': 'tarama geçmişinizi görüntülemek için.',
  },
  cs: {
    'No visible scans': 'Žádné viditelné skeny',
    'No viewable scans': 'Žádné zobrazitelné skeny',
    'Not enough scans to compare (minimum 2)':
      'Nedostatek skenů k porovnání (minimálně 2)',
    'Not enough valid or visible scans':
      'Nedostatek platných nebo viditelných skenů',
    'Not enough viewable scans (minimum 2)':
      'Nedostatek zobrazitelných skenů (minimálně 2)',
    'Not enough visible scans': 'Nedostatek viditelných skenů',
    'Not enough visible scans (minimum 2)':
      'Nedostatek viditelných skenů (minimálně 2)',
    'There needs to be at least 2 different validated/visible scans.':
      'Musí existovat alespoň 2 různé ověřené/viditelné skeny.',
    'There needs to be at least 2 different validated/visible scans. Click':
      'Musí existovat alespoň 2 různé ověřené/viditelné skeny. Klikněte',
    'There needs to be at least 2 different viewable scans.':
      'Musí existovat alespoň 2 různé zobrazitelné skeny.',
    'There needs to be at least 2 different viewable scans. Click':
      'Musí existovat alespoň 2 různé zobrazitelné skeny. Klikněte',
    'There needs to be at least 2 different visible scans.':
      'Musí existovat alespoň 2 různé viditelné skeny.',
    'There needs to be at least 2 different visible scans. Click':
      'Musí existovat alespoň 2 různé viditelné skeny. Klikněte',
    'to return to all client records.': 'pro návrat ke všem záznamům klientů.',
    "to return to all clients' records page.":
      'pro návrat na stránku záznamů všech klientů.',
    'to return to the single report page.':
      'pro návrat na stránku jednotlivé zprávy.',
    'to return to the single scan report |':
      'pro návrat k jednotlivé zprávě skenu |',
    'to view scans.': 'pro zobrazení skenů.',
    'to view your scan history.': 'pro zobrazení historie skenů.',
  },
  el: {
    'No visible scans': 'Δεν υπάρχουν ορατές σαρώσεις',
    'No viewable scans': 'Δεν υπάρχουν σαρώσεις για προβολή',
    'Not enough scans to compare (minimum 2)':
      'Δεν υπάρχουν αρκετές σαρώσεις για σύγκριση (ελάχιστο 2)',
    'Not enough valid or visible scans':
      'Δεν υπάρχουν αρκετές έγκυρες ή ορατές σαρώσεις',
    'Not enough viewable scans (minimum 2)':
      'Δεν υπάρχουν αρκετές σαρώσεις για προβολή (ελάχιστο 2)',
    'Not enough visible scans': 'Δεν υπάρχουν αρκετές ορατές σαρώσεις',
    'Not enough visible scans (minimum 2)':
      'Δεν υπάρχουν αρκετές ορατές σαρώσεις (ελάχιστο 2)',
    'There needs to be at least 2 different validated/visible scans.':
      'Πρέπει να υπάρχουν τουλάχιστον 2 διαφορετικές επικυρωμένες/ορατές σαρώσεις.',
    'There needs to be at least 2 different validated/visible scans. Click':
      'Πρέπει να υπάρχουν τουλάχιστον 2 διαφορετικές επικυρωμένες/ορατές σαρώσεις. Κάντε κλικ',
    'There needs to be at least 2 different viewable scans.':
      'Πρέπει να υπάρχουν τουλάχιστον 2 διαφορετικές σαρώσεις για προβολή.',
    'There needs to be at least 2 different viewable scans. Click':
      'Πρέπει να υπάρχουν τουλάχιστον 2 διαφορετικές σαρώσεις για προβολή. Κάντε κλικ',
    'There needs to be at least 2 different visible scans.':
      'Πρέπει να υπάρχουν τουλάχιστον 2 διαφορετικές ορατές σαρώσεις.',
    'There needs to be at least 2 different visible scans. Click':
      'Πρέπει να υπάρχουν τουλάχιστον 2 διαφορετικές ορατές σαρώσεις. Κάντε κλικ',
    'to return to all client records.':
      'για να επιστρέψετε σε όλα τα αρχεία πελατών.',
    "to return to all clients' records page.":
      'για να επιστρέψετε στη σελίδα αρχείων όλων των πελατών.',
    'to return to the single report page.':
      'για να επιστρέψετε στη σελίδα της μεμονωμένης αναφοράς.',
    'to return to the single scan report |':
      'για να επιστρέψετε στη μεμονωμένη αναφορά σάρωσης |',
    'to view scans.': 'για να δείτε τις σαρώσεις.',
    'to view your scan history.': 'για να δείτε το ιστορικό σαρώσεών σας.',
  },
  hr: {
    'No visible scans': 'Nema vidljivih skeniranja',
    'No viewable scans': 'Nema skeniranja za prikaz',
    'Not enough scans to compare (minimum 2)':
      'Nema dovoljno skeniranja za usporedbu (najmanje 2)',
    'Not enough valid or visible scans':
      'Nema dovoljno valjanih ili vidljivih skeniranja',
    'Not enough viewable scans (minimum 2)':
      'Nema dovoljno skeniranja za prikaz (najmanje 2)',
    'Not enough visible scans': 'Nema dovoljno vidljivih skeniranja',
    'Not enough visible scans (minimum 2)':
      'Nema dovoljno vidljivih skeniranja (najmanje 2)',
    'There needs to be at least 2 different validated/visible scans.':
      'Moraju postojati najmanje 2 različita potvrđena/vidljiva skeniranja.',
    'There needs to be at least 2 different validated/visible scans. Click':
      'Moraju postojati najmanje 2 različita potvrđena/vidljiva skeniranja. Kliknite',
    'There needs to be at least 2 different viewable scans.':
      'Moraju postojati najmanje 2 različita skeniranja za prikaz.',
    'There needs to be at least 2 different viewable scans. Click':
      'Moraju postojati najmanje 2 različita skeniranja za prikaz. Kliknite',
    'There needs to be at least 2 different visible scans.':
      'Moraju postojati najmanje 2 različita vidljiva skeniranja.',
    'There needs to be at least 2 different visible scans. Click':
      'Moraju postojati najmanje 2 različita vidljiva skeniranja. Kliknite',
    'to return to all client records.': 'za povratak na sve zapise klijenata.',
    "to return to all clients' records page.":
      'za povratak na stranicu zapisa svih klijenata.',
    'to return to the single report page.':
      'za povratak na stranicu pojedinačnog izvješća.',
    'to return to the single scan report |':
      'za povratak na pojedinačno izvješće skeniranja |',
    'to view scans.': 'za prikaz skeniranja.',
    'to view your scan history.': 'za prikaz povijesti skeniranja.',
  },
}

const renderedPagePhraseTranslations = {
  fr: {
    "'s Fit3D Comparison Report": '- Rapport comparatif Fit3D',
    Complete: 'Terminé',
    Formula: 'Formule',
    References: 'Références',
    'Body Shape Rating (BSR)': 'Note de forme corporelle (BSR)',
    'Fit3D Wellness Metrics Glossary':
      'Glossaire des métriques de bien-être Fit3D',
    'Gain a more in-depth understanding about each metric.':
      'Comprenez chaque métrique plus en détail.',
    'Lean Mass (lbs)': 'Masse maigre (lb)',
    'Metabolic Age (years)': 'Âge métabolique (années)',
    'See Scan in Color': 'Voir le scan en couleur',
    'Select a wellness group:': 'Sélectionnez un groupe de bien-être :',
    'Select two scans to view compare:': 'Sélectionnez deux scans à comparer :',
    'Trunk to Leg Volume Ratio': 'Rapport de volume tronc-jambes',
    'User Error': 'Erreur utilisateur',
    'VAT Mass (lbs)': 'Masse de graisse viscérale (lb)',
    'Ways to Improve': "Moyens de s'améliorer",
    'Weight (lbs)': 'Poids (lb)',
    'Wellness Metric Comparisons': 'Comparaisons des métriques de bien-être',
    'Wellness Metrics': 'Métriques de bien-être',
    'What is it?': "Qu'est-ce que c'est ?",
  },
  de: {
    "'s Fit3D Comparison Report": '- Fit3D-Vergleichsbericht',
    Complete: 'Abgeschlossen',
    Formula: 'Formel',
    References: 'Referenzen',
    'Body Shape Rating (BSR)': 'Körperformbewertung (BSR)',
    'Fit3D Wellness Metrics Glossary': 'Glossar der Fit3D-Wellnessmetriken',
    'Gain a more in-depth understanding about each metric.':
      'Erhalten Sie ein tieferes Verständnis jeder Metrik.',
    'Lean Mass (lbs)': 'Magermasse (lbs)',
    'Metabolic Age (years)': 'Metabolisches Alter (Jahre)',
    'See Scan in Color': 'Scan in Farbe anzeigen',
    'Select a wellness group:': 'Wellnessgruppe auswählen:',
    'Select two scans to view compare:':
      'Wählen Sie zwei Scans zum Vergleichen aus:',
    'User Error': 'Benutzerfehler',
    'VAT Mass (lbs)': 'Viszerale Fettmasse (lbs)',
    'Ways to Improve': 'Verbesserungsmöglichkeiten',
    'Weight (lbs)': 'Gewicht (lbs)',
    'What is it?': 'Was ist das?',
  },
  es: {
    "'s Fit3D Comparison Report": '- Informe comparativo Fit3D',
    '(Hover over graph to view more details)':
      '(Pasa el cursor sobre la gráfica para ver más detalles)',
    Actual: 'Actual',
    'Actual (Inches)': 'Actual (pulgadas)',
    Baseline: 'Referencia',
    'Baseline (Inches)': 'Referencia (pulgadas)',
    'Blood Pressure': 'Presión arterial',
    'Body Shape Rating': 'Calificación de forma corporal',
    'Body Shape Rating (BSR)': 'Calificación de forma corporal (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      'La Calificación de forma corporal (BSR) es una puntuación de bienestar basada en la relación entre la forma corporal y los factores de riesgo cardiovascular. Responde a la pregunta: ¿la forma de mi cuerpo aumenta la probabilidad de desarrollar ciertos problemas de salud cardiovascular? La BSR está en una escala de 0 a 100, donde 50 es el promedio y cuanto más alta sea la puntuación, menor es el riesgo.',
    Chest: 'Pecho',
    Complete: 'Completo',
    Current: 'Actual',
    Diff: 'Diferencia',
    'Diff (Inches)': 'Diferencia (pulgadas)',
    Download: 'Descargar',
    Formula: 'Fórmula',
    'Fit3D Wellness Metrics Glossary':
      'Glosario de métricas de bienestar Fit3D',
    'Gain a more in-depth understanding about each metric.':
      'Obtén una comprensión más profunda de cada métrica.',
    'Heart Rate': 'Frecuencia cardíaca',
    'Hide Image': 'Ocultar imagen',
    Hip: 'Cadera',
    'How do I compare?': '¿Cómo me comparo?',
    'Lean Mass': 'Masa magra',
    'Lean Mass (lbs)': 'Masa magra (lbs)',
    'Measurement Comparisons': 'Comparaciones de mediciones',
    'Measurement Name': 'Nombre de la medición',
    'Metabolic Age': 'Edad metabólica',
    'Metabolic Age (years)': 'Edad metabólica (años)',
    'Metric Name': 'Nombre de la métrica',
    Name: 'Nombre',
    References: 'Referencias',
    'Scan Information': 'Información del escaneo',
    'See Scan in Color': 'Ver escaneo en color',
    'Select a wellness group:': 'Selecciona un grupo de bienestar:',
    'Select two scans to view compare:':
      'Selecciona dos escaneos para comparar:',
    Status: 'Estado',
    'Status:': 'Estado:',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      'La gráfica a continuación muestra cómo te comparas con los rangos saludables recomendados y con otros usuarios de Fit3D de tu mismo género y edad similar.',
    'The primary way to improve your BSR is to increase the density of your body, build the muscle in your legs, and decrease your waist circumference.':
      'La forma principal de mejorar tu BSR es aumentar la densidad corporal, desarrollar músculo en las piernas y reducir la circunferencia de la cintura.',
    'This can be done through a balanced mix of good nutrition and exercise. Consult with your trainer, nutritionist, coaches, or doctors to set up a plan.':
      'Esto puede lograrse con una combinación equilibrada de buena nutrición y ejercicio. Consulta con tu entrenador, nutricionista, coaches o médicos para crear un plan.',
    'To better understand ABSI, SBSI, Body Fat Percentage and Trunk to Leg Volume Ratio, please refer to the descriptions below or the research from the following links:':
      'Para comprender mejor ABSI, SBSI, el porcentaje de grasa corporal y la relación de volumen tronco-piernas, consulta las descripciones siguientes o la investigación en los enlaces a continuación:',
    'Trunk to Leg': 'Tronco a pierna',
    'Trunk to Leg Volume Ratio': 'Relación de volumen tronco-piernas',
    'Trunk to Leg Volume Ratio compares the volume of your trunk with the volume of your legs. This can generally only be done with some type of body scanning, whether it be Fit3D or more costly and complex scanners like DXA or MRI. Research claims that having a high percentage of your body’s volume in your torso compared to your legs increases the likelihood of you experiencing prediabetes, diabetes, high triglyceride (fat) counts, high blood pressure, metabolic syndromes, and other severe health complications.':
      'La relación de volumen tronco-piernas compara el volumen del tronco con el volumen de las piernas. Por lo general, esto solo puede hacerse con algún tipo de escaneo corporal, ya sea Fit3D o escáneres más costosos y complejos como DXA o MRI. La investigación indica que tener un alto porcentaje del volumen corporal en el torso en comparación con las piernas aumenta la probabilidad de experimentar prediabetes, diabetes, triglicéridos altos, presión arterial alta, síndromes metabólicos y otras complicaciones graves de salud.',
    'Trunk to Leg Volume Ratio looks at the volume of your torso as compared with the volume of your legs. A high ratio of trunk to leg volume showed a strong association to diabetes and mortality that was independent of total and regional fat distributions. This novel body shape measure provides additional information regarding central adiposity and appendicular wasting to better stratify individuals at risk for diabetes and mortality, even among those with normal BMI.':
      'La relación de volumen tronco-piernas analiza el volumen del torso en comparación con el volumen de las piernas. Una relación alta mostró una fuerte asociación con diabetes y mortalidad, independiente de la distribución de grasa total y regional. Esta medida novedosa de forma corporal aporta información adicional sobre adiposidad central y pérdida apendicular para estratificar mejor a las personas en riesgo de diabetes y mortalidad, incluso con IMC normal.',
    'User Error': 'Error del usuario',
    'VAT Mass': 'Masa de grasa visceral',
    'VAT Mass (lbs)': 'Masa de grasa visceral (lbs)',
    Waist: 'Cintura',
    'Waist Circumference': 'Circunferencia de cintura',
    'Waist to Hip Ratio': 'Relación cintura-cadera',
    'Ways to Improve': 'Formas de mejorar',
    Weight: 'Peso',
    'Weight (lbs)': 'Peso (lbs)',
    'Weight in your mid-section is highly correlated with visceral fat, which is the unhealthy fat around your organs. If you have a big belly and smaller legs, it is a good assumption that your weight is centered around your midsection and is therefore visceral fat.':
      'El peso en la zona media está altamente correlacionado con la grasa visceral, que es la grasa no saludable alrededor de los órganos. Si tienes un abdomen grande y piernas más pequeñas, es razonable asumir que tu peso se concentra en la zona media y, por lo tanto, corresponde a grasa visceral.',
    'Wellness Comparison': 'Comparación de bienestar',
    'Wellness Metric Comparisons': 'Comparaciones de métricas de bienestar',
    'Wellness Metrics': 'Métricas de bienestar',
    'What is it?': '¿Qué es?',
  },
  pt: {
    "'s Fit3D Comparison Report": '- Relatório comparativo Fit3D',
    Complete: 'Concluído',
    'Download Report': 'Baixar relatório',
    Formula: 'Fórmula',
    'Hide Images': 'Ocultar imagens',
    References: 'Referências',
    'Read More': 'Ler mais',
    'Report (Limited)': 'Relatório (Limitado)',
    'Request Full Access': 'Solicitar acesso completo',
    'Return to All Scans': 'Voltar para todos os escaneamentos',
    'Scan Info': 'Informações do escaneamento',
    Status: 'Estado',
    'Status:': 'Estado:',
    'Success Hub': 'Success Hub',
    'Body Shape Rating (BSR)': 'Classificação da forma corporal (BSR)',
    'Fit3D Wellness Metrics Glossary':
      'Glossário de métricas de bem-estar Fit3D',
    'Gain a more in-depth understanding about each metric.':
      'Tenha uma compreensão mais aprofundada de cada métrica.',
    'Lean Mass (lbs)': 'Massa magra (lbs)',
    'Metabolic Age (years)': 'Idade metabólica (anos)',
    'See Scan in Color': 'Ver scan em cores',
    'Select a wellness group:': 'Selecione um grupo de bem-estar:',
    'Select two scans to view compare:': 'Selecione dois scans para comparar:',
    'Trunk to Leg Volume Ratio': 'Relação de volume tronco-pernas',
    'User Error': 'Erro do usuário',
    'VAT Mass (lbs)': 'Massa de gordura visceral (lbs)',
    'Ways to Improve': 'Formas de melhorar',
    'Weight (lbs)': 'Peso (lbs)',
    'Wellness Metric Comparisons': 'Comparações de métricas de bem-estar',
    'Wellness Metrics': 'Métricas de bem-estar',
    'What is it?': 'O que é?',
  },
  zh_CN: {
    "'s Fit3D Comparison Report": '- Fit3D 对比报告',
    Complete: '完成',
    Formula: '公式',
    References: '参考资料',
    'Body Shape Rating (BSR)': '体型评分 (BSR)',
    'Fit3D Wellness Metrics Glossary': 'Fit3D 健康指标术语表',
    'Gain a more in-depth understanding about each metric.':
      '更深入了解每项指标。',
    'Lean Mass (lbs)': '瘦体重 (lbs)',
    'Metabolic Age (years)': '代谢年龄（年）',
    'See Scan in Color': '查看彩色扫描',
    'Select a wellness group:': '选择健康指标组：',
    'Select two scans to view compare:': '选择两个扫描进行比较：',
    'Trunk to Leg Volume Ratio': '躯干与腿部体积比',
    'User Error': '用户错误',
    'VAT Mass (lbs)': '内脏脂肪质量 (lbs)',
    'Ways to Improve': '改善方法',
    'Weight (lbs)': '体重 (lbs)',
    'Wellness Metric Comparisons': '健康指标比较',
    'Wellness Metrics': '健康指标',
    'What is it?': '这是什么？',
  },
  zh_TW: {
    "'s Fit3D Comparison Report": '- Fit3D 比較報告',
    Complete: '完成',
    Formula: '公式',
    References: '參考資料',
    'Body Shape Rating (BSR)': '體型評分 (BSR)',
    'Fit3D Wellness Metrics Glossary': 'Fit3D 健康指標術語表',
    'Gain a more in-depth understanding about each metric.':
      '更深入了解每項指標。',
    'Lean Mass (lbs)': '瘦體重 (lbs)',
    'Metabolic Age (years)': '代謝年齡（年）',
    'See Scan in Color': '查看彩色掃描',
    'Select a wellness group:': '選擇健康指標群組：',
    'Select two scans to view compare:': '選擇兩個掃描進行比較：',
    'Trunk to Leg Volume Ratio': '軀幹與腿部體積比',
    'User Error': '使用者錯誤',
    'VAT Mass (lbs)': '內臟脂肪量 (lbs)',
    'Ways to Improve': '改善方法',
    'Weight (lbs)': '體重 (lbs)',
    'Wellness Metric Comparisons': '健康指標比較',
    'Wellness Metrics': '健康指標',
    'What is it?': '這是什麼？',
  },
  it: {
    "'s Fit3D Comparison Report": '- Report comparativo Fit3D',
    Complete: 'Completo',
    Formula: 'Formula metrica',
    References: 'Riferimenti',
    'Body Shape Rating (BSR)': 'Valutazione della forma corporea (BSR)',
    Coach: 'Allenatore',
    Coaches: 'Allenatori',
    'Click a scan on the left to view more information!':
      'Fai clic su una scansione a sinistra per visualizzare ulteriori informazioni!',
    'Date Taken:': 'Data scansione:',
    'Download Scan Gif': 'Scarica scansione GIF',
    'Download Scan Obj': 'Scarica scansione OBJ',
    'Fit3D Wellness Metrics Glossary':
      'Glossario delle metriche di benessere Fit3D',
    'Gain a more in-depth understanding about each metric.':
      'Ottieni una comprensione più approfondita di ogni metrica.',
    Hide: 'Nascondi',
    'Hide Scan In Report': 'Nascondi scansione nel rapporto',
    'Hide Images': 'Nascondi immagini',
    'Lean Mass (lbs)': 'Massa magra (lbs)',
    'Metabolic Age (years)': 'Età metabolica (anni)',
    'Posture Status:': 'Stato postura:',
    'Request Full Access': 'Richiedi accesso completo',
    'Return to All Scans': 'Torna a tutte le scansioni',
    'Scan In Report': 'scansione nel rapporto',
    'See Scan in Color': 'Vedi scansione a colori',
    'Select a wellness group:': 'Seleziona un gruppo di benessere:',
    'Select two scans to view compare:':
      'Seleziona due scansioni da confrontare:',
    Show: 'Mostra',
    'Show Images': 'Mostra immagini',
    'Show Scan In Report': 'Mostra scansione nel rapporto',
    'Trunk to Leg Volume Ratio': 'Rapporto volume tronco-gambe',
    'User Error': 'Errore utente',
    'VAT Mass (lbs)': 'Massa di grasso viscerale (lbs)',
    'Ways to Improve': 'Modi per migliorare',
    'Weight (lbs)': 'Peso (lbs)',
    'Wellness Metric Comparisons': 'Confronti delle metriche di benessere',
    'Wellness Metrics': 'Metriche di benessere',
    'What is it?': "Che cos'è?",
  },
  ko: {
    "'s Fit3D Comparison Report": '- Fit3D 비교 보고서',
    Complete: '완료',
    Formula: '공식',
    References: '참고 자료',
    'Body Shape Rating (BSR)': '체형 등급 (BSR)',
    'Fit3D Wellness Metrics Glossary': 'Fit3D 웰니스 지표 용어집',
    'Gain a more in-depth understanding about each metric.':
      '각 지표를 더 자세히 이해하세요.',
    'Lean Mass (lbs)': '제지방량 (lbs)',
    'Metabolic Age (years)': '대사 나이 (세)',
    'See Scan in Color': '컬러 스캔 보기',
    'Select a wellness group:': '웰니스 그룹 선택:',
    'Select two scans to view compare:': '비교할 스캔 두 개 선택:',
    'Trunk to Leg Volume Ratio': '몸통-다리 부피 비율',
    'User Error': '사용자 오류',
    'VAT Mass (lbs)': '내장 지방량 (lbs)',
    'Ways to Improve': '개선 방법',
    'Weight (lbs)': '체중 (lbs)',
    'Wellness Metric Comparisons': '웰니스 지표 비교',
    'Wellness Metrics': '웰니스 지표',
    'What is it?': '무엇인가요?',
  },
  nl: {
    "'s Fit3D Comparison Report": '- Fit3D-vergelijkingsrapport',
    Complete: 'Voltooid',
    Formula: 'Formule',
    References: 'Referenties',
    'Body Shape Rating (BSR)': 'Lichaamsvormscore (BSR)',
    'Fit3D Wellness Metrics Glossary': 'Woordenlijst Fit3D-wellnessmetingen',
    'Gain a more in-depth understanding about each metric.':
      'Krijg meer diepgaand inzicht in elke meting.',
    'Lean Mass (lbs)': 'Magere massa (lbs)',
    'Metabolic Age (years)': 'Metabole leeftijd (jaren)',
    'See Scan in Color': 'Scan in kleur bekijken',
    'Select a wellness group:': 'Selecteer een wellnessgroep:',
    'Select two scans to view compare:':
      'Selecteer twee scans om te vergelijken:',
    'Trunk to Leg Volume Ratio': 'Romp-tot-been volumeverhouding',
    'User Error': 'Gebruikersfout',
    'VAT Mass (lbs)': 'Viscerale vetmassa (lbs)',
    'Ways to Improve': 'Manieren om te verbeteren',
    'Weight (lbs)': 'Gewicht (lbs)',
    'Wellness Metric Comparisons': 'Vergelijkingen van wellnessmetingen',
    'Wellness Metrics': 'Wellnessmetingen',
    'What is it?': 'Wat is het?',
  },
  fi: {
    "'s Fit3D Comparison Report": '- Fit3D-vertailuraportti',
    Complete: 'Valmis',
    Formula: 'Kaava',
    References: 'Viitteet',
    'Body Shape Rating (BSR)': 'Kehon muodon arvio (BSR)',
    'Fit3D Wellness Metrics Glossary': 'Fit3D-hyvinvointimittareiden sanasto',
    'Gain a more in-depth understanding about each metric.':
      'Saat syvemmän ymmärryksen jokaisesta mittarista.',
    'Lean Mass (lbs)': 'Rasvaton massa (lbs)',
    'Metabolic Age (years)': 'Metabolinen ikä (vuotta)',
    'See Scan in Color': 'Näytä skannaus värillisenä',
    'Select a wellness group:': 'Valitse hyvinvointiryhmä:',
    'Select two scans to view compare:':
      'Valitse kaksi skannausta vertailua varten:',
    'Trunk to Leg Volume Ratio': 'Vartalon ja jalkojen tilavuussuhde',
    'User Error': 'Käyttäjän virhe',
    'VAT Mass (lbs)': 'Viskeraalisen rasvan massa (lbs)',
    'Ways to Improve': 'Tapoja parantaa',
    'Weight (lbs)': 'Paino (lbs)',
    'Wellness Metric Comparisons': 'Hyvinvointimittareiden vertailut',
    'Wellness Metrics': 'Hyvinvointimittarit',
    'What is it?': 'Mikä se on?',
  },
  ru: {
    "'s Fit3D Comparison Report": '- сравнительный отчет Fit3D',
    Complete: 'Завершено',
    Formula: 'Формула',
    References: 'Ссылки',
    'Body Shape Rating (BSR)': 'Оценка формы тела (BSR)',
    'Fit3D Wellness Metrics Glossary': 'Глоссарий показателей здоровья Fit3D',
    'Gain a more in-depth understanding about each metric.':
      'Получите более глубокое понимание каждого показателя.',
    'Lean Mass (lbs)': 'Безжировая масса (lbs)',
    'Metabolic Age (years)': 'Метаболический возраст (лет)',
    'See Scan in Color': 'Посмотреть скан в цвете',
    'Select a wellness group:': 'Выберите группу показателей здоровья:',
    'Select two scans to view compare:': 'Выберите два скана для сравнения:',
    'Trunk to Leg Volume Ratio': 'Соотношение объема туловища и ног',
    'User Error': 'Ошибка пользователя',
    'VAT Mass (lbs)': 'Масса висцерального жира (lbs)',
    'Ways to Improve': 'Способы улучшения',
    'Weight (lbs)': 'Вес (lbs)',
    'Wellness Metric Comparisons': 'Сравнение показателей здоровья',
    'Wellness Metrics': 'Показатели здоровья',
    'What is it?': 'Что это?',
  },
  sv: {
    "'s Fit3D Comparison Report": '- Fit3D-jämförelserapport',
    Complete: 'Slutförd',
    Formula: 'Formel',
    References: 'Referenser',
    'Body Shape Rating (BSR)': 'Kroppsformsbetyg (BSR)',
    'Fit3D Wellness Metrics Glossary': 'Ordlista för Fit3D-hälsomätvärden',
    'Gain a more in-depth understanding about each metric.':
      'Få en djupare förståelse för varje mätvärde.',
    'Lean Mass (lbs)': 'Mager massa (lbs)',
    'Metabolic Age (years)': 'Metabolisk ålder (år)',
    'See Scan in Color': 'Visa skanning i färg',
    'Select a wellness group:': 'Välj en hälsogrupp:',
    'Select two scans to view compare:': 'Välj två skanningar att jämföra:',
    'Trunk to Leg Volume Ratio': 'Volymförhållande bål till ben',
    'User Error': 'Användarfel',
    'VAT Mass (lbs)': 'Visceral fettmassa (lbs)',
    'Ways to Improve': 'Sätt att förbättra',
    'Weight (lbs)': 'Vikt (lbs)',
    'Wellness Metric Comparisons': 'Jämförelser av hälsomätvärden',
    'Wellness Metrics': 'Hälsomätvärden',
    'What is it?': 'Vad är det?',
  },
  ja: {
    "'s Fit3D Comparison Report": '- Fit3D 比較レポート',
    Complete: '完了',
    Formula: '式',
    References: '参考文献',
    'Body Shape Rating (BSR)': '体型評価 (BSR)',
    'Fit3D Wellness Metrics Glossary': 'Fit3D ウェルネス指標用語集',
    'Gain a more in-depth understanding about each metric.':
      '各指標についてより深く理解できます。',
    'Lean Mass (lbs)': '除脂肪量 (lbs)',
    'Metabolic Age (years)': '代謝年齢（年）',
    'See Scan in Color': 'カラーでスキャンを表示',
    'Select a wellness group:': 'ウェルネスグループを選択:',
    'Select two scans to view compare:': '比較するスキャンを2つ選択:',
    'Trunk to Leg Volume Ratio': '体幹対脚部体積比',
    'User Error': 'ユーザーエラー',
    'VAT Mass (lbs)': '内臓脂肪量 (lbs)',
    'Ways to Improve': '改善方法',
    'Weight (lbs)': '体重 (lbs)',
    'Wellness Metric Comparisons': 'ウェルネス指標の比較',
    'Wellness Metrics': 'ウェルネス指標',
    'What is it?': 'これは何ですか？',
  },
  tr: {
    "'s Fit3D Comparison Report": '- Fit3D karşılaştırma raporu',
    Average: 'Ortalama',
    'Body Composition': 'Vücut Kompozisyonu',
    'Body Shape': 'Vücut Şekli',
    'Body Shape Rating': 'Vücut Şekli Puanı',
    Complete: 'Tamamlandı',
    'Fitness Level': 'Fitness Seviyesi',
    Formula: 'Formül',
    'How do I compare?': 'Nasıl karşılaştırırım?',
    Ideal: 'İdeal',
    'Needs Improvement': 'İyileştirme Gerekiyor',
    References: 'Referanslar',
    'Body Shape Rating (BSR)': 'Vücut şekli puanı (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      'Vücut Şekli Puanı (BSR), vücut şeklinizin kardiyovasküler risk faktörleriyle ilişkisine dayanan bir sağlık puanıdır. Şu soruya yanıt verir: Vücut şeklim belirli kardiyovasküler sağlık sorunları geliştirme olasılığımı artırıyor mu? BSR 0-100 aralığındadır; 50 ortalamadır ve puan yükseldikçe risk azalır.',
    'Fit3D Wellness Metrics Glossary': 'Fit3D sağlık metrikleri sözlüğü',
    'Gain a more in-depth understanding about each metric.':
      'Her metrik hakkında daha derin bir anlayış kazanın.',
    'Lean Mass (lbs)': 'Yağsız kütle (lbs)',
    'Metabolic Age (years)': 'Metabolik yaş (yıl)',
    'See Scan in Color': 'Taramayı renkli gör',
    'Select a wellness group:': 'Bir sağlık grubu seçin:',
    'Select two scans to view compare:':
      'Karşılaştırmak için iki tarama seçin:',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      'Aşağıdaki grafik, önerilen sağlıklı aralıklarla ve aynı cinsiyet ile benzer yaştaki diğer Fit3D kullanıcılarıyla nasıl karşılaştırıldığınızı gösterir.',
    'Trunk to Leg Volume Ratio': 'Gövde-bacak hacim oranı',
    'User Error': 'Kullanıcı hatası',
    'VAT Mass (lbs)': 'Visseral yağ kütlesi (lbs)',
    'Ways to Improve': 'İyileştirme yolları',
    'Weight (lbs)': 'Kilo (lbs)',
    'Wellness Metric Comparisons': 'Sağlık metriği karşılaştırmaları',
    'Wellness Metrics': 'Sağlık metrikleri',
    'What is it?': 'Nedir?',
    You: 'Siz',
  },
  cs: {
    "'s Fit3D Comparison Report": '- srovnávací zpráva Fit3D',
    Complete: 'Dokončeno',
    Formula: 'Vzorec',
    References: 'Reference',
    'Body Shape Rating (BSR)': 'Hodnocení tvaru těla (BSR)',
    'Fit3D Wellness Metrics Glossary': 'Slovník wellness metrik Fit3D',
    'Gain a more in-depth understanding about each metric.':
      'Získejte hlubší porozumění každé metrice.',
    'Lean Mass (lbs)': 'Beztuková hmota (lbs)',
    'Metabolic Age (years)': 'Metabolický věk (roky)',
    'See Scan in Color': 'Zobrazit sken barevně',
    'Select a wellness group:': 'Vyberte wellness skupinu:',
    'Select two scans to view compare:': 'Vyberte dva skeny k porovnání:',
    'Trunk to Leg Volume Ratio': 'Poměr objemu trupu k nohám',
    'User Error': 'Chyba uživatele',
    'VAT Mass (lbs)': 'Hmota viscerálního tuku (lbs)',
    'Ways to Improve': 'Způsoby zlepšení',
    'Weight (lbs)': 'Hmotnost (lbs)',
    'Wellness Metric Comparisons': 'Porovnání wellness metrik',
    'Wellness Metrics': 'Wellness metriky',
    'What is it?': 'Co to je?',
  },
  el: {
    "'s Fit3D Comparison Report": '- Αναφορά σύγκρισης Fit3D',
    Complete: 'Ολοκληρώθηκε',
    Formula: 'Τύπος',
    References: 'Αναφορές',
    'Body Shape Rating (BSR)': 'Βαθμολογία σχήματος σώματος (BSR)',
    'Fit3D Wellness Metrics Glossary': 'Γλωσσάρι μετρήσεων ευεξίας Fit3D',
    'Gain a more in-depth understanding about each metric.':
      'Αποκτήστε βαθύτερη κατανόηση κάθε μέτρησης.',
    'Lean Mass (lbs)': 'Άλιπη μάζα (lbs)',
    'Metabolic Age (years)': 'Μεταβολική ηλικία (έτη)',
    'See Scan in Color': 'Δείτε τη σάρωση με χρώμα',
    'Select a wellness group:': 'Επιλέξτε ομάδα ευεξίας:',
    'Select two scans to view compare:': 'Επιλέξτε δύο σαρώσεις για σύγκριση:',
    'Trunk to Leg Volume Ratio': 'Αναλογία όγκου κορμού προς πόδια',
    'User Error': 'Σφάλμα χρήστη',
    'VAT Mass (lbs)': 'Μάζα σπλαχνικού λίπους (lbs)',
    'Ways to Improve': 'Τρόποι βελτίωσης',
    'Weight (lbs)': 'Βάρος (lbs)',
    'Wellness Metric Comparisons': 'Συγκρίσεις μετρήσεων ευεξίας',
    'Wellness Metrics': 'Μετρήσεις ευεξίας',
    'What is it?': 'Τι είναι;',
  },
  hr: {
    "'s Fit3D Comparison Report": '- Fit3D usporedno izvješće',
    Complete: 'Dovršeno',
    Formula: 'Formula metrike',
    References: 'Reference',
    'Body Shape Rating (BSR)': 'Ocjena oblika tijela (BSR)',
    'Fit3D Wellness Metrics Glossary': 'Pojmovnik Fit3D wellness metrika',
    'Gain a more in-depth understanding about each metric.':
      'Steknite dublje razumijevanje svake metrike.',
    'Lean Mass (lbs)': 'Nemasna masa (lbs)',
    'Metabolic Age (years)': 'Metabolička dob (godine)',
    'See Scan in Color': 'Prikaži skeniranje u boji',
    'Select a wellness group:': 'Odaberite wellness grupu:',
    'Select two scans to view compare:':
      'Odaberite dva skeniranja za usporedbu:',
    'Trunk to Leg Volume Ratio': 'Omjer volumena trupa i nogu',
    'User Error': 'Korisnička pogreška',
    'VAT Mass (lbs)': 'Masa visceralne masti (lbs)',
    'Ways to Improve': 'Načini poboljšanja',
    'Weight (lbs)': 'Težina (lbs)',
    'Wellness Metric Comparisons': 'Usporedbe wellness metrika',
    'Wellness Metrics': 'Wellness metrike',
    'What is it?': 'Što je to?',
  },
}

const wellnessReportPhraseTranslations = {
  fr: {
    Average: 'Moyen',
    'Body Composition': 'Composition corporelle',
    'Body Shape': 'Forme corporelle',
    'Body Shape Rating': 'Note de forme corporelle',
    'Body Shape Rating (BSR)': 'Note de forme corporelle (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      'La note de forme corporelle (BSR) est un score de bien-être basé sur la relation entre votre forme corporelle et les facteurs de risque cardiovasculaire. Elle répond à la question : ma forme corporelle augmente-t-elle la probabilité de développer certains problèmes de santé cardiovasculaire ? La BSR va de 0 à 100, où 50 est la moyenne, et plus le score est élevé, plus le risque est faible.',
    'Fitness Level': 'Niveau de forme physique',
    'How do I compare?': 'Comment est-ce que je me situe ?',
    Ideal: 'Idéal',
    'Needs Improvement': 'À améliorer',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      'Le graphique ci-dessous montre comment vous vous situez par rapport aux plages de santé recommandées et aux autres utilisateurs Fit3D du même genre et d’un âge similaire.',
    'Wellness Metrics': 'Métriques de bien-être',
    You: 'Vous',
  },
  de: {
    Average: 'Durchschnitt',
    'Body Composition': 'Körperzusammensetzung',
    'Body Shape': 'Körperform',
    'Body Shape Rating': 'Körperformbewertung',
    'Body Shape Rating (BSR)': 'Körperformbewertung (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      'Die Körperformbewertung (BSR) ist ein Wellnesswert, der auf dem Zusammenhang zwischen Ihrer Körperform und kardiovaskulären Risikofaktoren basiert. Sie beantwortet die Frage: Erhöht meine Körperform die Wahrscheinlichkeit, bestimmte kardiovaskuläre Gesundheitsprobleme zu entwickeln? Die BSR liegt auf einer Skala von 0 bis 100, wobei 50 der Durchschnitt ist; je höher der Wert, desto geringer das Risiko.',
    'Fitness Level': 'Fitnessniveau',
    'How do I compare?': 'Wie vergleiche ich mich?',
    Ideal: 'Optimal',
    'Needs Improvement': 'Verbesserungsbedarf',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      'Das Diagramm unten zeigt, wie Sie im Vergleich zu empfohlenen gesunden Bereichen sowie zu anderen Fit3D-Nutzern gleichen Geschlechts und ähnlichen Alters abschneiden.',
    'Wellness Metrics': 'Gesundheitsmetriken',
    You: 'Sie',
  },
  es: {
    Average: 'Promedio',
    'Body Composition': 'Composición corporal',
    'Body Shape': 'Forma corporal',
    'Body Shape Rating': 'Calificación de forma corporal',
    'Body Shape Rating (BSR)': 'Calificación de forma corporal (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      'La calificación de forma corporal (BSR) es una puntuación de bienestar basada en la relación entre tu forma corporal y los factores de riesgo cardiovascular. Responde a la pregunta: ¿hace mi forma corporal más probable que desarrolle ciertos problemas de salud cardiovascular? La BSR va de 0 a 100, donde 50 es el promedio; cuanto más alta es la puntuación, menor es el riesgo.',
    'Fitness Level': 'Nivel de fitness',
    'How do I compare?': '¿Cómo me comparo?',
    Ideal: 'Óptimo',
    'Needs Improvement': 'Necesita mejorar',
    'Read More': 'Leer más',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      'El gráfico siguiente muestra cómo te comparas con los rangos saludables recomendados y con otros usuarios Fit3D del mismo género y edad similar.',
    'Wellness Metrics': 'Métricas de bienestar',
    You: 'Tú',
  },
  pt: {
    Average: 'Média',
    'Body Composition': 'Composição corporal',
    'Body Shape': 'Forma corporal',
    'Body Shape Rating': 'Classificação da forma corporal',
    'Body Shape Rating (BSR)': 'Classificação da forma corporal (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      'A Classificação da forma corporal (BSR) é uma pontuação de bem-estar baseada na relação entre a forma do seu corpo e fatores de risco cardiovascular. Ela responde à pergunta: a forma do meu corpo aumenta a probabilidade de eu desenvolver certos problemas de saúde cardiovascular? A BSR fica em uma escala de 0 a 100, em que 50 é a média; quanto maior a pontuação, menor o risco.',
    'Fitness Level': 'Nível de condicionamento físico',
    'How do I compare?': 'Como me comparo?',
    Ideal: 'Ótimo',
    'Needs Improvement': 'Precisa melhorar',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      'O gráfico abaixo mostra como você se compara às faixas saudáveis recomendadas e a outros usuários Fit3D do mesmo gênero e idade semelhante.',
    'Wellness Metrics': 'Métricas de bem-estar',
    You: 'Você',
  },
  zh_CN: {
    Average: '平均',
    'Body Composition': '身体成分',
    'Body Shape': '体型',
    'Body Shape Rating': '体型评分',
    'Body Shape Rating (BSR)': '体型评分 (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      '体型评分 (BSR) 是基于您的体型与心血管相关风险因素之间关系的健康评分。它回答的问题是：我的体型是否会增加我出现某些心血管相关健康问题的可能性？BSR 的范围为 0 到 100，50 为平均值；分数越高，风险越低。',
    'Fitness Level': '体能水平',
    'How do I compare?': '我如何比较？',
    Ideal: '理想',
    'Needs Improvement': '需要改善',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      '下方图表显示您与推荐健康范围的比较，以及您与同性别、相近年龄的其他 Fit3D 用户的比较。',
    'Wellness Metrics': '健康指标',
    You: '您',
  },
  zh_TW: {
    Average: '平均',
    'Body Composition': '身體組成',
    'Body Shape': '體型',
    'Body Shape Rating': '體型評分',
    'Body Shape Rating (BSR)': '體型評分 (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      '體型評分 (BSR) 是根據您的體型與心血管相關風險因素之間的關係所計算的健康分數。它回答的問題是：我的體型是否會增加我發生某些心血管相關健康問題的可能性？BSR 範圍為 0 到 100，50 為平均值；分數越高，風險越低。',
    'Fitness Level': '體能水平',
    'How do I compare?': '我如何比較？',
    Ideal: '理想',
    'Needs Improvement': '需要改善',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      '下方圖表顯示您與建議健康範圍的比較，以及您與同性別、相近年齡的其他 Fit3D 使用者的比較。',
    'Wellness Metrics': '健康指標',
    You: '您',
  },
  it: {
    '% of Scans': '% di scansioni',
    Average: 'Medio',
    'Body Composition': 'Composizione corporea',
    'Body Shape': 'Forma corporea',
    'Body Shape Rating': 'Valutazione della forma corporea',
    'Body Shape Rating (BSR)': 'Valutazione della forma corporea (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      'La Valutazione della forma corporea (BSR) è un punteggio di benessere basato sulla relazione tra la forma del corpo e i fattori di rischio cardiovascolare. Risponde alla domanda: la forma del mio corpo aumenta la probabilità di sviluppare determinati problemi di salute cardiovascolare? La BSR va da 0 a 100, dove 50 è la media; più alto è il punteggio, minore è il rischio.',
    'Fitness Level': 'Livello di fitness',
    'How do I compare?': 'Come mi confronto?',
    Ideal: 'Ideale',
    'Metabolic Age': 'Età metabolica',
    'Needs Improvement': 'Da migliorare',
    'Read More': 'Leggi di più',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      'Il grafico qui sotto mostra come ti confronti con gli intervalli salutari consigliati e con altri utenti Fit3D dello stesso genere e di età simile.',
    'Waist Circumference': 'Circonferenza vita',
    'Waist to Hip Ratio': 'Rapporto vita-fianchi',
    'Wellness Metrics': 'Metriche di benessere',
    You: 'Tu',
  },
  ko: {
    Average: '평균',
    'Body Composition': '신체 구성',
    'Body Shape': '체형',
    'Body Shape Rating': '체형 등급',
    'Body Shape Rating (BSR)': '체형 등급 (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      '체형 등급(BSR)은 체형과 심혈관 관련 위험 요인의 관계를 기반으로 한 웰니스 점수입니다. 이는 내 체형이 특정 심혈관 관련 건강 문제가 생길 가능성을 높이는지에 답합니다. BSR은 0~100 범위이며 50이 평균이고, 점수가 높을수록 위험이 낮습니다.',
    'Fitness Level': '체력 수준',
    'How do I compare?': '나는 어떻게 비교되나요?',
    Ideal: '이상적',
    'Needs Improvement': '개선 필요',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      '아래 차트는 권장 건강 범위와 비교했을 때, 그리고 같은 성별과 비슷한 나이의 다른 Fit3D 사용자와 비교했을 때의 위치를 보여줍니다.',
    'Wellness Metrics': '웰니스 지표',
    You: '나',
  },
  nl: {
    Average: 'Gemiddeld',
    'Body Composition': 'Lichaamssamenstelling',
    'Body Shape': 'Lichaamsvorm',
    'Body Shape Rating': 'Lichaamsvormscore',
    'Body Shape Rating (BSR)': 'Lichaamsvormscore (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      'De lichaamsvormscore (BSR) is een welzijnsscore op basis van de relatie tussen uw lichaamsvorm en cardiovasculaire risicofactoren. Deze beantwoordt de vraag: maakt mijn lichaamsvorm het waarschijnlijker dat ik bepaalde cardiovasculaire gezondheidsproblemen ontwikkel? De BSR loopt van 0 tot 100, waarbij 50 gemiddeld is; hoe hoger de score, hoe lager het risico.',
    'Fitness Level': 'Fitnessniveau',
    'How do I compare?': 'Hoe vergelijk ik?',
    Ideal: 'Ideaal',
    'Needs Improvement': 'Moet worden verbeterd',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      'De onderstaande grafiek laat zien hoe u zich verhoudt tot aanbevolen gezonde bereiken en tot andere Fit3D-gebruikers met hetzelfde geslacht en een vergelijkbare leeftijd.',
    'Wellness Metrics': 'Welzijnsmetingen',
    You: 'U',
  },
  fi: {
    Average: 'Keskitaso',
    'Body Composition': 'Kehonkoostumus',
    'Body Shape': 'Kehon muoto',
    'Body Shape Rating': 'Kehon muodon arvio',
    'Body Shape Rating (BSR)': 'Kehon muodon arvio (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      'Kehon muodon arvio (BSR) on hyvinvointipisteytys, joka perustuu kehon muodon ja sydän- ja verisuonitautien riskitekijöiden väliseen suhteeseen. Se vastaa kysymykseen: lisääkö kehon muotoni todennäköisyyttä kehittää tiettyjä sydän- ja verisuoniterveyteen liittyviä ongelmia? BSR on asteikolla 0-100, jossa 50 on keskiarvo; mitä korkeampi pistemäärä, sitä pienempi riski.',
    'Fitness Level': 'Kuntotaso',
    'How do I compare?': 'Miten vertaudun?',
    Ideal: 'Ihanteellinen',
    'Needs Improvement': 'Parannettavaa',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      'Alla oleva kaavio näyttää, miten vertaudut suositeltuihin terveellisiin vaihteluväleihin sekä muihin saman sukupuolen ja samanikäisiin Fit3D-käyttäjiin.',
    'Wellness Metrics': 'Hyvinvointimittarit',
    You: 'Sinä',
  },
  ru: {
    Average: 'Средний',
    'Body Composition': 'Состав тела',
    'Body Shape': 'Форма тела',
    'Body Shape Rating': 'Оценка формы тела',
    'Body Shape Rating (BSR)': 'Оценка формы тела (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      'Оценка формы тела (BSR) — это показатель здоровья, основанный на связи между формой вашего тела и факторами риска сердечно-сосудистых заболеваний. Она отвечает на вопрос: повышает ли форма моего тела вероятность развития определенных сердечно-сосудистых проблем? BSR находится в диапазоне от 0 до 100, где 50 — среднее значение; чем выше оценка, тем ниже риск.',
    'Fitness Level': 'Уровень физической формы',
    'How do I compare?': 'Как я сравниваюсь?',
    Ideal: 'Идеально',
    'Needs Improvement': 'Требует улучшения',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      'На графике ниже показано, как вы соотноситесь с рекомендуемыми здоровыми диапазонами, а также с другими пользователями Fit3D того же пола и похожего возраста.',
    'Wellness Metrics': 'Показатели здоровья',
    You: 'Вы',
  },
  sv: {
    Average: 'Genomsnitt',
    'Body Composition': 'Kroppssammansättning',
    'Body Shape': 'Kroppsform',
    'Body Shape Rating': 'Kroppsformsbetyg',
    'Body Shape Rating (BSR)': 'Kroppsformsbetyg (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      'Kroppsformsbetyg (BSR) är ett hälsomått baserat på sambandet mellan din kroppsform och kardiovaskulära riskfaktorer. Det besvarar frågan: gör min kroppsform det mer sannolikt att jag utvecklar vissa kardiovaskulära hälsoproblem? BSR ligger på en skala från 0 till 100, där 50 är genomsnittet; ju högre poäng, desto lägre risk.',
    'Fitness Level': 'Konditionsnivå',
    'How do I compare?': 'Hur jämför jag mig?',
    Ideal: 'Idealiskt',
    'Needs Improvement': 'Behöver förbättras',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      'Diagrammet nedan visar hur du ligger till jämfört med rekommenderade hälsosamma intervall samt med andra Fit3D-användare med samma kön och liknande ålder.',
    'Wellness Metrics': 'Hälsomätvärden',
    You: 'Du',
  },
  ja: {
    Average: '平均',
    'Body Composition': '体組成',
    'Body Shape': '体型',
    'Body Shape Rating': '体型評価',
    'Body Shape Rating (BSR)': '体型評価 (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      '体型評価 (BSR) は、体型と心血管関連リスク要因との関係に基づくウェルネススコアです。これは「自分の体型が特定の心血管関連の健康問題を発症する可能性を高めているか」という問いに答えます。BSR は 0 から 100 の範囲で、50 が平均です。スコアが高いほどリスクは低くなります。',
    'Fitness Level': 'フィットネスレベル',
    'How do I compare?': '自分はどう比較されますか？',
    Ideal: '理想',
    'Needs Improvement': '改善が必要',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      '下のグラフは、推奨される健康的な範囲との比較、および同じ性別で年齢が近い他の Fit3D ユーザーとの比較を示しています。',
    'Wellness Metrics': 'ウェルネス指標',
    You: 'あなた',
  },
  tr: {
    Average: 'Ortalama',
    'Body Composition': 'Vücut Kompozisyonu',
    'Body Shape': 'Vücut Şekli',
    'Body Shape Rating': 'Vücut Şekli Puanı',
    'Body Shape Rating (BSR)': 'Vücut şekli puanı (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      'Vücut Şekli Puanı (BSR), vücut şeklinizin kardiyovasküler risk faktörleriyle ilişkisine dayanan bir sağlık puanıdır. Şu soruya yanıt verir: Vücut şeklim belirli kardiyovasküler sağlık sorunları geliştirme olasılığımı artırıyor mu? BSR 0-100 aralığındadır; 50 ortalamadır ve puan yükseldikçe risk azalır.',
    'Fitness Level': 'Fitness Seviyesi',
    'How do I compare?': 'Nasıl karşılaştırırım?',
    Ideal: 'İdeal',
    'Needs Improvement': 'İyileştirme Gerekiyor',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      'Aşağıdaki grafik, önerilen sağlıklı aralıklarla ve aynı cinsiyet ile benzer yaştaki diğer Fit3D kullanıcılarıyla nasıl karşılaştırıldığınızı gösterir.',
    'Wellness Metrics': 'Sağlık metrikleri',
    You: 'Siz',
  },
  cs: {
    Average: 'Průměr',
    'Body Composition': 'Složení těla',
    'Body Shape': 'Tvar těla',
    'Body Shape Rating': 'Hodnocení tvaru těla',
    'Body Shape Rating (BSR)': 'Hodnocení tvaru těla (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      'Hodnocení tvaru těla (BSR) je zdravotní skóre založené na vztahu mezi tvarem vašeho těla a rizikovými faktory souvisejícími s kardiovaskulárním zdravím. Odpovídá na otázku: zvyšuje tvar mého těla pravděpodobnost vzniku určitých kardiovaskulárních zdravotních problémů? BSR je na škále 0-100, kde 50 je průměr; čím vyšší skóre, tím nižší riziko.',
    'Fitness Level': 'Úroveň kondice',
    'How do I compare?': 'Jak se porovnávám?',
    Ideal: 'Ideální',
    'Needs Improvement': 'Vyžaduje zlepšení',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      'Graf níže ukazuje, jak si stojíte vůči doporučeným zdravým rozmezím a vůči ostatním uživatelům Fit3D stejného pohlaví a podobného věku.',
    'Wellness Metrics': 'Zdravotní metriky',
    You: 'Vy',
  },
  el: {
    Average: 'Μέσος όρος',
    'Body Composition': 'Σύσταση σώματος',
    'Body Shape': 'Σχήμα σώματος',
    'Body Shape Rating': 'Βαθμολογία σχήματος σώματος',
    'Body Shape Rating (BSR)': 'Βαθμολογία σχήματος σώματος (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      'Η Βαθμολογία σχήματος σώματος (BSR) είναι μια βαθμολογία ευεξίας που βασίζεται στη σχέση ανάμεσα στο σχήμα του σώματός σας και τους παράγοντες καρδιαγγειακού κινδύνου. Απαντά στην ερώτηση: κάνει το σχήμα του σώματός μου πιο πιθανό να αναπτύξω ορισμένα καρδιαγγειακά προβλήματα υγείας; Η BSR είναι σε κλίμακα 0-100, όπου το 50 είναι ο μέσος όρος· όσο υψηλότερη είναι η βαθμολογία, τόσο χαμηλότερος είναι ο κίνδυνος.',
    'Fitness Level': 'Επίπεδο φυσικής κατάστασης',
    'How do I compare?': 'Πώς συγκρίνομαι;',
    Ideal: 'Ιδανικό',
    'Needs Improvement': 'Χρειάζεται βελτίωση',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      'Το παρακάτω γράφημα δείχνει πώς συγκρίνεστε με τα συνιστώμενα υγιή εύρη, καθώς και με άλλους χρήστες Fit3D του ίδιου φύλου και παρόμοιας ηλικίας.',
    'Wellness Metrics': 'Μετρήσεις ευεξίας',
    You: 'Εσείς',
  },
  hr: {
    Average: 'Prosjek',
    'Body Composition': 'Sastav tijela',
    'Body Shape': 'Oblik tijela',
    'Body Shape Rating': 'Ocjena oblika tijela',
    'Body Shape Rating (BSR)': 'Ocjena oblika tijela (BSR)',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      'Ocjena oblika tijela (BSR) zdravstveni je rezultat temeljen na odnosu između oblika vašeg tijela i čimbenika kardiovaskularnog rizika. Odgovara na pitanje: povećava li oblik mojeg tijela vjerojatnost razvoja određenih kardiovaskularnih zdravstvenih problema? BSR je na ljestvici od 0 do 100, gdje je 50 prosjek; što je rezultat viši, to je rizik manji.',
    'Fitness Level': 'Razina kondicije',
    'How do I compare?': 'Kako se uspoređujem?',
    Ideal: 'Idealno',
    'Needs Improvement': 'Potrebno poboljšanje',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      'Grafikon u nastavku prikazuje kako se uspoređujete s preporučenim zdravim rasponima te s drugim Fit3D korisnicima istog spola i slične dobi.',
    'Wellness Metrics': 'Zdravstvene metrike',
    You: 'Vi',
  },
}

const fullReportPhraseTranslations = {
  fr: {
    'Show Silhouettes': 'Afficher les silhouettes',
    'Waist Circumference': 'Tour de taille',
    'Waist to Hip Ratio': 'Rapport taille-hanches',
    '% of Scans': '% des numérisations',
  },
  de: {
    'Show Silhouettes': 'Silhouetten anzeigen',
    'Waist Circumference': 'Taillenumfang',
    'Waist to Hip Ratio': 'Taille-Hüfte-Verhältnis',
    '% of Scans': '% der Körpermessungen',
  },
  es: {
    'Show Silhouettes': 'Mostrar siluetas',
    'Waist Circumference': 'Circunferencia de cintura',
    'Waist to Hip Ratio': 'Relación cintura-cadera',
    '% of Scans': '% de escaneos',
  },
  pt: {
    'Show Silhouettes': 'Mostrar silhuetas',
    'Waist Circumference': 'Circunferência da cintura',
    'Waist to Hip Ratio': 'Relação cintura-quadril',
    '% of Scans': '% de escaneamentos',
  },
  zh_CN: {
    'Show Silhouettes': '显示轮廓',
    'Waist Circumference': '腰围',
    'Waist to Hip Ratio': '腰臀比',
    '% of Scans': '扫描百分比',
  },
  zh_TW: {
    'Show Silhouettes': '顯示輪廓',
    'Waist Circumference': '腰圍',
    'Waist to Hip Ratio': '腰臀比',
    '% of Scans': '掃描百分比',
  },
  it: {
    'Show Silhouettes': 'Mostra sagome',
    'Waist Circumference': 'Circonferenza vita',
    'Waist to Hip Ratio': 'Rapporto vita-fianchi',
    '% of Scans': '% di scansioni',
  },
  ko: {
    'Show Silhouettes': '실루엣 표시',
    'Waist Circumference': '허리둘레',
    'Waist to Hip Ratio': '허리-엉덩이 비율',
    '% of Scans': '스캔 비율',
  },
  nl: {
    'Show Silhouettes': 'Silhouetten tonen',
    'Waist Circumference': 'Tailleomtrek',
    'Waist to Hip Ratio': 'Taille-heupverhouding',
    '% of Scans': '% van metingen',
  },
  fi: {
    'Show Silhouettes': 'Näytä siluetit',
    'Waist Circumference': 'Vyötärönympärys',
    'Waist to Hip Ratio': 'Vyötärö-lantiosuhde',
    '% of Scans': '% skannauksista',
  },
  ru: {
    'Show Silhouettes': 'Показать силуэты',
    'Waist Circumference': 'Окружность талии',
    'Waist to Hip Ratio': 'Соотношение талии и бёдер',
    '% of Scans': '% сканирований',
  },
  sv: {
    'Show Silhouettes': 'Visa silhuetter',
    'Waist Circumference': 'Midjeomkrets',
    'Waist to Hip Ratio': 'Midja-höftkvot',
    '% of Scans': '% av skanningar',
  },
  ja: {
    'Show Silhouettes': 'シルエットを表示',
    'Waist Circumference': '腹囲',
    'Waist to Hip Ratio': 'ウエスト・ヒップ比',
    '% of Scans': 'スキャンの割合',
  },
  tr: {
    'Show Silhouettes': 'Siluetleri göster',
    'Waist Circumference': 'Bel çevresi',
    'Waist to Hip Ratio': 'Bel-kalça oranı',
    '% of Scans': 'Taramaların yüzdesi',
  },
  cs: {
    'Show Silhouettes': 'Zobrazit siluety',
    'Waist Circumference': 'Obvod pasu',
    'Waist to Hip Ratio': 'Poměr pasu a boků',
    '% of Scans': '% skenů',
  },
  el: {
    'Show Silhouettes': 'Εμφάνιση περιγραμμάτων',
    'Waist Circumference': 'Περίμετρος μέσης',
    'Waist to Hip Ratio': 'Αναλογία μέσης προς γοφούς',
    '% of Scans': '% των σαρώσεων',
  },
  hr: {
    'Show Silhouettes': 'Prikaži siluete',
    'Waist Circumference': 'Opseg struka',
    'Waist to Hip Ratio': 'Omjer struka i bokova',
    '% of Scans': '% skeniranja',
  },
}

const coachRenderedPagePhraseTranslations = {
  fr: {
    'Add Coaches': 'Ajouter des coachs',
    'Coach Access Level': "Niveau d'accès du coach",
    'Coach cannot see client results':
      'Le coach ne peut pas voir les résultats du client',
    "Coach is able to see client's result data, but not scan images":
      'Le coach peut voir les résultats du client, mais pas les images de scan',
    "Coach is able to see client's results data and scan images":
      'Le coach peut voir les résultats du client et les images de scan',
    Delete: 'Supprimer',
    Filter: 'Filtrer',
    First: 'Premier',
    'First Name': 'Prénom',
    Full: 'Complet',
    'Full Access': 'Accès complet',
    Last: 'Dernier',
    'Last Name': 'Nom',
    Limited: 'Limité',
    'Limited Access': 'Accès limité',
    'Manage Coaches': 'Gérer les coachs',
    'No Access': 'Aucun accès',
    'Select Page Size:': 'Sélectionner la taille de page :',
  },
  de: {
    'Add Coaches': 'Coaches hinzufügen',
    'Coach Access Level': 'Coach-Zugriffsebene',
    'Coach cannot see client results':
      'Der Coach kann Kundenergebnisse nicht sehen',
    "Coach is able to see client's result data, but not scan images":
      'Der Coach kann Kundenergebnisdaten sehen, aber keine Scanbilder',
    "Coach is able to see client's results data and scan images":
      'Der Coach kann Kundenergebnisdaten und Scanbilder sehen',
    Delete: 'Löschen',
    Filter: 'Filtern',
    First: 'Erste',
    'First Name': 'Vorname',
    Full: 'Voll',
    'Full Access': 'Vollzugriff',
    Last: 'Letzte',
    'Last Name': 'Nachname',
    Limited: 'Begrenzt',
    'Limited Access': 'Begrenzter Zugriff',
    'Manage Coaches': 'Coaches verwalten',
    'No Access': 'Kein Zugriff',
    'Select Page Size:': 'Seitengröße auswählen:',
  },
  es: {
    'Add Coaches': 'Añadir entrenadores',
    'Coach Access Level': 'Nivel de acceso del entrenador',
    'Coach cannot see client results':
      'El entrenador no puede ver los resultados del cliente',
    "Coach is able to see client's result data, but not scan images":
      'El entrenador puede ver los resultados del cliente, pero no las imágenes del escaneo',
    "Coach is able to see client's results data and scan images":
      'El entrenador puede ver los resultados del cliente y las imágenes del escaneo',
    Delete: 'Eliminar',
    Filter: 'Filtrar',
    First: 'Primero',
    'First Name': 'Nombre',
    Full: 'Completo',
    'Full Access': 'Acceso completo',
    Last: 'Último',
    'Last Name': 'Apellido',
    Limited: 'Limitado',
    'Limited Access': 'Acceso limitado',
    'Manage Coaches': 'Gestionar entrenadores',
    'No Access': 'Sin acceso',
    'Select Page Size:': 'Seleccionar tamaño de página:',
  },
  pt: {
    'Add Coaches': 'Adicionar coaches',
    'Coach Access Level': 'Nível de acesso do coach',
    'Coach cannot see client results':
      'O coach não pode ver os resultados do cliente',
    "Coach is able to see client's result data, but not scan images":
      'O coach pode ver os dados de resultados do cliente, mas não as imagens do scan',
    "Coach is able to see client's results data and scan images":
      'O coach pode ver os dados de resultados do cliente e as imagens do scan',
    Delete: 'Excluir',
    Filter: 'Filtrar',
    First: 'Primeiro',
    'First Name': 'Nome',
    Full: 'Completo',
    'Full Access': 'Acesso completo',
    Last: 'Último',
    'Last Name': 'Sobrenome',
    Limited: 'Limitado',
    'Limited Access': 'Acesso limitado',
    'Manage Coaches': 'Gerenciar coaches',
    'No Access': 'Sem acesso',
    'Select Page Size:': 'Selecionar tamanho da página:',
  },
  zh_CN: {
    'Add Coaches': '添加教练',
    'Coach Access Level': '教练访问级别',
    'Coach cannot see client results': '教练无法查看客户结果',
    "Coach is able to see client's result data, but not scan images":
      '教练可以查看客户结果数据，但不能查看扫描图像',
    "Coach is able to see client's results data and scan images":
      '教练可以查看客户结果数据和扫描图像',
    Delete: '删除',
    Filter: '筛选',
    First: '首页',
    'First Name': '名字',
    Full: '完整',
    'Full Access': '完整访问权限',
    Last: '末页',
    'Last Name': '姓氏',
    Limited: '受限',
    'Limited Access': '受限访问权限',
    'Manage Coaches': '管理教练',
    'No Access': '无访问权限',
    'Select Page Size:': '选择页面大小：',
  },
  zh_TW: {
    'Add Coaches': '新增教練',
    'Coach Access Level': '教練存取層級',
    'Coach cannot see client results': '教練無法查看客戶結果',
    "Coach is able to see client's result data, but not scan images":
      '教練可以查看客戶結果資料，但不能查看掃描影像',
    "Coach is able to see client's results data and scan images":
      '教練可以查看客戶結果資料和掃描影像',
    Delete: '刪除',
    Filter: '篩選',
    First: '首頁',
    'First Name': '名字',
    Full: '完整',
    'Full Access': '完整存取權',
    Last: '末頁',
    'Last Name': '姓氏',
    Limited: '受限',
    'Limited Access': '受限存取權',
    'Manage Coaches': '管理教練',
    'No Access': '無存取權',
    'Select Page Size:': '選擇頁面大小：',
  },
  it: {
    'Add Coaches': 'Aggiungi allenatori',
    'Add as Coach': 'Aggiungi come allenatore',
    'Add/Remove Coaches': 'Aggiungi/rimuovi allenatori',
    'Coach Access Level': "Livello di accesso dell'allenatore",
    'Coach cannot see client results':
      "L'allenatore non può vedere i risultati del cliente",
    "Coach is able to see client's result data, but not scan images":
      "L'allenatore può vedere i dati dei risultati del cliente, ma non le immagini della scansione",
    "Coach is able to see client's results data and scan images":
      "L'allenatore può vedere i dati dei risultati del cliente e le immagini della scansione",
    'Coaches Only': 'Solo allenatori',
    Delete: 'Elimina',
    'E-mail': 'E-mail',
    Filter: 'Filtra',
    First: 'Primo',
    'First Name': 'Nome',
    Full: 'Completo',
    'Full Access': 'Accesso completo',
    Last: 'Ultimo',
    'Last Name': 'Cognome',
    Limited: 'Limitato',
    'Limited Access': 'Accesso limitato',
    'Mock Client Comparison': 'Confronto cliente demo',
    'Mock client comparison page provides two':
      'La pagina di confronto del cliente demo mostra due',
    'No Access': 'Nessun accesso',
    'Reload Client Records': 'Ricarica record clienti',
    'Remove as Coach': 'Rimuovi come allenatore',
    'Search Clients (Name or E-mail)': 'Cerca clienti (nome o e-mail)',
    Search: 'Cerca',
    'Select Page Size:': 'Seleziona dimensione pagina:',
    'Signup Date': 'Data di registrazione',
    Type: 'Tipo',
    'Front View': 'Vista frontale',
    'Side View': 'Vista laterale',
    screenshots: 'schermate',
    '(front & side) the client comparison page.':
      '(frontale e laterale) della pagina di confronto del cliente.',
  },
  ko: {
    'Add Coaches': '코치 추가',
    'Coach Access Level': '코치 접근 수준',
    'Coach cannot see client results': '코치는 고객 결과를 볼 수 없습니다',
    "Coach is able to see client's result data, but not scan images":
      '코치는 고객 결과 데이터는 볼 수 있지만 스캔 이미지는 볼 수 없습니다',
    "Coach is able to see client's results data and scan images":
      '코치는 고객 결과 데이터와 스캔 이미지를 볼 수 있습니다',
    Delete: '삭제',
    Filter: '필터',
    First: '처음',
    'First Name': '이름',
    Full: '전체',
    'Full Access': '전체 접근',
    Last: '마지막',
    'Last Name': '성',
    Limited: '제한됨',
    'Limited Access': '제한된 접근',
    'Manage Coaches': '코치 관리',
    'No Access': '접근 없음',
    'Select Page Size:': '페이지 크기 선택:',
  },
  nl: {
    'Add Coaches': 'Coaches toevoegen',
    'Coach Access Level': 'Toegangsniveau coach',
    'Coach cannot see client results':
      'De coach kan de resultaten van de klant niet zien',
    "Coach is able to see client's result data, but not scan images":
      'De coach kan resultaatgegevens van de klant zien, maar geen scanafbeeldingen',
    "Coach is able to see client's results data and scan images":
      'De coach kan resultaatgegevens en scanafbeeldingen van de klant zien',
    Delete: 'Verwijderen',
    Filter: 'Filteren',
    First: 'Eerste',
    'First Name': 'Voornaam',
    Full: 'Volledig',
    'Full Access': 'Volledige toegang',
    Last: 'Laatste',
    'Last Name': 'Achternaam',
    Limited: 'Beperkt',
    'Limited Access': 'Beperkte toegang',
    'Manage Coaches': 'Coaches beheren',
    'No Access': 'Geen toegang',
    'Select Page Size:': 'Paginagrootte selecteren:',
  },
  fi: {
    'Add Coaches': 'Lisää valmentajia',
    'Coach Access Level': 'Valmentajan käyttöoikeustaso',
    'Coach cannot see client results':
      'Valmentaja ei voi nähdä asiakkaan tuloksia',
    "Coach is able to see client's result data, but not scan images":
      'Valmentaja voi nähdä asiakkaan tulostiedot, mutta ei skannauskuvia',
    "Coach is able to see client's results data and scan images":
      'Valmentaja voi nähdä asiakkaan tulostiedot ja skannauskuvat',
    Delete: 'Poista',
    Filter: 'Suodata',
    First: 'Ensimmäinen',
    'First Name': 'Etunimi',
    Full: 'Täysi',
    'Full Access': 'Täysi käyttöoikeus',
    Last: 'Viimeinen',
    'Last Name': 'Sukunimi',
    Limited: 'Rajoitettu',
    'Limited Access': 'Rajoitettu käyttöoikeus',
    'Manage Coaches': 'Hallinnoi valmentajia',
    'No Access': 'Ei käyttöoikeutta',
    'Select Page Size:': 'Valitse sivukoko:',
  },
  ru: {
    'Add Coaches': 'Добавить тренеров',
    'Coach Access Level': 'Уровень доступа тренера',
    'Coach cannot see client results':
      'Тренер не может видеть результаты клиента',
    "Coach is able to see client's result data, but not scan images":
      'Тренер может видеть данные результатов клиента, но не изображения скана',
    "Coach is able to see client's results data and scan images":
      'Тренер может видеть данные результатов клиента и изображения скана',
    Delete: 'Удалить',
    Filter: 'Фильтр',
    First: 'Первая',
    'First Name': 'Имя',
    Full: 'Полный',
    'Full Access': 'Полный доступ',
    Last: 'Последняя',
    'Last Name': 'Фамилия',
    Limited: 'Ограниченный',
    'Limited Access': 'Ограниченный доступ',
    'Manage Coaches': 'Управление тренерами',
    'No Access': 'Нет доступа',
    'Select Page Size:': 'Выберите размер страницы:',
  },
  sv: {
    'Add Coaches': 'Lägg till coacher',
    'Coach Access Level': 'Coachens åtkomstnivå',
    'Coach cannot see client results': 'Coachen kan inte se klientens resultat',
    "Coach is able to see client's result data, but not scan images":
      'Coachen kan se klientens resultatdata, men inte skanningsbilder',
    "Coach is able to see client's results data and scan images":
      'Coachen kan se klientens resultatdata och skanningsbilder',
    Delete: 'Ta bort',
    Filter: 'Filtrera',
    First: 'Första',
    'First Name': 'Förnamn',
    Full: 'Fullständig',
    'Full Access': 'Full åtkomst',
    Last: 'Sista',
    'Last Name': 'Efternamn',
    Limited: 'Begränsad',
    'Limited Access': 'Begränsad åtkomst',
    'Manage Coaches': 'Hantera coacher',
    'No Access': 'Ingen åtkomst',
    'Select Page Size:': 'Välj sidstorlek:',
  },
  ja: {
    'Add Coaches': 'コーチを追加',
    'Coach Access Level': 'コーチのアクセスレベル',
    'Coach cannot see client results':
      'コーチはクライアントの結果を表示できません',
    "Coach is able to see client's result data, but not scan images":
      'コーチはクライアントの結果データを表示できますが、スキャン画像は表示できません',
    "Coach is able to see client's results data and scan images":
      'コーチはクライアントの結果データとスキャン画像を表示できます',
    Delete: '削除',
    Filter: 'フィルター',
    First: '最初',
    'First Name': '名',
    Full: 'フル',
    'Full Access': 'フルアクセス',
    Last: '最後',
    'Last Name': '姓',
    Limited: '制限付き',
    'Limited Access': '制限付きアクセス',
    'Manage Coaches': 'コーチを管理',
    'No Access': 'アクセスなし',
    'Select Page Size:': 'ページサイズを選択:',
  },
  tr: {
    'Add Coaches': 'Koç ekle',
    'Coach Access Level': 'Koç erişim düzeyi',
    'Coach cannot see client results': 'Koç müşteri sonuçlarını göremez',
    "Coach is able to see client's result data, but not scan images":
      'Koç müşterinin sonuç verilerini görebilir, ancak tarama görüntülerini göremez',
    "Coach is able to see client's results data and scan images":
      'Koç müşterinin sonuç verilerini ve tarama görüntülerini görebilir',
    Delete: 'Sil',
    Filter: 'Filtrele',
    First: 'İlk',
    'First Name': 'Ad',
    Full: 'Tam',
    'Full Access': 'Tam erişim',
    Last: 'Son',
    'Last Name': 'Soyad',
    Limited: 'Sınırlı',
    'Limited Access': 'Sınırlı erişim',
    'Manage Coaches': 'Koçları yönet',
    'No Access': 'Erişim yok',
    'Select Page Size:': 'Sayfa boyutu seç:',
  },
  cs: {
    'Add Coaches': 'Přidat trenéry',
    'Coach Access Level': 'Úroveň přístupu trenéra',
    'Coach cannot see client results': 'Trenér nemůže vidět výsledky klienta',
    "Coach is able to see client's result data, but not scan images":
      'Trenér může vidět výsledková data klienta, ale ne obrázky skenu',
    "Coach is able to see client's results data and scan images":
      'Trenér může vidět výsledková data klienta a obrázky skenu',
    Delete: 'Odstranit',
    Filter: 'Filtrovat',
    First: 'První',
    'First Name': 'Jméno',
    Full: 'Plný',
    'Full Access': 'Plný přístup',
    Last: 'Poslední',
    'Last Name': 'Příjmení',
    Limited: 'Omezený',
    'Limited Access': 'Omezený přístup',
    'Manage Coaches': 'Spravovat trenéry',
    'No Access': 'Bez přístupu',
    'Select Page Size:': 'Vyberte velikost stránky:',
  },
  el: {
    'Add Coaches': 'Προσθήκη προπονητών',
    'Coach Access Level': 'Επίπεδο πρόσβασης προπονητή',
    'Coach cannot see client results':
      'Ο προπονητής δεν μπορεί να δει τα αποτελέσματα του πελάτη',
    "Coach is able to see client's result data, but not scan images":
      'Ο προπονητής μπορεί να δει τα δεδομένα αποτελεσμάτων του πελάτη, αλλά όχι τις εικόνες σάρωσης',
    "Coach is able to see client's results data and scan images":
      'Ο προπονητής μπορεί να δει τα δεδομένα αποτελεσμάτων του πελάτη και τις εικόνες σάρωσης',
    Delete: 'Διαγραφή',
    Filter: 'Φίλτρο',
    First: 'Πρώτη',
    'First Name': 'Όνομα',
    Full: 'Πλήρης',
    'Full Access': 'Πλήρης πρόσβαση',
    Last: 'Τελευταία',
    'Last Name': 'Επώνυμο',
    Limited: 'Περιορισμένη',
    'Limited Access': 'Περιορισμένη πρόσβαση',
    'Manage Coaches': 'Διαχείριση προπονητών',
    'No Access': 'Χωρίς πρόσβαση',
    'Select Page Size:': 'Επιλέξτε μέγεθος σελίδας:',
  },
  hr: {
    'Add Coaches': 'Dodaj trenere',
    'Coach Access Level': 'Razina pristupa trenera',
    'Coach cannot see client results':
      'Trener ne može vidjeti rezultate klijenta',
    "Coach is able to see client's result data, but not scan images":
      'Trener može vidjeti podatke rezultata klijenta, ali ne i slike skeniranja',
    "Coach is able to see client's results data and scan images":
      'Trener može vidjeti podatke rezultata klijenta i slike skeniranja',
    Delete: 'Izbriši',
    Filter: 'Filtriraj',
    First: 'Prva',
    'First Name': 'Ime',
    Full: 'Potpuno',
    'Full Access': 'Puni pristup',
    Last: 'Zadnja',
    'Last Name': 'Prezime',
    Limited: 'Ograničeno',
    'Limited Access': 'Ograničeni pristup',
    'Manage Coaches': 'Upravljanje trenerima',
    'No Access': 'Bez pristupa',
    'Select Page Size:': 'Odaberite veličinu stranice:',
  },
}

const sourceAuditPhraseTranslations = {
  es: {
    "'s Fit3D Report": '- Informe Fit3D',
    "'s Scan": '- Escaneo',
    "'s site. This will open a new tab.":
      '- sitio. Esto abrirá una pestaña nueva.',
    "'Failed to update additional metrics. Please try again or contact support.'":
      "'No se pudieron actualizar las métricas adicionales. Inténtalo de nuevo o contacta con soporte.'",
    '13. What are your primary fitness goals?':
      '13. ¿Cuáles son tus objetivos principales de fitness?',
    '14. What areas of your body do you want to focus on?':
      '14. ¿En qué áreas de tu cuerpo quieres enfocarte?',
    '15. What prevented you from reaching your fitness goals in the past?':
      '15. ¿Qué te impidió alcanzar tus objetivos de fitness en el pasado?',
    '16. What is your current occupation?': '16. ¿Cuál es tu ocupación actual?',
    '17. Current physical activity level?':
      '17. ¿Nivel actual de actividad física?',
    '7. Have you been exercising for the last 6 months?':
      '7. ¿Has estado haciendo ejercicio durante los últimos 6 meses?',
    '8. Have you ever had a hard time attaining results and motivating yourself?':
      '8. ¿Alguna vez te costó obtener resultados y motivarte?',
    'Body fat is primarily made up of three types of fat:':
      'La grasa corporal se compone principalmente de tres tipos de grasa:',
    'Body Fat Percentage (BFP)': 'Porcentaje de grasa corporal (BFP)',
    'cancel add and remove panel': 'cancelar panel de añadir y eliminar',
    'Clicking continue will take you out of Sculpteo. Would you like to go back to your scans?':
      'Al hacer clic en continuar saldrás de Sculpteo. ¿Quieres volver a tus escaneos?',
    'Clients who scan must be attributed to the coach to be considered part of the competition.':
      'Los clientes que se escanean deben estar atribuidos al entrenador para considerarse parte de la competencia.',
    coach: 'entrenador',
    'Coach Activity Challenge': 'Reto de actividad de entrenadores',
    'Coach Activity Leaderboard - August 2018':
      'Clasificación de actividad de entrenadores - agosto de 2018',
    'Completed Client Scans': 'Escaneos de clientes completados',
    'Completed Scans': 'Escaneos completados',
    'dash user icon': 'icono de usuario del panel',
    'data compare against': 'datos para comparar',
    'essential body fat': 'grasa corporal esencial',
    'Facility Activity Leaderboard - July 2018':
      'Clasificación de actividad del centro - julio de 2018',
    'Facility Dashboard': 'Panel del centro',
    'Front View': 'Vista frontal',
    "Join our New Year's Challenge!": 'Únete a nuestro reto de Año Nuevo.',
    'Mock Client Comparison': 'Comparación de cliente de muestra',
    'Mock client comparison page provides two':
      'La página de comparación de cliente de muestra proporciona dos',
    'New User Raffle Winner 1st Place: $500 Visa Gift Card':
      'Ganador del sorteo de nuevo usuario, 1.er lugar: tarjeta Visa de regalo de $500',
    'New User Raffle Winner 2nd Place: $250 Visa Gift Card':
      'Ganador del sorteo de nuevo usuario, 2.º lugar: tarjeta Visa de regalo de $250',
    'New User Raffle Winner 3rd Place: $100 Visa Gift Card':
      'Ganador del sorteo de nuevo usuario, 3.er lugar: tarjeta Visa de regalo de $100',
    'Pick a scan:': 'Elige un escaneo:',
    'Sample Comparison': 'Comparación de muestra',
    'Sample Report': 'Informe de muestra',
    'Scan Count Raffle Winner 1st Place: $500 Visa Gift Card':
      'Ganador del sorteo por cantidad de escaneos, 1.er lugar: tarjeta Visa de regalo de $500',
    'Scan Count Raffle Winner 2nd Place: $250 Visa Gift Card':
      'Ganador del sorteo por cantidad de escaneos, 2.º lugar: tarjeta Visa de regalo de $250',
    'Scan Count Raffle Winner 3rd Place: $100 Visa Gift Card':
      'Ganador del sorteo por cantidad de escaneos, 3.er lugar: tarjeta Visa de regalo de $100',
    'scan history page': 'página de historial de escaneos',
    "scan images? You can view your coach or change the coach's access at your My Coaches page.":
      '¿imágenes de escaneo? Puedes ver tu entrenador o cambiar su acceso en tu página Mis entrenadores.',
    'Scan In Report': 'Escaneo en informe',
    'Scan report is not available': 'El informe de escaneo no está disponible',
    'Search Clients (Name or E-mail)':
      'Buscar clientes (nombre o correo electrónico)',
    'Scans completed by coaches and admins will not be factored into total valid scan counts.':
      'Los escaneos completados por entrenadores y administradores no se incluirán en el total de escaneos válidos.',
    'Select a body group:': 'Selecciona un grupo corporal:',
    'Select a scan from the list below':
      'Selecciona un escaneo de la lista siguiente',
    'Select a scan to view report:':
      'Selecciona un escaneo para ver el informe:',
    'Select all that apply.': 'Selecciona todo lo que corresponda.',
    'Select Coach Type': 'Seleccionar tipo de entrenador',
    'Select data to view.': 'Selecciona los datos que quieres ver.',
    "Select your client's interest level!":
      'Selecciona el nivel de interés de tu cliente.',
    'Show Image': 'Mostrar imagen',
    'Side View': 'Vista lateral',
    Submit: 'Enviar',
    'Submit Changes': 'Enviar cambios',
    'Submit Survey': 'Enviar encuesta',
    'Take some scans to view your scan history. Click':
      'Realiza algunos escaneos para ver tu historial de escaneos. Haz clic',
    'The amount of energy your body is burning while at rest.':
      'La cantidad de energía que tu cuerpo quema en reposo.',
    'The baseline scan dates that occur after the current scan dates will be disabled':
      'Las fechas de escaneo de referencia posteriores a las fechas de escaneo actuales estarán deshabilitadas',
    'The last request was sent on': 'La última solicitud se envió el',
    'The mass of the adipose tissue within the body is given by:':
      'La masa del tejido adiposo dentro del cuerpo se calcula mediante:',
    'There are no metrics associated with this scan':
      'No hay métricas asociadas con este escaneo',
    'There are no visible scans to view': 'No hay escaneos visibles para ver',
    'This page is unavailable, please use the nav bar to redirect to a different page.':
      'Esta página no está disponible; usa la barra de navegación para ir a otra página.',
    'to return to the posture page.': 'para volver a la página de postura.',
    'to return to the wellness page': 'para volver a la página de bienestar',
    'to return to your dashboard': 'para volver a tu panel',
    'to view your scans.': 'para ver tus escaneos.',
    'Unavailable for this facility': 'No disponible para este centro',
    'Update Metrics': 'Actualizar métricas',
    'Use the form below to edit height and weight.':
      'Usa el formulario siguiente para editar estatura y peso.',
    'View most recent scans at your facility - OR - search to filter by email/name.':
      'Ve los escaneos más recientes de tu centro, o busca para filtrar por correo/nombre.',
    'View Posture Comparison': 'Ver comparación de postura',
    'View Waist Circumference Data': 'Ver datos de circunferencia de cintura',
    'View Waist to Hip Ratio Data': 'Ver datos de relación cintura-cadera',
    'View Weight Trend': 'Ver tendencia de peso',
    Visible: 'Visible',
    'WC is the circumference measurement taken at the small of the back.':
      'WC es la medida de circunferencia tomada en la parte baja de la espalda.',
    "We'll never share your email with anyone else.":
      'Nunca compartiremos tu correo electrónico con nadie más.',
    'Weight / Height': 'Peso / estatura',
    'Wellness Glossary': 'Glosario de bienestar',
    'Wellness Metric': 'Métrica de bienestar',
    'what i do?? :(': '¿qué hago?',
    'What is Posture?': '¿Qué es la postura?',
    'You have already requested access for this client. Your last request was sent on':
      'Ya solicitaste acceso para este cliente. Tu última solicitud se envió el',
    'You may send one request to a client every 30 minutes.':
      'Puedes enviar una solicitud a un cliente cada 30 minutos.',
    'Your account has been created successfully. Log in to get started.':
      'Tu cuenta se creó correctamente. Inicia sesión para comenzar.',
    "Your Clients' Completed Scans": 'Escaneos completados de tus clientes',
    'Your Dashboard': 'Tu panel',
    'Your Facility': 'Tu centro',
    'Your Fit3D Body Shape Rating': 'Tu calificación de forma corporal Fit3D',
    'Your Scan History': 'Tu historial de escaneos',
    'Your Wellness Page': 'Tu página de bienestar',
    'your scan record? You will not be able to retrieve it in the future.':
      '¿tu registro de escaneo? No podrás recuperarlo en el futuro.',
  },
  de: {
    "'s Fit3D Report": '- Fit3D-Bericht',
    "'s site. This will open a new tab.":
      '- Website. Dies öffnet einen neuen Tab.',
    "'Failed to update additional metrics. Please try again or contact support.'":
      "'Zusätzliche Metriken konnten nicht aktualisiert werden. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.'",
    '13. What are your primary fitness goals?':
      '13. Was sind Ihre wichtigsten Fitnessziele?',
    '14. What areas of your body do you want to focus on?':
      '14. Auf welche Körperbereiche möchten Sie sich konzentrieren?',
    '15. What prevented you from reaching your fitness goals in the past?':
      '15. Was hat Sie früher daran gehindert, Ihre Fitnessziele zu erreichen?',
    '16. What is your current occupation?':
      '16. Was ist Ihre derzeitige Tätigkeit?',
    '17. Current physical activity level?':
      '17. Aktuelles körperliches Aktivitätsniveau?',
    '7. Have you been exercising for the last 6 months?':
      '7. Haben Sie in den letzten 6 Monaten trainiert?',
    '8. Have you ever had a hard time attaining results and motivating yourself?':
      '8. Hatten Sie schon einmal Schwierigkeiten, Ergebnisse zu erzielen und sich zu motivieren?',
    'Access Level': 'Zugriffsebene',
    'Account Created!': 'Konto erstellt!',
    'Add Metric': 'Metrik hinzufügen',
    'Add/Edit Additional Metrics': 'Zusätzliche Metriken hinzufügen/bearbeiten',
    'Add/Edit Metric(s)': 'Metrik(en) hinzufügen/bearbeiten',
    'Already have an account?': 'Haben Sie bereits ein Konto?',
    Back: 'Zurück',
    'Body Comp Access Unavailable':
      'Zugriff auf Körperzusammensetzung nicht verfügbar',
    'Body fat is primarily made up of three types of fat:':
      'Körperfett besteht hauptsächlich aus drei Fettarten:',
    'Body Fat Percent': 'Körperfettanteil',
    'Body Fat Percentage (BFP)': 'Körperfettanteil (BFP)',
    'Body Shape Rating Percentile': 'Perzentil der Körperformbewertung',
    "Body weight is a person's mass or weight.":
      'Das Körpergewicht ist die Masse oder das Gewicht einer Person.',
    'cancel add and remove panel':
      'Panel zum Hinzufügen und Entfernen abbrechen',
    'Clicking continue will take you out of Sculpteo. Would you like to go back to your scans?':
      'Wenn Sie auf Weiter klicken, verlassen Sie Sculpteo. Möchten Sie zu Ihren Scans zurückkehren?',
    'Change E-mail': 'E-Mail ändern',
    'Click a scan on the left to view more information!':
      'Klicken Sie links auf einen Scan, um weitere Informationen anzuzeigen!',
    'Click on a scan panel to change reports!':
      'Klicken Sie auf ein Scan-Panel, um Berichte zu wechseln!',
    'Clients who scan must be attributed to the coach to be considered part of the competition.':
      'Kunden, die scannen, müssen dem Trainer zugeordnet sein, um als Teil des Wettbewerbs zu zählen.',
    'Client Comparison': 'Kundenvergleich',
    'Client Comparison Page': 'Kundenvergleichsseite',
    'Client PARQ Survey is unavailable':
      'Die PARQ-Umfrage des Kunden ist nicht verfügbar',
    'Client Report': 'Kundenbericht',
    'Client Scan Report is not available':
      'Der Scan-Bericht des Kunden ist nicht verfügbar',
    'Comparison Report': 'Vergleichsbericht',
    'Completed Client Scans': 'Abgeschlossene Kundenscans',
    'Confirm Access': 'Zugriff bestätigen',
    'Confirm Access Removal': 'Entfernen des Zugriffs bestätigen',
    'Confirm New Email': 'Neue E-Mail bestätigen',
    'Confirm Remove Access': 'Zugriffsentfernung bestätigen',
    'Confirm Request': 'Anfrage bestätigen',
    'Create a Fit3D Account': 'Fit3D-Konto erstellen',
    'Create Account': 'Konto erstellen',
    'dash user icon': 'Dashboard-Benutzersymbol',
    'data compare against': 'Daten zum Vergleichen',
    'Days since last scan': 'Tage seit dem letzten Scan',
    'Demo Location Guide (Sample Image)*':
      'Demo-Positionsleitfaden (Beispielbild)*',
    Diff: 'Differenz',
    'Download Report': 'Bericht herunterladen',
    'Download Scan': 'Scan herunterladen',
    'Download Scan (GIF)': 'Scan herunterladen (GIF)',
    'Download Scan (OBJ)': 'Scan herunterladen (OBJ)',
    'Download Scan Gif': 'Scan-GIF herunterladen',
    'Download Scan Obj': 'Scan-OBJ herunterladen',
    'Edit Email': 'E-Mail bearbeiten',
    'Edit Height & Weight': 'Größe und Gewicht bearbeiten',
    'Edit PARQ Survey': 'PARQ-Umfrage bearbeiten',
    'Edit Password': 'Passwort bearbeiten',
    'Edit Profile': 'Profil bearbeiten',
    'Error: Not Found': 'Fehler: Nicht gefunden',
    'essential body fat': 'essenzielles Körperfett',
    'Failure to remove coach. Please try again or contact support.':
      'Trainer konnte nicht entfernt werden. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.',
    'Failure to update coach access level. Please try again or contact support.':
      'Trainer-Zugriffsebene konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.',
    'Facility Activity Leaderboard - July 2018':
      'Einrichtungsaktivitäts-Bestenliste - Juli 2018',
    'Facility Dashboard': 'Einrichtungs-Dashboard',
    'Fitness Level': 'Fitnessniveau',
    'Front View': 'Vorderansicht',
    'Front/Back': 'Vorne/Hinten',
    Gender: 'Geschlecht',
    'Give your coach access to your Fit3D data':
      'Geben Sie Ihrem Trainer Zugriff auf Ihre Fit3D-Daten',
    'Go to comparison page': 'Zur Vergleichsseite',
    'Go to Report': 'Zum Bericht',
    'Health History': 'Gesundheitsverlauf',
    'Height/Weight': 'Größe/Gewicht',
    'Hide Image': 'Bild ausblenden',
    'How Can Posture Affect You?': 'Wie kann sich Haltung auf Sie auswirken?',
    'How do I compare to other Fit3D users?':
      'Wie vergleiche ich mich mit anderen Fit3D-Benutzern?',
    'How do I compare?': 'Wie schneide ich im Vergleich ab?',
    'Interest Level': 'Interessenstufe',
    "Join our New Year's Challenge!":
      'Nehmen Sie an unserer Neujahrs-Challenge teil!',
    'Last scan attempt status:': 'Status des letzten Scanversuchs:',
    'Last scan taken date': 'Datum des letzten Scans',
    'Leaving a field blank when submitting will not update the metric.':
      'Wenn ein Feld beim Absenden leer bleibt, wird die Metrik nicht aktualisiert.',
    'Manage Profile': 'Profil verwalten',
    'Measurement Comparison': 'Messungsvergleich',
    'Measurement Name': 'Name der Messung',
    'Measurements & Comparison': 'Messungen & Vergleich',
    'Metric Name': 'Name der Metrik',
    'Mock Client Comparison': 'Beispiel-Kundenvergleich',
    'Mock client comparison page provides two':
      'Die Beispiel-Kundenvergleichsseite bietet zwei',
    Name: 'Name',
    'New Email': 'Neue E-Mail',
    'New User Raffle Winner 1st Place: $500 Visa Gift Card':
      'Gewinner der Verlosung für neue Benutzer, 1. Platz: Visa-Geschenkkarte über 500 $',
    'New User Raffle Winner 2nd Place: $250 Visa Gift Card':
      'Gewinner der Verlosung für neue Benutzer, 2. Platz: Visa-Geschenkkarte über 250 $',
    'New User Raffle Winner 3rd Place: $100 Visa Gift Card':
      'Gewinner der Verlosung für neue Benutzer, 3. Platz: Visa-Geschenkkarte über 100 $',
    'No additional metrics activated for this facility':
      'Für diese Einrichtung sind keine zusätzlichen Metriken aktiviert',
    'No additional metrics for this client':
      'Keine zusätzlichen Metriken für diesen Kunden',
    'No available measurements': 'Keine Messungen verfügbar',
    'No available wellness metrics': 'Keine Wellness-Metriken verfügbar',
    'No posture data': 'Keine Haltungsdaten',
    'No scans available to show': 'Keine Scans zum Anzeigen verfügbar',
    'No tilt data for side view': 'Keine Neigungsdaten für die Seitenansicht',
    'No video available': 'Kein Video verfügbar',
    'Not enough completed posture assessments':
      'Nicht genügend abgeschlossene Haltungsbewertungen',
    'Overlay Comparison': 'Überlagerungsvergleich',
    'Password (8+ characters)': 'Passwort (8+ Zeichen)',
    'Pick a scan:': 'Scan auswählen:',
    'Please take follow up scans to compare posture assessments. Click':
      'Bitte machen Sie Folgescans, um Haltungsbewertungen zu vergleichen. Klicken Sie',
    'Please take a scan to continue':
      'Bitte machen Sie einen Scan, um fortzufahren',
    'Please update your scan visibility to view your wellness information! Click':
      'Bitte aktualisieren Sie Ihre Scan-Sichtbarkeit, um Ihre Wellness-Informationen anzuzeigen. Klicken Sie',
    'Posture processing is in progress': 'Haltungsverarbeitung läuft',
    'Posture Status': 'Haltungsstatus',
    'Posture Status:': 'Haltungsstatus:',
    'Profile Overview': 'Profilübersicht',
    'Read more in the Fit3D Wellness Glossary':
      'Lesen Sie mehr im Fit3D-Wellness-Glossar',
    'Reload Client Records': 'Kundendatensätze neu laden',
    'Remove Access': 'Zugriff entfernen',
    'Request Client Access': 'Kundenzugriff anfragen',
    'Request Date': 'Anfragedatum',
    'Request Full Access': 'Vollzugriff anfragen',
    'Request/Remove Clients': 'Kunden anfragen/entfernen',
    'Return to All Client Records': 'Zurück zu allen Kundendatensätzen',
    'Return to Client Records': 'Zurück zu Kundendatensätzen',
    'Return to Wellness Page': 'Zurück zur Wellness-Seite',
    'Review My Wellness': 'Meine Wellness ansehen',
    'Sample Comparison': 'Beispielvergleich',
    'Sample Report': 'Beispielbericht',
    Scan: 'Scan',
    'Scan Count Raffle Winner 1st Place: $500 Visa Gift Card':
      'Gewinner der Verlosung nach Scan-Anzahl, 1. Platz: Visa-Geschenkkarte über 500 $',
    'Scan Count Raffle Winner 2nd Place: $250 Visa Gift Card':
      'Gewinner der Verlosung nach Scan-Anzahl, 2. Platz: Visa-Geschenkkarte über 250 $',
    'Scan Count Raffle Winner 3rd Place: $100 Visa Gift Card':
      'Gewinner der Verlosung nach Scan-Anzahl, 3. Platz: Visa-Geschenkkarte über 100 $',
    'scan history page': 'Scanverlaufsseite',
    "scan images? You can view your coach or change the coach's access at your My Coaches page.":
      'Scanbilder? Sie können Ihren Trainer anzeigen oder dessen Zugriff auf Ihrer Seite Meine Trainer ändern.',
    'Scan In Report': 'Scan im Bericht',
    'Scan Info': 'Scan-Info',
    'Scan Preview': 'Scan-Vorschau',
    'Scan report is not available': 'Scan-Bericht ist nicht verfügbar',
    'Scan Status': 'Scan-Status',
    'Scan Status:': 'Scan-Status:',
    'Search Clients (Name or E-mail)': 'Kunden suchen (Name oder E-Mail)',
    'Scans completed by coaches and admins will not be factored into total valid scan counts.':
      'Von Trainern und Administratoren abgeschlossene Scans werden nicht in die Gesamtzahl gültiger Scans einbezogen.',
    'Select a body group:': 'Körpergruppe auswählen:',
    'Select a scan from the list below':
      'Wählen Sie einen Scan aus der Liste unten aus',
    'Select a scan to view report:':
      'Wählen Sie einen Scan aus, um den Bericht anzuzeigen:',
    'Select all that apply.': 'Wählen Sie alles Zutreffende aus.',
    'Select Coach Type': 'Trainertyp auswählen',
    'Select data to view.': 'Wählen Sie Daten zum Anzeigen aus.',
    "Select your client's interest level!":
      'Wählen Sie die Interessenstufe Ihres Kunden aus!',
    'Show Image': 'Bild anzeigen',
    'Side View': 'Seitenansicht',
    Status: 'Status',
    'Status:': 'Status:',
    'Submit Changes': 'Änderungen absenden',
    'Submit Survey': 'Umfrage absenden',
    'Take some scans to view your scan history. Click':
      'Machen Sie einige Scans, um Ihren Scanverlauf anzuzeigen. Klicken Sie',
    'The amount of energy your body is burning while at rest.':
      'Die Energiemenge, die Ihr Körper im Ruhezustand verbrennt.',
    'The baseline scan dates that occur after the current scan dates will be disabled':
      'Baseline-Scandaten, die nach den aktuellen Scandaten liegen, werden deaktiviert',
    'The last request was sent on': 'Die letzte Anfrage wurde gesendet am',
    'The mass of the adipose tissue within the body is given by:':
      'Die Masse des Fettgewebes im Körper ergibt sich aus:',
    'There are no visible scans to view':
      'Es gibt keine sichtbaren Scans zum Anzeigen',
    'This page is unavailable, please use the nav bar to redirect to a different page.':
      'Diese Seite ist nicht verfügbar. Bitte verwenden Sie die Navigationsleiste, um zu einer anderen Seite zu wechseln.',
    'to return to your dashboard': 'um zu Ihrem Dashboard zurückzukehren',
    Wellness: 'Wellness',
    'WC is the circumference measurement taken at the small of the back.':
      'WC ist die Umfangsmessung am unteren Rücken.',
    'what i do?? :(': 'Was soll ich tun?',
    'your scan record? You will not be able to retrieve it in the future.':
      'Ihren Scan-Datensatz? Sie können ihn später nicht wiederherstellen.',
  },
}

const longFormSourcePhraseTranslations = {
  es: {
    'All coaches and admins who are listed as either on the Fit3D platform by end of business (5pm PT), Wednesday July 31, 2018 are automatically entered. To be eligible for a prize, the winning coach much accept the prize via email confirmation.':
      'Todos los entrenadores y administradores que figuren en la plataforma Fit3D al cierre del horario laboral (5 p. m. PT) del miércoles 31 de julio de 2018 quedan inscritos automáticamente. Para ser elegible para un premio, el entrenador ganador debe aceptar el premio mediante confirmación por correo electrónico.',
    'All coaches and facility admins who are listed as either on the Fit3D platform are automatically entered. Void where prohibited or restricted by law or regulation. Not eligible are employees and their immediate families including household members of Fit3D, Inc. or their respective agents, attorneys, subsidiaries, divisions, and advertising and promotion agencies.':
      'Todos los entrenadores y administradores del centro que figuren en la plataforma Fit3D quedan inscritos automáticamente. Nulo donde esté prohibido o restringido por ley o regulación. No son elegibles los empleados ni sus familiares directos, incluidos los miembros del hogar de Fit3D, Inc. o de sus respectivos agentes, abogados, subsidiarias, divisiones y agencias de publicidad y promoción.',
    'All facilities who own a Fit3D ProScanner are automatically entered. To be eligible for a prize, facilities much accept the prize via email confirmation.':
      'Todos los centros que posean un Fit3D ProScanner quedan inscritos automáticamente. Para ser elegibles para un premio, los centros deben aceptar el premio mediante confirmación por correo electrónico.',
    'At the end of the Competition Period, Fit3D will announce the top ten coaches/admins of the competition in an email September 10, 2018. The winner will be notified directly via electronic mail on September 11, 2018 and will have three (3) days to confirm a desire to receive their prizes. If prizes are not confirmed, the prize may be forfeited and offered to another winner.':
      'Al final del periodo de competencia, Fit3D anunciará los diez mejores entrenadores/administradores de la competencia en un correo electrónico el 10 de septiembre de 2018. El ganador será notificado directamente por correo electrónico el 11 de septiembre de 2018 y tendrá tres (3) días para confirmar que desea recibir sus premios. Si los premios no se confirman, pueden perderse y ofrecerse a otro ganador.',
    'At the end of the Raffle Period, Fit3D will announce the amount of New User Raffle Tickets and Scan Raffle Tickets for each facility on or before August 10, 2018. The Raffle will take place on August 13, 2018 and the six (6) winners will be notified via electronic mail on August 15, 2018. The winners will have three (3) days to confirm a desire to receive their prizes. If prizes are not confirmed, the prize may be forfeited and offered to another winner.':
      'Al final del periodo del sorteo, Fit3D anunciará la cantidad de boletos del sorteo de nuevos usuarios y boletos del sorteo de escaneos de cada centro el 10 de agosto de 2018 o antes. El sorteo se realizará el 13 de agosto de 2018 y los seis (6) ganadores serán notificados por correo electrónico el 15 de agosto de 2018. Los ganadores tendrán tres (3) días para confirmar que desean recibir sus premios. Si los premios no se confirman, pueden perderse y ofrecerse a otro ganador.',
    'Basal Metabolic Rate (BMR) is the amount of energy expended while at rest in a neutrally temperate environment and in the post-absorptive state. In this state, the digestive system is inactive, which is usually achieved by about twelve hours of fasting. Furthermore, BMR is the amount of energy expressed in calories that a person needs to keep the body functioning (i.e. breathing, blood circulation, controlling body temperature, cell growth, brain and nervous function, and contraction of muscles). BMR affects the rate at which a person burns calories and ultimately affects whether that individual maintains, gains, or loses weight.':
      'La tasa metabólica basal (BMR) es la cantidad de energía que se gasta en reposo, en un ambiente de temperatura neutra y en estado posabsortivo. En este estado, el sistema digestivo está inactivo, lo que normalmente se logra tras unas doce horas de ayuno. Además, la BMR es la cantidad de energía expresada en calorías que una persona necesita para mantener el funcionamiento del cuerpo (por ejemplo, respirar, circular la sangre, controlar la temperatura corporal, crecimiento celular, función cerebral y nerviosa, y contracción muscular). La BMR afecta la velocidad a la que una persona quema calorías y, en última instancia, influye en si mantiene, aumenta o pierde peso.',
    'Body fat percentage is the user’s total fat mass divided by the total body mass. Fat is an essential component of the body and is necessary to maintain life and reproductive functions; however, too much body fat can negatively affect overall health or hormone levels. It also serves as an indicator of more serious health problems that could potentially be faced in the future. The':
      'El porcentaje de grasa corporal es la masa grasa total del usuario dividida por la masa corporal total. La grasa es un componente esencial del cuerpo y es necesaria para mantener la vida y las funciones reproductivas; sin embargo, demasiada grasa corporal puede afectar negativamente la salud general o los niveles hormonales. También sirve como indicador de problemas de salud más graves que podrían enfrentarse en el futuro. El',
    "Body fat percentage is the user's total fat mass divided by the total body mass. Fat is an essential component of the body, however, too much body fat can negatively affect overall health.":
      'El porcentaje de grasa corporal es la masa grasa total del usuario dividida por la masa corporal total. La grasa es un componente esencial del cuerpo; sin embargo, demasiada grasa corporal puede afectar negativamente la salud general.',
    'Body weight is a person’s mass or weight. This is probably the easiest metric to measure on a human and is therefore a part of our primary assessment metrics; however, the body shape makeup and body composition is a much more real mechanism to determine the health of an individual.':
      'El peso corporal es la masa o el peso de una persona. Probablemente sea la métrica más fácil de medir en un ser humano y, por eso, forma parte de nuestras métricas principales de evaluación; sin embargo, la forma corporal y la composición corporal son mecanismos mucho más reales para determinar la salud de una persona.',
    'Click on value in the chart for a comparison against your demographic. The comparison will be shown on the right.':
      'Haz clic en un valor de la gráfica para compararlo con tu grupo demográfico. La comparación se mostrará a la derecha.',
    "Coach must be listed as either a Coach or Admin on their facility's Fit3D Dashboard by end of business (5pm PT), Wednesday July 31, 2018 to be entered into the competition.":
      'El entrenador debe figurar como entrenador o administrador en el panel Fit3D de su centro al cierre del horario laboral (5 p. m. PT) del miércoles 31 de julio de 2018 para participar en la competencia.',
    'Fat mass is also known as adipose tissue within the body. This loose connective tissue is primarily composed of':
      'La masa grasa también se conoce como tejido adiposo dentro del cuerpo. Este tejido conectivo laxo está compuesto principalmente por',
    "Heart rate is the speed of the heartbeat measured by the number of contractions of the heart per minute (bpm). The heart rate can vary according to the body's":
      'La frecuencia cardíaca es la velocidad del latido del corazón medida por el número de contracciones por minuto (lpm). La frecuencia cardíaca puede variar según el cuerpo',
    'Lean mass is the muscle tissue, skeletal tissue, and water in the body. Lean mass burns more energy than fat mass, so increasing lean mass can help continue to reduce fat mass.':
      'La masa magra es el tejido muscular, el tejido esquelético y el agua del cuerpo. La masa magra quema más energía que la masa grasa, por lo que aumentarla puede ayudar a seguir reduciendo la masa grasa.',
    'Metabolic age compares your basal metabolic rate (BMR) to the average BMR of people in different age groups. A lower metabolic age suggests better metabolic health and indicates that your body is functioning more efficiently than the typical person of your chronological age.':
      'La edad metabólica compara tu tasa metabólica basal (BMR) con la BMR promedio de personas de distintos grupos de edad. Una edad metabólica más baja sugiere una mejor salud metabólica e indica que tu cuerpo funciona con más eficiencia que el de una persona típica de tu edad cronológica.',
    'No correspondence will be entered into by Sponsor. Any tax due on any prize is the sole responsibility of the winner. A completed W-9 will be required by Fit3D in order to issue prize winnings in cash. Winners hereby consent to the use of his/her name and photograph for promotional purposes without additional compensation, unless prohibited by law. Persons found tampering with or abusing any aspect of this contest as solely determined by the Sponsor will be disqualified from winning any prize. In the event the contest is compromised by a virus, bugs, non-authorized human intervention or other causes beyond the control of Sponsor which corrupts or impairs the administration, security, fairness or proper play of the contest, Sponsor reserves the right in its sole discretion to suspend or terminate the contest and award prizes in a later contest. Should the contest be terminated prior to the stated expiration date, notice will be posted at www.fit3d.com.':
      'El patrocinador no mantendrá correspondencia. Cualquier impuesto adeudado por cualquier premio será responsabilidad exclusiva del ganador. Fit3D requerirá un formulario W-9 completo para emitir premios en efectivo. Los ganadores aceptan el uso de su nombre y fotografía con fines promocionales sin compensación adicional, salvo que la ley lo prohíba. Las personas que manipulen o abusen de cualquier aspecto de este concurso, según lo determine exclusivamente el patrocinador, quedarán descalificadas para ganar cualquier premio. Si el concurso se ve comprometido por virus, errores, intervención humana no autorizada u otras causas fuera del control del patrocinador que corrompan o afecten la administración, seguridad, equidad o desarrollo correcto del concurso, el patrocinador se reserva el derecho, a su entera discreción, de suspender o terminar el concurso y otorgar premios en un concurso posterior. Si el concurso termina antes de la fecha de vencimiento indicada, se publicará un aviso en www.fit3d.com.',
    'No correspondence will be entered into by Sponsor. Any tax due on any prize is the sole responsibility of the winner. Winners hereby consent to the use of his/her name and photograph for promotional purposes without additional compensation, unless prohibited by law. Persons found tampering with or abusing any aspect of this contest as solely determined by the Sponsor will be disqualified from winning any prize. In the event the contest is compromised by a virus, bugs, non-authorized human intervention or other causes beyond the control of Sponsor which corrupts or impairs the administration, security, fairness or proper play of the contest, Sponsor reserves the right in its sole discretion to suspend or terminate the contest and award prizes in a later contest. Should the contest be terminated prior to the stated expiration date, notice will be posted at www.fit3d.com.':
      'El patrocinador no mantendrá correspondencia. Cualquier impuesto adeudado por cualquier premio será responsabilidad exclusiva del ganador. Los ganadores aceptan el uso de su nombre y fotografía con fines promocionales sin compensación adicional, salvo que la ley lo prohíba. Las personas que manipulen o abusen de cualquier aspecto de este concurso, según lo determine exclusivamente el patrocinador, quedarán descalificadas para ganar cualquier premio. Si el concurso se ve comprometido por virus, errores, intervención humana no autorizada u otras causas fuera del control del patrocinador que corrompan o afecten la administración, seguridad, equidad o desarrollo correcto del concurso, el patrocinador se reserva el derecho, a su entera discreción, de suspender o terminar el concurso y otorgar premios en un concurso posterior. Si el concurso termina antes de la fecha de vencimiento indicada, se publicará un aviso en www.fit3d.com.',
    'Raffle Period: July 1, 2018 at 12:01 AM (PST) and ending July 31, 2018 at 11:59 PM (PST) New User Raffle Tickets: Facilities will get 1 raffle ticket for every new user who has completed a scan after the first 100 new users who have completed a successful scan from the Facility’s ProScanner during the Raffle Period. Scan Raffle Tickets: Facilities will get 1 raffle ticket for every successfully completed scan after the first 100 successfully completed scans taken from the Facility’s ProScanner during the Raffle Period. user after':
      'Periodo del sorteo: desde el 1 de julio de 2018 a las 12:01 a. m. (PST) hasta el 31 de julio de 2018 a las 11:59 p. m. (PST). Boletos del sorteo de nuevos usuarios: los centros recibirán 1 boleto por cada nuevo usuario que haya completado un escaneo después de los primeros 100 nuevos usuarios que hayan completado un escaneo exitoso desde el ProScanner del centro durante el periodo del sorteo. Boletos del sorteo de escaneos: los centros recibirán 1 boleto por cada escaneo completado exitosamente después de los primeros 100 escaneos exitosos realizados desde el ProScanner del centro durante el periodo del sorteo. usuario después',
    'Remove all access for coach? You can always add these coaches back later in the Add Coaches page.':
      '¿Eliminar todo el acceso del entrenador? Siempre puedes volver a añadir estos entrenadores más tarde en la página Añadir entrenadores.',
    'Similar to WHR where body shape is described using a ratio, but instead of waist and hips circumferences, body trunk/torso and leg volumes are used. By using volume it captures a more detailed view of body shape. A lower trunk to leg volume ratio generally means lower risk for certain health issues.':
      'Similar al WHR, donde la forma corporal se describe mediante una relación, pero en lugar de las circunferencias de cintura y cadera se usan los volúmenes del tronco/torso y las piernas. Al usar volumen, captura una vista más detallada de la forma corporal. Una relación de volumen tronco-piernas más baja generalmente significa menor riesgo de ciertos problemas de salud.',
    'The 2-component model, which consists of fat mass and lean mass calculations, is widely used to determine body composition. Fat mass is the mass of the adipose tissue in the body. Lean mass is the muscle tissue, skeletal tissue, and water in the body. In 3- and 4-component models, skeletal tissue and water are drawn out as isolated measurements.':
      'El modelo de 2 componentes, que consiste en cálculos de masa grasa y masa magra, se utiliza ampliamente para determinar la composición corporal. La masa grasa es la masa del tejido adiposo del cuerpo. La masa magra es el tejido muscular, el tejido esquelético y el agua del cuerpo. En los modelos de 3 y 4 componentes, el tejido esquelético y el agua se separan como mediciones aisladas.',
    'The body is designed to be in balance including head, shoulders, rib cage, pelvis, and knees for perfect balance from front and side views. Posture quality is measured by calculating deviations between your posture and "normal" balanced posture.':
      'El cuerpo está diseñado para estar en equilibrio, incluidos cabeza, hombros, caja torácica, pelvis y rodillas, para lograr un equilibrio perfecto desde las vistas frontal y lateral. La calidad de la postura se mide calculando las desviaciones entre tu postura y una postura equilibrada "normal".',
    'The coach or facility admin who helps clients/members complete the most valid Fit3D body scans during the month of August 2018.':
      'El entrenador o administrador del centro que ayude a los clientes/miembros a completar la mayor cantidad de escaneos corporales Fit3D válidos durante agosto de 2018.',
    'The total amount of fat in the body. There are multiple types of fat in the body which have very different effects on overall healthy. The body shape tab can provide more insight into how fat distribution factors into potential health risks.':
      'La cantidad total de grasa en el cuerpo. Hay varios tipos de grasa en el cuerpo que tienen efectos muy diferentes en la salud general. La pestaña de forma corporal puede aportar más información sobre cómo la distribución de grasa influye en posibles riesgos de salud.',
    'This can be done through a balanced mix of good nutrition and exercise that includes higher intensity interval training. Consult with your trainer, nutritionist, coaches, and/or doctors to set up a plan':
      'Esto puede lograrse mediante una combinación equilibrada de buena nutrición y ejercicio que incluya entrenamiento por intervalos de mayor intensidad. Consulta con tu entrenador, nutricionista, coaches y/o médicos para establecer un plan',
    'This formula is dependent on volume, not weight. The overly simple way to improve your Trunk to Leg Volume score is to decrease the volume of your midsection and increase the volume of your legs.':
      'Esta fórmula depende del volumen, no del peso. La forma más simple de mejorar tu puntuación de volumen tronco-piernas es disminuir el volumen de la zona media y aumentar el volumen de las piernas.',
    'This ratio as a health metric is extremely limited, but it is an easy way to try to evaluate the level of visceral fat one may have.':
      'Esta relación como métrica de salud es extremadamente limitada, pero es una forma sencilla de intentar evaluar el nivel de grasa visceral que una persona puede tener.',
    'Through research partnerships with public and private institutions, Fit3D has scanned thousands of people with Fit3D and DXA systems side by side. Fit3D has subsequently created algorithms that utilize hundreds of measurements automatically extracted from these body scans to calculate a user’s body fat percentage.':
      'A través de alianzas de investigación con instituciones públicas y privadas, Fit3D ha escaneado a miles de personas con sistemas Fit3D y DXA en paralelo. Posteriormente, Fit3D creó algoritmos que utilizan cientos de mediciones extraídas automáticamente de estos escaneos corporales para calcular el porcentaje de grasa corporal de un usuario.',
    "Validating scans is highly important because it allows you to obtain the best possible data. Fit3D's scans are highly accurate, but there are several factors that could cause issues. Walking through this scan will allow you to identify some of the factors that might lead to an improper scan.":
      'Validar los escaneos es muy importante porque te permite obtener los mejores datos posibles. Los escaneos de Fit3D son muy precisos, pero hay varios factores que podrían causar problemas. Revisar este escaneo te permitirá identificar algunos factores que podrían provocar un escaneo incorrecto.',
    'Waist circumference (WC) provides a prediction of risk independent of BMI. WC is particularly useful for patients who are categorized as normal or overweight on the BMI scale as a measurement associated with visceral fat and overall body shape.':
      'La circunferencia de cintura (WC) proporciona una predicción de riesgo independiente del BMI. La WC es especialmente útil para pacientes clasificados como normales o con sobrepeso en la escala de BMI, como una medición asociada con la grasa visceral y la forma corporal general.',
    'Waist to hip ratio describes body shape using a ratio between waist and hips. A lower ratio generally means lower risk for certain health issues. If you have heard of body shapes described as apple or pear, these are two ends of the WHR spectrum where pear has a lower WHR ratio and therefore lower risk for certain health issues.':
      'La relación cintura-cadera describe la forma corporal mediante una relación entre la cintura y la cadera. Una relación más baja generalmente significa menor riesgo de ciertos problemas de salud. Si has oído describir formas corporales como manzana o pera, estos son dos extremos del espectro de WHR, donde la pera tiene una relación WHR más baja y, por lo tanto, menor riesgo de ciertos problemas de salud.',
    'We suggest that you consult with your trainer, nutritionist, coaches, and/or doctors to set up a plan before focusing solely on your WHR.':
      'Sugerimos que consultes con tu entrenador, nutricionista, coaches y/o médicos para establecer un plan antes de enfocarte únicamente en tu WHR.',
    "We'll pass your measurements and/or scan to this vendor for a potential better fit. For more information about what is being passed on, view our":
      'Pasaremos tus mediciones y/o escaneo a este proveedor para obtener un posible mejor ajuste. Para obtener más información sobre lo que se comparte, consulta nuestra',
    'While you cannot spot reduced fat mass throughout your body, you can still work with your coaches to reduce the amount throughout your body, which will generally decrease the circumference of your mid-section. WHR is extremely limited in scope, but is widely used as a metric of health.':
      'Aunque no puedes reducir grasa de forma localizada en todo el cuerpo, puedes trabajar con tus coaches para reducir la cantidad en todo el cuerpo, lo que generalmente disminuirá la circunferencia de la zona media. El WHR tiene un alcance extremadamente limitado, pero se usa ampliamente como métrica de salud.',
    'WHR is a ratio generally used to evaluate whether the individual is at high risk of obesity, diabetes, coronary heart disease, and/or high blood pressure. The measurement evaluates body shape in the midsection of the body.':
      'El WHR es una relación que generalmente se usa para evaluar si una persona tiene alto riesgo de obesidad, diabetes, enfermedad coronaria y/o presión arterial alta. La medición evalúa la forma corporal en la zona media del cuerpo.',
    'You can decrease your body fat percentage through a balanced mix of good nutrition and exercise that includes higher intensity interval training and cardio. Consult with your trainer, nutritionist, coaches, and/or doctors to set up a plan.':
      'Puedes reducir tu porcentaje de grasa corporal mediante una combinación equilibrada de buena nutrición y ejercicio que incluya entrenamiento por intervalos de mayor intensidad y cardio. Consulta con tu entrenador, nutricionista, coaches y/o médicos para establecer un plan.',
    'You can increase your BMR by participating in fitness programs that include high intensity interval training or lifting weights to build muscle. You can further increase your BMR by eating more protein, eating many smaller-portioned meals per day, and staying hydrated. The rule of thumb here is that muscle requires more energy to survive—the more lean muscle you have on your body, the higher your BMR. Consult with your trainer, nutritionist, coaches, and/or doctors to set up a plan.':
      'Puedes aumentar tu BMR participando en programas de fitness que incluyan entrenamiento por intervalos de alta intensidad o levantamiento de pesas para desarrollar músculo. También puedes aumentar tu BMR comiendo más proteína, haciendo muchas comidas de porciones más pequeñas al día y manteniéndote hidratado. La regla general es que el músculo requiere más energía para mantenerse: cuanto más músculo magro tengas en el cuerpo, mayor será tu BMR. Consulta con tu entrenador, nutricionista, coaches y/o médicos para establecer un plan.',
    'You can increase your lean mass by participating in fitness programs that include weight training. You can also talk with your nutritionist to develop a nutrition program that will effectively build lean mass. If you are simply looking to build lean mass, but not necessarily lose fat mass, your program may be quite different than a program that is geared towards a more balanced fat percentage reduction. Consult with your trainer, nutritionist, coaches, and/or doctors to set up a plan.':
      'Puedes aumentar tu masa magra participando en programas de fitness que incluyan entrenamiento con pesas. También puedes hablar con tu nutricionista para desarrollar un programa de nutrición que aumente eficazmente la masa magra. Si simplemente buscas aumentar masa magra, pero no necesariamente perder masa grasa, tu programa puede ser muy diferente de uno orientado a una reducción más equilibrada del porcentaje de grasa. Consulta con tu entrenador, nutricionista, coaches y/o médicos para establecer un plan.',
  },
  de: {
    'All coaches and admins who are listed as either on the Fit3D platform by end of business (5pm PT), Wednesday July 31, 2018 are automatically entered. To be eligible for a prize, the winning coach much accept the prize via email confirmation.':
      'Alle Trainer und Administratoren, die bis Geschäftsschluss (17:00 Uhr PT) am Mittwoch, dem 31. Juli 2018, auf der Fit3D-Plattform aufgeführt sind, nehmen automatisch teil. Um für einen Preis berechtigt zu sein, muss der gewinnende Trainer den Preis per E-Mail-Bestätigung annehmen.',
    'All coaches and facility admins who are listed as either on the Fit3D platform are automatically entered. Void where prohibited or restricted by law or regulation. Not eligible are employees and their immediate families including household members of Fit3D, Inc. or their respective agents, attorneys, subsidiaries, divisions, and advertising and promotion agencies.':
      'Alle Trainer und Einrichtungsadministratoren, die auf der Fit3D-Plattform aufgeführt sind, nehmen automatisch teil. Ungültig, wo gesetzlich oder regulatorisch verboten oder eingeschränkt. Nicht teilnahmeberechtigt sind Mitarbeiter und deren unmittelbare Familienangehörige einschließlich Haushaltsmitglieder von Fit3D, Inc. oder deren jeweiligen Beauftragten, Anwälten, Tochtergesellschaften, Abteilungen sowie Werbe- und Promotionsagenturen.',
    'All facilities who own a Fit3D ProScanner are automatically entered. To be eligible for a prize, facilities much accept the prize via email confirmation.':
      'Alle Einrichtungen, die einen Fit3D ProScanner besitzen, nehmen automatisch teil. Um für einen Preis berechtigt zu sein, müssen Einrichtungen den Preis per E-Mail-Bestätigung annehmen.',
    'At the end of the Competition Period, Fit3D will announce the top ten coaches/admins of the competition in an email September 10, 2018. The winner will be notified directly via electronic mail on September 11, 2018 and will have three (3) days to confirm a desire to receive their prizes. If prizes are not confirmed, the prize may be forfeited and offered to another winner.':
      'Am Ende des Wettbewerbszeitraums wird Fit3D die zehn besten Trainer/Administratoren des Wettbewerbs in einer E-Mail am 10. September 2018 bekannt geben. Der Gewinner wird am 11. September 2018 direkt per E-Mail benachrichtigt und hat drei (3) Tage Zeit, den Wunsch zum Erhalt der Preise zu bestätigen. Wenn die Preise nicht bestätigt werden, können sie verfallen und einem anderen Gewinner angeboten werden.',
    'At the end of the Raffle Period, Fit3D will announce the amount of New User Raffle Tickets and Scan Raffle Tickets for each facility on or before August 10, 2018. The Raffle will take place on August 13, 2018 and the six (6) winners will be notified via electronic mail on August 15, 2018. The winners will have three (3) days to confirm a desire to receive their prizes. If prizes are not confirmed, the prize may be forfeited and offered to another winner.':
      'Am Ende des Verlosungszeitraums wird Fit3D die Anzahl der Lose für neue Benutzer und Scan-Lose jeder Einrichtung spätestens am 10. August 2018 bekannt geben. Die Verlosung findet am 13. August 2018 statt, und die sechs (6) Gewinner werden am 15. August 2018 per E-Mail benachrichtigt. Die Gewinner haben drei (3) Tage Zeit, den Wunsch zum Erhalt ihrer Preise zu bestätigen. Wenn die Preise nicht bestätigt werden, können sie verfallen und einem anderen Gewinner angeboten werden.',
    'Basal Metabolic Rate (BMR) is the amount of energy expended while at rest in a neutrally temperate environment and in the post-absorptive state. In this state, the digestive system is inactive, which is usually achieved by about twelve hours of fasting. Furthermore, BMR is the amount of energy expressed in calories that a person needs to keep the body functioning (i.e. breathing, blood circulation, controlling body temperature, cell growth, brain and nervous function, and contraction of muscles). BMR affects the rate at which a person burns calories and ultimately affects whether that individual maintains, gains, or loses weight.':
      'Die basale Stoffwechselrate (BMR) ist die Energiemenge, die im Ruhezustand in einer neutral temperierten Umgebung und im postabsorptiven Zustand verbraucht wird. In diesem Zustand ist das Verdauungssystem inaktiv, was normalerweise nach etwa zwölf Stunden Fasten erreicht wird. Außerdem ist die BMR die in Kalorien ausgedrückte Energiemenge, die eine Person benötigt, um die Körperfunktionen aufrechtzuerhalten (z. B. Atmung, Blutkreislauf, Kontrolle der Körpertemperatur, Zellwachstum, Gehirn- und Nervenfunktion sowie Muskelkontraktion). Die BMR beeinflusst die Rate, mit der eine Person Kalorien verbrennt, und wirkt sich letztlich darauf aus, ob diese Person ihr Gewicht hält, zunimmt oder abnimmt.',
    'Body fat percentage is the user’s total fat mass divided by the total body mass. Fat is an essential component of the body and is necessary to maintain life and reproductive functions; however, too much body fat can negatively affect overall health or hormone levels. It also serves as an indicator of more serious health problems that could potentially be faced in the future. The':
      'Der Körperfettanteil ist die gesamte Fettmasse des Benutzers geteilt durch die gesamte Körpermasse. Fett ist ein wesentlicher Bestandteil des Körpers und notwendig, um Leben und Fortpflanzungsfunktionen aufrechtzuerhalten; zu viel Körperfett kann jedoch die allgemeine Gesundheit oder den Hormonspiegel negativ beeinflussen. Es dient außerdem als Indikator für ernstere Gesundheitsprobleme, die künftig auftreten könnten. Der',
    "Body fat percentage is the user's total fat mass divided by the total body mass. Fat is an essential component of the body, however, too much body fat can negatively affect overall health.":
      'Der Körperfettanteil ist die gesamte Fettmasse des Benutzers geteilt durch die gesamte Körpermasse. Fett ist ein wesentlicher Bestandteil des Körpers; zu viel Körperfett kann jedoch die allgemeine Gesundheit negativ beeinflussen.',
    'Body Shape Rating (BSR) is a wellness score based on the relationship of your body shape to cardiovascular related risk factors. It answers the question, Is my body shape making it more likely for me potentially develop certain cardiovascular related health issues? BSR is on a 0-100 range where 50 is average and the higher the score the lower the risk.':
      'Die Körperformbewertung (BSR) ist ein Wellness-Wert, der auf dem Zusammenhang zwischen Ihrer Körperform und kardiovaskulären Risikofaktoren basiert. Sie beantwortet die Frage, ob meine Körperform die Wahrscheinlichkeit erhöht, bestimmte kardiovaskuläre Gesundheitsprobleme zu entwickeln. Die BSR liegt auf einer Skala von 0 bis 100, wobei 50 der Durchschnitt ist; je höher der Wert, desto niedriger das Risiko.',
    'Body weight is a person’s mass or weight. This is probably the easiest metric to measure on a human and is therefore a part of our primary assessment metrics; however, the body shape makeup and body composition is a much more real mechanism to determine the health of an individual.':
      'Das Körpergewicht ist die Masse oder das Gewicht einer Person. Dies ist wahrscheinlich die einfachste am Menschen zu messende Metrik und daher Teil unserer primären Bewertungsmetriken; Körperform und Körperzusammensetzung sind jedoch ein wesentlich aussagekräftigerer Mechanismus zur Bestimmung der Gesundheit einer Person.',
    'Click on value in the chart for a comparison against your demographic. The comparison will be shown on the right.':
      'Klicken Sie auf einen Wert im Diagramm, um ihn mit Ihrer demografischen Gruppe zu vergleichen. Der Vergleich wird rechts angezeigt.',
    "Coach must be listed as either a Coach or Admin on their facility's Fit3D Dashboard by end of business (5pm PT), Wednesday July 31, 2018 to be entered into the competition.":
      'Der Trainer muss bis Geschäftsschluss (17:00 Uhr PT) am Mittwoch, dem 31. Juli 2018, im Fit3D-Dashboard seiner Einrichtung als Trainer oder Administrator aufgeführt sein, um am Wettbewerb teilzunehmen.',
    'Fat mass is also known as adipose tissue within the body. This loose connective tissue is primarily composed of':
      'Fettmasse wird auch als Fettgewebe im Körper bezeichnet. Dieses lockere Bindegewebe besteht hauptsächlich aus',
    "Heart rate is the speed of the heartbeat measured by the number of contractions of the heart per minute (bpm). The heart rate can vary according to the body's":
      'Die Herzfrequenz ist die Geschwindigkeit des Herzschlags, gemessen an der Anzahl der Herzkontraktionen pro Minute (bpm). Die Herzfrequenz kann je nach Körper',
    'Lean mass is the muscle tissue, skeletal tissue, and water in the body. Lean mass burns more energy than fat mass, so increasing lean mass can help continue to reduce fat mass.':
      'Magermasse umfasst Muskelgewebe, Skelettgewebe und Wasser im Körper. Magermasse verbrennt mehr Energie als Fettmasse, daher kann eine Erhöhung der Magermasse weiterhin helfen, Fettmasse zu reduzieren.',
    'Metabolic age compares your basal metabolic rate (BMR) to the average BMR of people in different age groups. A lower metabolic age suggests better metabolic health and indicates that your body is functioning more efficiently than the typical person of your chronological age.':
      'Das metabolische Alter vergleicht Ihre basale Stoffwechselrate (BMR) mit der durchschnittlichen BMR von Menschen verschiedener Altersgruppen. Ein niedrigeres metabolisches Alter deutet auf eine bessere Stoffwechselgesundheit hin und zeigt, dass Ihr Körper effizienter funktioniert als bei einer typischen Person Ihres chronologischen Alters.',
    'No correspondence will be entered into by Sponsor. Any tax due on any prize is the sole responsibility of the winner. A completed W-9 will be required by Fit3D in order to issue prize winnings in cash. Winners hereby consent to the use of his/her name and photograph for promotional purposes without additional compensation, unless prohibited by law. Persons found tampering with or abusing any aspect of this contest as solely determined by the Sponsor will be disqualified from winning any prize. In the event the contest is compromised by a virus, bugs, non-authorized human intervention or other causes beyond the control of Sponsor which corrupts or impairs the administration, security, fairness or proper play of the contest, Sponsor reserves the right in its sole discretion to suspend or terminate the contest and award prizes in a later contest. Should the contest be terminated prior to the stated expiration date, notice will be posted at www.fit3d.com.':
      'Der Sponsor führt keine Korrespondenz. Alle auf einen Preis anfallenden Steuern liegen ausschließlich in der Verantwortung des Gewinners. Ein ausgefülltes W-9-Formular ist von Fit3D erforderlich, um Preisgelder in bar auszugeben. Die Gewinner stimmen hiermit der Verwendung ihres Namens und Fotos zu Werbezwecken ohne zusätzliche Vergütung zu, sofern dies nicht gesetzlich verboten ist. Personen, die nach alleiniger Feststellung des Sponsors irgendeinen Aspekt dieses Wettbewerbs manipulieren oder missbrauchen, werden vom Gewinn eines Preises ausgeschlossen. Falls der Wettbewerb durch einen Virus, Fehler, nicht autorisierte menschliche Eingriffe oder andere Ursachen außerhalb der Kontrolle des Sponsors beeinträchtigt wird, die Verwaltung, Sicherheit, Fairness oder ordnungsgemäßen Ablauf des Wettbewerbs verfälschen oder beeinträchtigen, behält sich der Sponsor nach eigenem Ermessen das Recht vor, den Wettbewerb auszusetzen oder zu beenden und Preise in einem späteren Wettbewerb zu vergeben. Sollte der Wettbewerb vor dem angegebenen Ablaufdatum beendet werden, wird ein Hinweis auf www.fit3d.com veröffentlicht.',
    'No correspondence will be entered into by Sponsor. Any tax due on any prize is the sole responsibility of the winner. Winners hereby consent to the use of his/her name and photograph for promotional purposes without additional compensation, unless prohibited by law. Persons found tampering with or abusing any aspect of this contest as solely determined by the Sponsor will be disqualified from winning any prize. In the event the contest is compromised by a virus, bugs, non-authorized human intervention or other causes beyond the control of Sponsor which corrupts or impairs the administration, security, fairness or proper play of the contest, Sponsor reserves the right in its sole discretion to suspend or terminate the contest and award prizes in a later contest. Should the contest be terminated prior to the stated expiration date, notice will be posted at www.fit3d.com.':
      'Der Sponsor führt keine Korrespondenz. Alle auf einen Preis anfallenden Steuern liegen ausschließlich in der Verantwortung des Gewinners. Die Gewinner stimmen hiermit der Verwendung ihres Namens und Fotos zu Werbezwecken ohne zusätzliche Vergütung zu, sofern dies nicht gesetzlich verboten ist. Personen, die nach alleiniger Feststellung des Sponsors irgendeinen Aspekt dieses Wettbewerbs manipulieren oder missbrauchen, werden vom Gewinn eines Preises ausgeschlossen. Falls der Wettbewerb durch einen Virus, Fehler, nicht autorisierte menschliche Eingriffe oder andere Ursachen außerhalb der Kontrolle des Sponsors beeinträchtigt wird, die Verwaltung, Sicherheit, Fairness oder ordnungsgemäßen Ablauf des Wettbewerbs verfälschen oder beeinträchtigen, behält sich der Sponsor nach eigenem Ermessen das Recht vor, den Wettbewerb auszusetzen oder zu beenden und Preise in einem späteren Wettbewerb zu vergeben. Sollte der Wettbewerb vor dem angegebenen Ablaufdatum beendet werden, wird ein Hinweis auf www.fit3d.com veröffentlicht.',
    'Raffle Period: July 1, 2018 at 12:01 AM (PST) and ending July 31, 2018 at 11:59 PM (PST) New User Raffle Tickets: Facilities will get 1 raffle ticket for every new user who has completed a scan after the first 100 new users who have completed a successful scan from the Facility’s ProScanner during the Raffle Period. Scan Raffle Tickets: Facilities will get 1 raffle ticket for every successfully completed scan after the first 100 successfully completed scans taken from the Facility’s ProScanner during the Raffle Period. user after':
      'Verlosungszeitraum: 1. Juli 2018 um 12:01 Uhr (PST) bis 31. Juli 2018 um 23:59 Uhr (PST). Lose für neue Benutzer: Einrichtungen erhalten 1 Los für jeden neuen Benutzer, der nach den ersten 100 neuen Benutzern einen Scan abgeschlossen hat, die während des Verlosungszeitraums einen erfolgreichen Scan mit dem ProScanner der Einrichtung abgeschlossen haben. Scan-Lose: Einrichtungen erhalten 1 Los für jeden erfolgreich abgeschlossenen Scan nach den ersten 100 erfolgreich abgeschlossenen Scans, die während des Verlosungszeitraums mit dem ProScanner der Einrichtung durchgeführt wurden. Benutzer nach',
    'Remove all access for coach? You can always add these coaches back later in the Add Coaches page.':
      'Allen Zugriff für den Trainer entfernen? Sie können diese Trainer später jederzeit auf der Seite Trainer hinzufügen wieder hinzufügen.',
    'Similar to WHR where body shape is described using a ratio, but instead of waist and hips circumferences, body trunk/torso and leg volumes are used. By using volume it captures a more detailed view of body shape. A lower trunk to leg volume ratio generally means lower risk for certain health issues.':
      'Ähnlich wie beim WHR, bei dem die Körperform anhand eines Verhältnisses beschrieben wird, werden hier jedoch statt Taillen- und Hüftumfang die Volumina von Rumpf/Torso und Beinen verwendet. Durch die Verwendung von Volumen entsteht eine detailliertere Sicht auf die Körperform. Ein niedrigeres Verhältnis von Rumpf- zu Beinvolumen bedeutet im Allgemeinen ein geringeres Risiko für bestimmte Gesundheitsprobleme.',
    'The 2-component model, which consists of fat mass and lean mass calculations, is widely used to determine body composition. Fat mass is the mass of the adipose tissue in the body. Lean mass is the muscle tissue, skeletal tissue, and water in the body. In 3- and 4-component models, skeletal tissue and water are drawn out as isolated measurements.':
      'Das 2-Komponenten-Modell, das aus Berechnungen von Fettmasse und Magermasse besteht, wird häufig zur Bestimmung der Körperzusammensetzung verwendet. Fettmasse ist die Masse des Fettgewebes im Körper. Magermasse ist Muskelgewebe, Skelettgewebe und Wasser im Körper. In 3- und 4-Komponenten-Modellen werden Skelettgewebe und Wasser als isolierte Messungen ausgewiesen.',
    'The body is designed to be in balance including head, shoulders, rib cage, pelvis, and knees for perfect balance from front and side views. Posture quality is measured by calculating deviations between your posture and "normal" balanced posture.':
      'Der Körper ist auf Gleichgewicht ausgelegt, einschließlich Kopf, Schultern, Brustkorb, Becken und Knien, um aus Vorder- und Seitenansicht ein perfektes Gleichgewicht zu erreichen. Die Haltungsqualität wird gemessen, indem Abweichungen zwischen Ihrer Haltung und einer "normalen" ausgeglichenen Haltung berechnet werden.',
    'The chart below shows how you compare against recommended healthy ranges as well as how you compare to other Fit3D users with your same gender and similar age.':
      'Die folgende Grafik zeigt, wie Sie im Vergleich zu empfohlenen gesunden Bereichen abschneiden und wie Sie im Vergleich zu anderen Fit3D-Benutzern mit demselben Geschlecht und ähnlichem Alter abschneiden.',
    'The coach or facility admin who helps clients/members complete the most valid Fit3D body scans during the month of August 2018.':
      'Der Trainer oder Einrichtungsadministrator, der Kunden/Mitgliedern im August 2018 dabei hilft, die meisten gültigen Fit3D-Körperscans abzuschließen.',
    'The primary way to improve your BSR is to increase the density of your body, build the muscle in your legs, and decrease your waist circumference.':
      'Der wichtigste Weg zur Verbesserung Ihrer BSR besteht darin, die Dichte Ihres Körpers zu erhöhen, Muskeln in den Beinen aufzubauen und den Taillenumfang zu verringern.',
    'The total amount of fat in the body. There are multiple types of fat in the body which have very different effects on overall healthy. The body shape tab can provide more insight into how fat distribution factors into potential health risks.':
      'Die Gesamtmenge an Fett im Körper. Es gibt mehrere Fettarten im Körper, die sehr unterschiedliche Auswirkungen auf die allgemeine Gesundheit haben. Die Registerkarte Körperform kann mehr Einblick geben, wie die Fettverteilung potenzielle Gesundheitsrisiken beeinflusst.',
    'This can be done through a balanced mix of good nutrition and exercise that includes higher intensity interval training. Consult with your trainer, nutritionist, coaches, and/or doctors to set up a plan':
      'Dies kann durch eine ausgewogene Kombination aus guter Ernährung und Bewegung erreicht werden, die Intervalltraining mit höherer Intensität einschließt. Wenden Sie sich an Ihren Trainer, Ernährungsberater, Coaches und/oder Ärzte, um einen Plan zu erstellen',
    'This can be done through a balanced mix of good nutrition and exercise. Consult with your trainer, nutritionist, coaches, or doctors to set up a plan.':
      'Dies kann durch eine ausgewogene Kombination aus guter Ernährung und Bewegung erreicht werden. Wenden Sie sich an Ihren Trainer, Ernährungsberater, Coaches oder Ärzte, um einen Plan zu erstellen.',
    'This formula is dependent on volume, not weight. The overly simple way to improve your Trunk to Leg Volume score is to decrease the volume of your midsection and increase the volume of your legs.':
      'Diese Formel hängt vom Volumen ab, nicht vom Gewicht. Der stark vereinfachte Weg zur Verbesserung Ihres Rumpf-zu-Bein-Volumenwerts besteht darin, das Volumen Ihrer Körpermitte zu verringern und das Volumen Ihrer Beine zu erhöhen.',
    'This ratio as a health metric is extremely limited, but it is an easy way to try to evaluate the level of visceral fat one may have.':
      'Dieses Verhältnis ist als Gesundheitsmetrik äußerst begrenzt, aber eine einfache Möglichkeit, das mögliche Niveau an viszeralem Fett einzuschätzen.',
    'Through research partnerships with public and private institutions, Fit3D has scanned thousands of people with Fit3D and DXA systems side by side. Fit3D has subsequently created algorithms that utilize hundreds of measurements automatically extracted from these body scans to calculate a user’s body fat percentage.':
      'Durch Forschungspartnerschaften mit öffentlichen und privaten Institutionen hat Fit3D Tausende von Menschen parallel mit Fit3D- und DXA-Systemen gescannt. Fit3D hat anschließend Algorithmen erstellt, die Hunderte automatisch aus diesen Körperscans extrahierter Messungen verwenden, um den Körperfettanteil eines Benutzers zu berechnen.',
    'To better understand ABSI, SBSI, Body Fat Percentage and Trunk to Leg Volume Ratio, please refer to the descriptions below or the research from the following links:':
      'Um ABSI, SBSI, Körperfettanteil und das Rumpf-zu-Bein-Volumenverhältnis besser zu verstehen, lesen Sie bitte die folgenden Beschreibungen oder die Forschung unter den folgenden Links:',
    'Trunk to Leg Volume Ratio compares the volume of your trunk with the volume of your legs. This can generally only be done with some type of body scanning, whether it be Fit3D or more costly and complex scanners like DXA or MRI. Research claims that having a high percentage of your body’s volume in your torso compared to your legs increases the likelihood of you experiencing prediabetes, diabetes, high triglyceride (fat) counts, high blood pressure, metabolic syndromes, and other severe health complications.':
      'Das Rumpf-zu-Bein-Volumenverhältnis vergleicht das Volumen Ihres Rumpfs mit dem Volumen Ihrer Beine. Dies kann im Allgemeinen nur mit einer Form des Körperscannings erfolgen, sei es Fit3D oder teurere und komplexere Scanner wie DXA oder MRI. Forschungsergebnisse zeigen, dass ein hoher Anteil des Körpervolumens im Oberkörper im Vergleich zu den Beinen die Wahrscheinlichkeit für Prädiabetes, Diabetes, hohe Triglyceridwerte (Fettwerte), Bluthochdruck, metabolische Syndrome und andere schwere gesundheitliche Komplikationen erhöht.',
    "Validating scans is highly important because it allows you to obtain the best possible data. Fit3D's scans are highly accurate, but there are several factors that could cause issues. Walking through this scan will allow you to identify some of the factors that might lead to an improper scan.":
      'Die Validierung von Scans ist sehr wichtig, da Sie dadurch die bestmöglichen Daten erhalten. Die Scans von Fit3D sind sehr genau, aber es gibt mehrere Faktoren, die Probleme verursachen können. Die Durchsicht dieses Scans ermöglicht es Ihnen, einige Faktoren zu erkennen, die zu einem fehlerhaften Scan führen könnten.',
    'Waist circumference (WC) provides a prediction of risk independent of BMI. WC is particularly useful for patients who are categorized as normal or overweight on the BMI scale as a measurement associated with visceral fat and overall body shape.':
      'Der Taillenumfang (WC) liefert eine Risikovorhersage unabhängig vom BMI. WC ist besonders nützlich für Patienten, die auf der BMI-Skala als normal oder übergewichtig eingestuft werden, da diese Messung mit viszeralem Fett und der gesamten Körperform verbunden ist.',
    'Waist to hip ratio describes body shape using a ratio between waist and hips. A lower ratio generally means lower risk for certain health issues. If you have heard of body shapes described as apple or pear, these are two ends of the WHR spectrum where pear has a lower WHR ratio and therefore lower risk for certain health issues.':
      'Das Taille-Hüfte-Verhältnis beschreibt die Körperform anhand eines Verhältnisses zwischen Taille und Hüfte. Ein niedrigeres Verhältnis bedeutet im Allgemeinen ein geringeres Risiko für bestimmte Gesundheitsprobleme. Wenn Sie von Körperformen gehört haben, die als Apfel oder Birne beschrieben werden, sind dies zwei Enden des WHR-Spektrums, wobei die Birnenform ein niedrigeres WHR-Verhältnis und daher ein geringeres Risiko für bestimmte Gesundheitsprobleme aufweist.',
    'We suggest that you consult with your trainer, nutritionist, coaches, and/or doctors to set up a plan before focusing solely on your WHR.':
      'Wir empfehlen, dass Sie mit Ihrem Trainer, Ernährungsberater, Coaches und/oder Ärzten einen Plan erstellen, bevor Sie sich ausschließlich auf Ihr WHR konzentrieren.',
    "We'll pass your measurements and/or scan to this vendor for a potential better fit. For more information about what is being passed on, view our":
      'Wir geben Ihre Messungen und/oder Ihren Scan an diesen Anbieter weiter, um möglicherweise eine bessere Passform zu erhalten. Weitere Informationen dazu, was weitergegeben wird, finden Sie in unserer',
    'Weight in your mid-section is highly correlated with visceral fat, which is the unhealthy fat around your organs. If you have a big belly and smaller legs, it is a good assumption that your weight is centered around your midsection and is therefore visceral fat.':
      'Gewicht in der Körpermitte korreliert stark mit viszeralem Fett, dem ungesunden Fett um Ihre Organe. Wenn Sie einen großen Bauch und kleinere Beine haben, ist die Annahme naheliegend, dass Ihr Gewicht in der Körpermitte konzentriert ist und daher viszerales Fett darstellt.',
    'While you cannot spot reduced fat mass throughout your body, you can still work with your coaches to reduce the amount throughout your body, which will generally decrease the circumference of your mid-section. WHR is extremely limited in scope, but is widely used as a metric of health.':
      'Auch wenn Sie Fettmasse nicht gezielt an einzelnen Stellen reduzieren können, können Sie dennoch mit Ihren Coaches daran arbeiten, die Menge im gesamten Körper zu reduzieren, was im Allgemeinen den Umfang Ihrer Körpermitte verringert. WHR ist im Umfang äußerst begrenzt, wird aber weithin als Gesundheitsmetrik verwendet.',
    'WHR is a ratio generally used to evaluate whether the individual is at high risk of obesity, diabetes, coronary heart disease, and/or high blood pressure. The measurement evaluates body shape in the midsection of the body.':
      'WHR ist ein Verhältnis, das im Allgemeinen verwendet wird, um zu beurteilen, ob eine Person ein hohes Risiko für Adipositas, Diabetes, koronare Herzkrankheit und/oder Bluthochdruck hat. Die Messung bewertet die Körperform in der Körpermitte.',
    'You can decrease your body fat percentage through a balanced mix of good nutrition and exercise that includes higher intensity interval training and cardio. Consult with your trainer, nutritionist, coaches, and/or doctors to set up a plan.':
      'Sie können Ihren Körperfettanteil durch eine ausgewogene Kombination aus guter Ernährung und Bewegung senken, die Intervalltraining mit höherer Intensität und Cardio einschließt. Wenden Sie sich an Ihren Trainer, Ernährungsberater, Coaches und/oder Ärzte, um einen Plan zu erstellen.',
    'You can increase your BMR by participating in fitness programs that include high intensity interval training or lifting weights to build muscle. You can further increase your BMR by eating more protein, eating many smaller-portioned meals per day, and staying hydrated. The rule of thumb here is that muscle requires more energy to survive—the more lean muscle you have on your body, the higher your BMR. Consult with your trainer, nutritionist, coaches, and/or doctors to set up a plan.':
      'Sie können Ihre BMR erhöhen, indem Sie an Fitnessprogrammen teilnehmen, die hochintensives Intervalltraining oder Gewichtheben zum Muskelaufbau beinhalten. Sie können Ihre BMR weiter erhöhen, indem Sie mehr Protein essen, täglich mehrere kleinere Mahlzeiten zu sich nehmen und hydratisiert bleiben. Die Faustregel lautet: Muskeln benötigen mehr Energie zum Erhalt; je mehr magere Muskelmasse Sie am Körper haben, desto höher ist Ihre BMR. Wenden Sie sich an Ihren Trainer, Ernährungsberater, Coaches und/oder Ärzte, um einen Plan zu erstellen.',
    'You can increase your lean mass by participating in fitness programs that include weight training. You can also talk with your nutritionist to develop a nutrition program that will effectively build lean mass. If you are simply looking to build lean mass, but not necessarily lose fat mass, your program may be quite different than a program that is geared towards a more balanced fat percentage reduction. Consult with your trainer, nutritionist, coaches, and/or doctors to set up a plan.':
      'Sie können Ihre Magermasse erhöhen, indem Sie an Fitnessprogrammen teilnehmen, die Krafttraining beinhalten. Sie können auch mit Ihrem Ernährungsberater sprechen, um ein Ernährungsprogramm zu entwickeln, das Magermasse effektiv aufbaut. Wenn Sie lediglich Magermasse aufbauen möchten, aber nicht unbedingt Fettmasse verlieren wollen, kann Ihr Programm ganz anders aussehen als ein Programm, das auf eine ausgewogenere Reduzierung des Fettanteils ausgerichtet ist. Wenden Sie sich an Ihren Trainer, Ernährungsberater, Coaches und/oder Ärzte, um einen Plan zu erstellen.',
  },
}

const downloadableReportPhraseTranslations = reportAndGlossaryPhraseTranslations

const sharedWellnessActionTranslations = {
  fr: { 'Read More': 'Lire plus' },
  de: { 'Read More': 'Mehr lesen' },
  es: { 'Read More': 'Leer más' },
  pt: { 'Read More': 'Ler mais' },
  zh_CN: { 'Read More': '阅读更多' },
  zh_TW: { 'Read More': '閱讀更多' },
  it: { 'Read More': 'Leggi di più' },
  ko: { 'Read More': '더 보기' },
  nl: { 'Read More': 'Meer lezen' },
  fi: { 'Read More': 'Lue lisää' },
  ru: { 'Read More': 'Читать далее' },
  sv: { 'Read More': 'Läs mer' },
  ja: { 'Read More': '続きを読む' },
  tr: { 'Read More': 'Devamını oku' },
  cs: { 'Read More': 'Číst dál' },
  el: { 'Read More': 'Διαβάστε περισσότερα' },
  hr: { 'Read More': 'Pročitaj više' },
}

const dictionaryPhraseTranslations = {}
const phraseAliases = {
  Parqs: 'PARQs',
  PARQS: 'PARQs',
  'WAIST TO HIP RATIO': 'Waist to Hip Ratio',
}

const composableWordTranslations = {
  fr: {
    access: 'accès',
    account: 'compte',
    action: 'action',
    actions: 'actions',
    active: 'actif',
    add: 'ajouter',
    additional: 'supplémentaire',
    age: 'âge',
    all: 'tous',
    available: 'disponible',
    back: 'retour',
    baseline: 'référence',
    body: 'corps',
    cancel: 'annuler',
    change: 'modifier',
    client: 'client',
    clients: 'clients',
    coach: 'coach',
    coaches: 'coachs',
    compare: 'comparer',
    comparison: 'comparaison',
    complete: 'terminé',
    completed: 'terminé',
    confirm: 'confirmer',
    current: 'actuel',
    dashboard: 'tableau de bord',
    data: 'données',
    date: 'date',
    delete: 'supprimer',
    diff: 'différence',
    difference: 'différence',
    download: 'télécharger',
    edit: 'modifier',
    email: 'e-mail',
    error: 'erreur',
    facility: 'établissement',
    fat: 'graisse',
    filter: 'filtrer',
    first: 'prénom',
    fitness: 'forme',
    full: 'complet',
    gender: 'genre',
    goal: 'objectif',
    goals: 'objectifs',
    health: 'santé',
    height: 'taille',
    history: 'historique',
    image: 'image',
    images: 'images',
    i: 'je',
    information: 'information',
    interest: 'intérêt',
    last: 'dernier',
    lean: 'maigre',
    level: 'niveau',
    mass: 'masse',
    measurement: 'mesure',
    measurements: 'mesures',
    metric: 'métrique',
    metrics: 'métriques',
    name: 'nom',
    new: 'nouveau',
    no: 'aucun',
    not: 'non',
    page: 'page',
    password: 'mot de passe',
    posture: 'posture',
    profile: 'profil',
    rating: 'note',
    remove: 'supprimer',
    report: 'rapport',
    request: 'demande',
    result: 'résultat',
    results: 'résultats',
    scan: 'scan',
    scans: 'scans',
    select: 'sélectionner',
    shape: 'forme',
    status: 'statut',
    submit: 'envoyer',
    summary: 'résumé',
    survey: 'questionnaire',
    user: 'utilisateur',
    users: 'utilisateurs',
    view: 'voir',
    visible: 'visible',
    what: 'que',
    waist: 'taille',
    weight: 'poids',
    wellness: 'bien-être',
    win: 'gain',
    wins: 'gains',
    your: 'votre',
    do: 'faire',
  },
  pt: {
    access: 'acesso',
    account: 'conta',
    action: 'ação',
    actions: 'ações',
    active: 'ativo',
    add: 'adicionar',
    additional: 'adicional',
    age: 'idade',
    all: 'todos',
    available: 'disponível',
    back: 'voltar',
    baseline: 'referência',
    body: 'corpo',
    cancel: 'cancelar',
    change: 'alterar',
    client: 'cliente',
    clients: 'clientes',
    coach: 'coach',
    coaches: 'coaches',
    compare: 'comparar',
    comparison: 'comparação',
    complete: 'concluído',
    completed: 'concluído',
    confirm: 'confirmar',
    current: 'atual',
    dashboard: 'painel',
    data: 'dados',
    date: 'data',
    delete: 'excluir',
    diff: 'diferença',
    difference: 'diferença',
    download: 'baixar',
    edit: 'editar',
    email: 'e-mail',
    error: 'erro',
    facility: 'instalação',
    fat: 'gordura',
    filter: 'filtrar',
    first: 'primeiro',
    fitness: 'fitness',
    full: 'completo',
    gender: 'gênero',
    goal: 'meta',
    goals: 'metas',
    health: 'saúde',
    height: 'altura',
    history: 'histórico',
    image: 'imagem',
    images: 'imagens',
    i: 'eu',
    information: 'informação',
    interest: 'interesse',
    last: 'último',
    lean: 'magra',
    level: 'nível',
    mass: 'massa',
    measurement: 'medida',
    measurements: 'medidas',
    metric: 'métrica',
    metrics: 'métricas',
    name: 'nome',
    new: 'novo',
    no: 'sem',
    not: 'não',
    page: 'página',
    password: 'senha',
    posture: 'postura',
    profile: 'perfil',
    rating: 'classificação',
    remove: 'remover',
    report: 'relatório',
    request: 'solicitação',
    result: 'resultado',
    results: 'resultados',
    scan: 'scan',
    scans: 'scans',
    select: 'selecionar',
    shape: 'forma',
    status: 'status',
    submit: 'enviar',
    summary: 'resumo',
    survey: 'questionário',
    user: 'usuário',
    users: 'usuários',
    view: 'ver',
    visible: 'visível',
    what: 'o que',
    waist: 'cintura',
    weight: 'peso',
    wellness: 'bem-estar',
    win: 'vitória',
    wins: 'vitórias',
    your: 'seu',
    do: 'fazer',
  },
  zh_CN: {
    access: '访问',
    account: '账户',
    action: '操作',
    actions: '操作',
    active: '活跃',
    add: '添加',
    additional: '附加',
    age: '年龄',
    all: '全部',
    available: '可用',
    back: '返回',
    baseline: '基准',
    body: '身体',
    cancel: '取消',
    change: '更改',
    client: '客户',
    clients: '客户',
    coach: '教练',
    coaches: '教练',
    compare: '比较',
    comparison: '比较',
    complete: '完成',
    completed: '已完成',
    confirm: '确认',
    current: '当前',
    dashboard: '仪表板',
    data: '数据',
    date: '日期',
    delete: '删除',
    diff: '差异',
    difference: '差异',
    download: '下载',
    edit: '编辑',
    email: '电子邮件',
    error: '错误',
    facility: '场馆',
    fat: '脂肪',
    filter: '筛选',
    first: '第一页',
    fitness: '健身',
    full: '完整',
    gender: '性别',
    goal: '目标',
    goals: '目标',
    health: '健康',
    height: '身高',
    history: '历史',
    image: '图像',
    images: '图像',
    i: '我',
    information: '信息',
    interest: '兴趣',
    last: '最后',
    lean: '瘦体重',
    level: '级别',
    mass: '质量',
    measurement: '测量',
    measurements: '测量',
    metric: '指标',
    metrics: '指标',
    name: '名称',
    new: '新',
    no: '无',
    not: '不',
    page: '页面',
    password: '密码',
    posture: '姿势',
    profile: '资料',
    rating: '评分',
    remove: '移除',
    report: '报告',
    request: '请求',
    result: '结果',
    results: '结果',
    scan: '扫描',
    scans: '扫描',
    select: '选择',
    shape: '形状',
    status: '状态',
    submit: '提交',
    summary: '摘要',
    survey: '问卷',
    user: '用户',
    users: '用户',
    view: '查看',
    visible: '可见',
    what: '什么',
    waist: '腰围',
    weight: '体重',
    wellness: '健康',
    win: '成功',
    wins: '成功',
    your: '您的',
    do: '做',
  },
  zh_TW: {
    access: '存取',
    account: '帳戶',
    action: '操作',
    actions: '操作',
    active: '活躍',
    add: '新增',
    additional: '附加',
    age: '年齡',
    all: '全部',
    available: '可用',
    back: '返回',
    baseline: '基準',
    body: '身體',
    cancel: '取消',
    change: '變更',
    client: '客戶',
    clients: '客戶',
    coach: '教練',
    coaches: '教練',
    compare: '比較',
    comparison: '比較',
    complete: '完成',
    completed: '已完成',
    confirm: '確認',
    current: '目前',
    dashboard: '儀表板',
    data: '資料',
    date: '日期',
    delete: '刪除',
    diff: '差異',
    difference: '差異',
    download: '下載',
    edit: '編輯',
    email: '電子郵件',
    error: '錯誤',
    facility: '場館',
    fat: '脂肪',
    filter: '篩選',
    first: '第一頁',
    fitness: '健身',
    full: '完整',
    gender: '性別',
    goal: '目標',
    goals: '目標',
    health: '健康',
    height: '身高',
    history: '歷史',
    image: '圖片',
    images: '圖片',
    i: '我',
    information: '資訊',
    interest: '興趣',
    last: '最後',
    lean: '瘦體重',
    level: '等級',
    mass: '質量',
    measurement: '測量',
    measurements: '測量',
    metric: '指標',
    metrics: '指標',
    name: '名稱',
    new: '新',
    no: '無',
    not: '不',
    page: '頁面',
    password: '密碼',
    posture: '姿勢',
    profile: '資料',
    rating: '評分',
    remove: '移除',
    report: '報告',
    request: '請求',
    result: '結果',
    results: '結果',
    scan: '掃描',
    scans: '掃描',
    select: '選擇',
    shape: '形狀',
    status: '狀態',
    submit: '提交',
    summary: '摘要',
    survey: '問卷',
    user: '使用者',
    users: '使用者',
    view: '查看',
    visible: '可見',
    what: '什麼',
    waist: '腰圍',
    weight: '體重',
    wellness: '健康',
    win: '成功',
    wins: '成功',
    your: '您的',
    do: '做',
  },
  it: {
    access: 'accesso',
    account: 'account',
    action: 'azione',
    actions: 'azioni',
    active: 'attivo',
    add: 'aggiungi',
    additional: 'aggiuntivo',
    age: 'età',
    all: 'tutti',
    available: 'disponibile',
    back: 'indietro',
    baseline: 'riferimento',
    body: 'corpo',
    cancel: 'annulla',
    change: 'modifica',
    client: 'cliente',
    clients: 'clienti',
    coach: 'coach',
    coaches: 'coach',
    compare: 'confronta',
    comparison: 'confronto',
    complete: 'completo',
    completed: 'completato',
    confirm: 'conferma',
    current: 'attuale',
    dashboard: 'dashboard',
    data: 'dati',
    date: 'data',
    delete: 'elimina',
    diff: 'differenza',
    difference: 'differenza',
    download: 'scarica',
    edit: 'modifica',
    email: 'e-mail',
    error: 'errore',
    facility: 'struttura',
    fat: 'grasso',
    filter: 'filtra',
    first: 'primo',
    fitness: 'fitness',
    full: 'completo',
    gender: 'genere',
    goal: 'obiettivo',
    goals: 'obiettivi',
    health: 'salute',
    height: 'altezza',
    history: 'cronologia',
    image: 'immagine',
    images: 'immagini',
    i: 'io',
    information: 'informazioni',
    interest: 'interesse',
    last: 'ultimo',
    lean: 'magra',
    level: 'livello',
    mass: 'massa',
    measurement: 'misura',
    measurements: 'misure',
    metric: 'metrica',
    metrics: 'metriche',
    name: 'nome',
    new: 'nuovo',
    no: 'nessun',
    not: 'non',
    page: 'pagina',
    password: 'password',
    posture: 'postura',
    profile: 'profilo',
    rating: 'valutazione',
    remove: 'rimuovi',
    report: 'rapporto',
    request: 'richiesta',
    result: 'risultato',
    results: 'risultati',
    scan: 'scansione',
    scans: 'scansioni',
    select: 'seleziona',
    shape: 'forma',
    status: 'stato',
    submit: 'invia',
    summary: 'riepilogo',
    survey: 'sondaggio',
    user: 'utente',
    users: 'utenti',
    view: 'visualizza',
    forward: 'avanti',
    left: 'sinistra',
    right: 'destra',
    visible: 'visibile',
    what: 'cosa',
    waist: 'vita',
    weight: 'peso',
    wellness: 'benessere',
    win: 'vittoria',
    wins: 'vittorie',
    your: 'tuo',
    do: 'fare',
  },
  ko: {
    access: '접근',
    account: '계정',
    action: '작업',
    actions: '작업',
    active: '활성',
    add: '추가',
    additional: '추가',
    age: '나이',
    all: '전체',
    available: '사용 가능',
    back: '뒤로',
    baseline: '기준',
    body: '신체',
    cancel: '취소',
    change: '변경',
    client: '고객',
    clients: '고객',
    coach: '코치',
    coaches: '코치',
    compare: '비교',
    comparison: '비교',
    complete: '완료',
    completed: '완료됨',
    confirm: '확인',
    current: '현재',
    dashboard: '대시보드',
    data: '데이터',
    date: '날짜',
    delete: '삭제',
    diff: '차이',
    difference: '차이',
    download: '다운로드',
    edit: '편집',
    email: '이메일',
    error: '오류',
    facility: '시설',
    fat: '지방',
    filter: '필터',
    first: '처음',
    fitness: '피트니스',
    full: '전체',
    gender: '성별',
    goal: '목표',
    goals: '목표',
    health: '건강',
    height: '신장',
    history: '기록',
    image: '이미지',
    images: '이미지',
    i: '나',
    information: '정보',
    interest: '관심',
    last: '마지막',
    lean: '제지방',
    level: '수준',
    mass: '질량',
    measurement: '측정',
    measurements: '측정',
    metric: '지표',
    metrics: '지표',
    name: '이름',
    new: '새',
    no: '없음',
    not: '아님',
    page: '페이지',
    password: '비밀번호',
    posture: '자세',
    profile: '프로필',
    rating: '평가',
    remove: '제거',
    report: '보고서',
    request: '요청',
    result: '결과',
    results: '결과',
    scan: '스캔',
    scans: '스캔',
    select: '선택',
    shape: '형태',
    status: '상태',
    submit: '제출',
    summary: '요약',
    survey: '설문',
    user: '사용자',
    users: '사용자',
    view: '보기',
    visible: '표시',
    what: '무엇',
    waist: '허리',
    weight: '체중',
    wellness: '웰니스',
    win: '성공',
    wins: '성공',
    your: '귀하의',
    do: '하기',
  },
  nl: {
    access: 'toegang',
    account: 'account',
    action: 'actie',
    actions: 'acties',
    active: 'actief',
    add: 'toevoegen',
    additional: 'aanvullend',
    age: 'leeftijd',
    all: 'alle',
    available: 'beschikbaar',
    back: 'terug',
    baseline: 'referentie',
    body: 'lichaam',
    cancel: 'annuleren',
    change: 'wijzigen',
    client: 'klant',
    clients: 'klanten',
    coach: 'coach',
    coaches: 'coaches',
    compare: 'vergelijken',
    comparison: 'vergelijking',
    complete: 'voltooid',
    completed: 'voltooid',
    confirm: 'bevestigen',
    current: 'huidig',
    dashboard: 'dashboard',
    data: 'gegevens',
    date: 'datum',
    delete: 'verwijderen',
    diff: 'verschil',
    difference: 'verschil',
    download: 'downloaden',
    edit: 'bewerken',
    email: 'e-mail',
    error: 'fout',
    facility: 'faciliteit',
    fat: 'vet',
    filter: 'filter',
    first: 'eerste',
    fitness: 'fitness',
    full: 'volledig',
    gender: 'geslacht',
    goal: 'doel',
    goals: 'doelen',
    health: 'gezondheid',
    height: 'lengte',
    history: 'geschiedenis',
    image: 'afbeelding',
    images: 'afbeeldingen',
    i: 'ik',
    information: 'informatie',
    interest: 'interesse',
    last: 'laatste',
    lean: 'magere',
    level: 'niveau',
    mass: 'massa',
    measurement: 'meting',
    measurements: 'metingen',
    metric: 'metriek',
    metrics: 'metrieken',
    name: 'naam',
    new: 'nieuw',
    no: 'geen',
    not: 'niet',
    page: 'pagina',
    password: 'wachtwoord',
    posture: 'houding',
    profile: 'profiel',
    rating: 'beoordeling',
    remove: 'verwijderen',
    report: 'rapport',
    request: 'verzoek',
    result: 'resultaat',
    results: 'resultaten',
    scan: 'scan',
    scans: 'scans',
    select: 'selecteren',
    shape: 'vorm',
    status: 'status',
    submit: 'indienen',
    summary: 'samenvatting',
    survey: 'vragenlijst',
    user: 'gebruiker',
    users: 'gebruikers',
    view: 'bekijken',
    visible: 'zichtbaar',
    what: 'wat',
    waist: 'taille',
    weight: 'gewicht',
    wellness: 'welzijn',
    win: 'win',
    wins: 'wins',
    your: 'uw',
    do: 'doen',
  },
  fi: {
    access: 'käyttöoikeus',
    account: 'tili',
    action: 'toiminto',
    actions: 'toiminnot',
    active: 'aktiivinen',
    add: 'lisää',
    additional: 'lisä',
    age: 'ikä',
    all: 'kaikki',
    available: 'saatavilla',
    back: 'takaisin',
    baseline: 'vertailu',
    body: 'keho',
    cancel: 'peruuta',
    change: 'muuta',
    client: 'asiakas',
    clients: 'asiakkaat',
    coach: 'valmentaja',
    coaches: 'valmentajat',
    compare: 'vertaa',
    comparison: 'vertailu',
    complete: 'valmis',
    completed: 'valmis',
    confirm: 'vahvista',
    current: 'nykyinen',
    dashboard: 'hallintapaneeli',
    data: 'tiedot',
    date: 'päivämäärä',
    delete: 'poista',
    diff: 'ero',
    difference: 'ero',
    download: 'lataa',
    edit: 'muokkaa',
    email: 'sähköposti',
    error: 'virhe',
    facility: 'toimipiste',
    fat: 'rasva',
    filter: 'suodata',
    first: 'ensimmäinen',
    fitness: 'kunto',
    full: 'täysi',
    gender: 'sukupuoli',
    goal: 'tavoite',
    goals: 'tavoitteet',
    health: 'terveys',
    height: 'pituus',
    history: 'historia',
    image: 'kuva',
    images: 'kuvat',
    i: 'minä',
    information: 'tiedot',
    interest: 'kiinnostus',
    last: 'viimeinen',
    lean: 'rasvaton',
    level: 'taso',
    mass: 'massa',
    measurement: 'mittaus',
    measurements: 'mittaukset',
    metric: 'mittari',
    metrics: 'mittarit',
    name: 'nimi',
    new: 'uusi',
    no: 'ei',
    not: 'ei',
    page: 'sivu',
    password: 'salasana',
    posture: 'ryhti',
    profile: 'profiili',
    rating: 'arvio',
    remove: 'poista',
    report: 'raportti',
    request: 'pyyntö',
    result: 'tulos',
    results: 'tulokset',
    scan: 'skannaus',
    scans: 'skannaukset',
    select: 'valitse',
    shape: 'muoto',
    status: 'tila',
    submit: 'lähetä',
    summary: 'yhteenveto',
    survey: 'kysely',
    user: 'käyttäjä',
    users: 'käyttäjät',
    view: 'näytä',
    visible: 'näkyvä',
    what: 'mitä',
    waist: 'vyötärö',
    weight: 'paino',
    wellness: 'hyvinvointi',
    win: 'voitto',
    wins: 'voitot',
    your: 'sinun',
    do: 'tehdä',
  },
  ru: {
    access: 'доступ',
    account: 'аккаунт',
    action: 'действие',
    actions: 'действия',
    active: 'активный',
    add: 'добавить',
    additional: 'дополнительный',
    age: 'возраст',
    all: 'все',
    available: 'доступно',
    back: 'назад',
    baseline: 'исходный',
    body: 'тело',
    cancel: 'отмена',
    change: 'изменить',
    client: 'клиент',
    clients: 'клиенты',
    coach: 'тренер',
    coaches: 'тренеры',
    compare: 'сравнить',
    comparison: 'сравнение',
    complete: 'завершено',
    completed: 'завершено',
    confirm: 'подтвердить',
    current: 'текущий',
    dashboard: 'панель',
    data: 'данные',
    date: 'дата',
    delete: 'удалить',
    diff: 'разница',
    difference: 'разница',
    download: 'скачать',
    edit: 'редактировать',
    email: 'эл. почта',
    error: 'ошибка',
    facility: 'объект',
    fat: 'жир',
    filter: 'фильтр',
    first: 'первый',
    fitness: 'фитнес',
    full: 'полный',
    gender: 'пол',
    goal: 'цель',
    goals: 'цели',
    health: 'здоровье',
    height: 'рост',
    history: 'история',
    image: 'изображение',
    images: 'изображения',
    i: 'я',
    information: 'информация',
    interest: 'интерес',
    last: 'последний',
    lean: 'безжировая',
    level: 'уровень',
    mass: 'масса',
    measurement: 'измерение',
    measurements: 'измерения',
    metric: 'метрика',
    metrics: 'метрики',
    name: 'имя',
    new: 'новый',
    no: 'нет',
    not: 'не',
    page: 'страница',
    password: 'пароль',
    posture: 'осанка',
    profile: 'профиль',
    rating: 'оценка',
    remove: 'удалить',
    report: 'отчет',
    request: 'запрос',
    result: 'результат',
    results: 'результаты',
    scan: 'скан',
    scans: 'сканы',
    select: 'выбрать',
    shape: 'форма',
    status: 'статус',
    submit: 'отправить',
    summary: 'сводка',
    survey: 'опрос',
    user: 'пользователь',
    users: 'пользователи',
    view: 'просмотр',
    visible: 'видимый',
    what: 'что',
    waist: 'талия',
    weight: 'вес',
    wellness: 'здоровье',
    win: 'победа',
    wins: 'победы',
    your: 'ваш',
    do: 'делать',
  },
  sv: {
    access: 'åtkomst',
    account: 'konto',
    action: 'åtgärd',
    actions: 'åtgärder',
    active: 'aktiv',
    add: 'lägg till',
    additional: 'ytterligare',
    age: 'ålder',
    all: 'alla',
    available: 'tillgänglig',
    back: 'tillbaka',
    baseline: 'referens',
    body: 'kropp',
    cancel: 'avbryt',
    change: 'ändra',
    client: 'klient',
    clients: 'klienter',
    coach: 'coach',
    coaches: 'coacher',
    compare: 'jämför',
    comparison: 'jämförelse',
    complete: 'klar',
    completed: 'slutförd',
    confirm: 'bekräfta',
    current: 'aktuell',
    dashboard: 'instrumentpanel',
    data: 'data',
    date: 'datum',
    delete: 'ta bort',
    diff: 'skillnad',
    difference: 'skillnad',
    download: 'ladda ner',
    edit: 'redigera',
    email: 'e-post',
    error: 'fel',
    facility: 'anläggning',
    fat: 'fett',
    filter: 'filtrera',
    first: 'första',
    fitness: 'fitness',
    full: 'full',
    gender: 'kön',
    goal: 'mål',
    goals: 'mål',
    health: 'hälsa',
    height: 'längd',
    history: 'historik',
    image: 'bild',
    images: 'bilder',
    i: 'jag',
    information: 'information',
    interest: 'intresse',
    last: 'sista',
    lean: 'mager',
    level: 'nivå',
    mass: 'massa',
    measurement: 'mått',
    measurements: 'mått',
    metric: 'mätvärde',
    metrics: 'mätvärden',
    name: 'namn',
    new: 'ny',
    no: 'nej',
    not: 'inte',
    page: 'sida',
    password: 'lösenord',
    posture: 'hållning',
    profile: 'profil',
    rating: 'betyg',
    remove: 'ta bort',
    report: 'rapport',
    request: 'begäran',
    result: 'resultat',
    results: 'resultat',
    scan: 'skanning',
    scans: 'skanningar',
    select: 'välj',
    shape: 'form',
    status: 'status',
    submit: 'skicka',
    summary: 'sammanfattning',
    survey: 'enkät',
    user: 'användare',
    users: 'användare',
    view: 'visa',
    visible: 'synlig',
    what: 'vad',
    waist: 'midja',
    weight: 'vikt',
    wellness: 'välmående',
    win: 'vinst',
    wins: 'vinster',
    your: 'din',
    do: 'göra',
  },
  ja: {
    access: 'アクセス',
    account: 'アカウント',
    action: '操作',
    actions: '操作',
    active: 'アクティブ',
    add: '追加',
    additional: '追加',
    age: '年齢',
    all: 'すべて',
    available: '利用可能',
    back: '戻る',
    baseline: '基準',
    body: '身体',
    cancel: 'キャンセル',
    change: '変更',
    client: '顧客',
    clients: '顧客',
    coach: 'コーチ',
    coaches: 'コーチ',
    compare: '比較',
    comparison: '比較',
    complete: '完了',
    completed: '完了',
    confirm: '確認',
    current: '現在',
    dashboard: 'ダッシュボード',
    data: 'データ',
    date: '日付',
    delete: '削除',
    diff: '差分',
    difference: '差分',
    download: 'ダウンロード',
    edit: '編集',
    email: 'メール',
    error: 'エラー',
    facility: '施設',
    fat: '脂肪',
    filter: 'フィルター',
    first: '最初',
    fitness: 'フィットネス',
    full: '完全',
    gender: '性別',
    goal: '目標',
    goals: '目標',
    health: '健康',
    height: '身長',
    history: '履歴',
    image: '画像',
    images: '画像',
    i: '私',
    information: '情報',
    interest: '関心',
    last: '最後',
    lean: '除脂肪',
    level: 'レベル',
    mass: '質量',
    measurement: '測定',
    measurements: '測定',
    metric: '指標',
    metrics: '指標',
    name: '名前',
    new: '新規',
    no: 'なし',
    not: '非',
    page: 'ページ',
    password: 'パスワード',
    posture: '姿勢',
    profile: 'プロフィール',
    rating: '評価',
    remove: '削除',
    report: 'レポート',
    request: 'リクエスト',
    result: '結果',
    results: '結果',
    scan: 'スキャン',
    scans: 'スキャン',
    select: '選択',
    shape: '形状',
    status: 'ステータス',
    submit: '送信',
    summary: '概要',
    survey: 'アンケート',
    user: 'ユーザー',
    users: 'ユーザー',
    view: '表示',
    visible: '表示',
    what: '何',
    waist: 'ウエスト',
    weight: '体重',
    wellness: 'ウェルネス',
    win: '成功',
    wins: '成功',
    your: 'あなたの',
    do: 'する',
  },
  tr: {
    access: 'erişim',
    account: 'hesap',
    action: 'işlem',
    actions: 'işlemler',
    active: 'aktif',
    add: 'ekle',
    additional: 'ek',
    age: 'yaş',
    all: 'tüm',
    available: 'mevcut',
    back: 'geri',
    baseline: 'referans',
    body: 'vücut',
    cancel: 'iptal',
    change: 'değiştir',
    client: 'müşteri',
    clients: 'müşteriler',
    coach: 'koç',
    coaches: 'koçlar',
    compare: 'karşılaştır',
    comparison: 'karşılaştırma',
    complete: 'tamamlandı',
    completed: 'tamamlandı',
    confirm: 'onayla',
    current: 'geçerli',
    dashboard: 'panel',
    data: 'veri',
    date: 'tarih',
    delete: 'sil',
    diff: 'fark',
    difference: 'fark',
    download: 'indir',
    edit: 'düzenle',
    email: 'e-posta',
    error: 'hata',
    facility: 'tesis',
    fat: 'yağ',
    filter: 'filtre',
    first: 'ilk',
    fitness: 'fitness',
    full: 'tam',
    gender: 'cinsiyet',
    goal: 'hedef',
    goals: 'hedefler',
    health: 'sağlık',
    height: 'boy',
    history: 'geçmiş',
    image: 'görüntü',
    images: 'görüntüler',
    i: 'ben',
    information: 'bilgi',
    interest: 'ilgi',
    last: 'son',
    lean: 'yağsız',
    level: 'seviye',
    mass: 'kütle',
    measurement: 'ölçüm',
    measurements: 'ölçümler',
    metric: 'metrik',
    metrics: 'metrikler',
    name: 'ad',
    new: 'yeni',
    no: 'hayır',
    not: 'değil',
    page: 'sayfa',
    password: 'şifre',
    posture: 'duruş',
    profile: 'profil',
    rating: 'puan',
    remove: 'kaldır',
    report: 'rapor',
    request: 'istek',
    result: 'sonuç',
    results: 'sonuçlar',
    scan: 'tarama',
    scans: 'taramalar',
    select: 'seç',
    shape: 'şekil',
    status: 'durum',
    submit: 'gönder',
    summary: 'özet',
    survey: 'anket',
    user: 'kullanıcı',
    users: 'kullanıcılar',
    view: 'görüntüle',
    visible: 'görünür',
    what: 'ne',
    waist: 'bel',
    weight: 'ağırlık',
    wellness: 'sağlık',
    win: 'kazanım',
    wins: 'kazanımlar',
    your: 'sizin',
    do: 'yap',
  },
  cs: {
    access: 'přístup',
    account: 'účet',
    action: 'akce',
    actions: 'akce',
    active: 'aktivní',
    add: 'přidat',
    additional: 'další',
    age: 'věk',
    all: 'vše',
    available: 'dostupné',
    back: 'zpět',
    baseline: 'referenční',
    body: 'tělo',
    cancel: 'zrušit',
    change: 'změnit',
    client: 'klient',
    clients: 'klienti',
    coach: 'trenér',
    coaches: 'trenéři',
    compare: 'porovnat',
    comparison: 'porovnání',
    complete: 'dokončeno',
    completed: 'dokončeno',
    confirm: 'potvrdit',
    current: 'aktuální',
    dashboard: 'přehled',
    data: 'data',
    date: 'datum',
    delete: 'smazat',
    diff: 'rozdíl',
    difference: 'rozdíl',
    download: 'stáhnout',
    edit: 'upravit',
    email: 'e-mail',
    error: 'chyba',
    facility: 'zařízení',
    fat: 'tuk',
    filter: 'filtr',
    first: 'první',
    fitness: 'fitness',
    full: 'plný',
    gender: 'pohlaví',
    goal: 'cíl',
    goals: 'cíle',
    health: 'zdraví',
    height: 'výška',
    history: 'historie',
    image: 'obrázek',
    images: 'obrázky',
    i: 'já',
    information: 'informace',
    interest: 'zájem',
    last: 'poslední',
    lean: 'netuková',
    level: 'úroveň',
    mass: 'hmota',
    measurement: 'měření',
    measurements: 'měření',
    metric: 'metrika',
    metrics: 'metriky',
    name: 'jméno',
    new: 'nový',
    no: 'ne',
    not: 'ne',
    page: 'stránka',
    password: 'heslo',
    posture: 'držení těla',
    profile: 'profil',
    rating: 'hodnocení',
    remove: 'odebrat',
    report: 'zpráva',
    request: 'žádost',
    result: 'výsledek',
    results: 'výsledky',
    scan: 'sken',
    scans: 'skeny',
    select: 'vybrat',
    shape: 'tvar',
    status: 'stav',
    submit: 'odeslat',
    summary: 'souhrn',
    survey: 'dotazník',
    user: 'uživatel',
    users: 'uživatelé',
    view: 'zobrazit',
    visible: 'viditelný',
    what: 'co',
    waist: 'pas',
    weight: 'hmotnost',
    wellness: 'wellness',
    win: 'výhra',
    wins: 'výhry',
    your: 'váš',
    do: 'dělat',
  },
  el: {
    access: 'πρόσβαση',
    account: 'λογαριασμός',
    action: 'ενέργεια',
    actions: 'ενέργειες',
    active: 'ενεργό',
    add: 'προσθήκη',
    additional: 'πρόσθετο',
    age: 'ηλικία',
    all: 'όλα',
    available: 'διαθέσιμο',
    back: 'πίσω',
    baseline: 'αναφορά',
    body: 'σώμα',
    cancel: 'ακύρωση',
    change: 'αλλαγή',
    client: 'πελάτης',
    clients: 'πελάτες',
    coach: 'προπονητής',
    coaches: 'προπονητές',
    compare: 'σύγκριση',
    comparison: 'σύγκριση',
    complete: 'ολοκληρωμένο',
    completed: 'ολοκληρωμένο',
    confirm: 'επιβεβαίωση',
    current: 'τρέχον',
    dashboard: 'πίνακας',
    data: 'δεδομένα',
    date: 'ημερομηνία',
    delete: 'διαγραφή',
    diff: 'διαφορά',
    difference: 'διαφορά',
    download: 'λήψη',
    edit: 'επεξεργασία',
    email: 'email',
    error: 'σφάλμα',
    facility: 'εγκατάσταση',
    fat: 'λίπος',
    filter: 'φίλτρο',
    first: 'πρώτο',
    fitness: 'fitness',
    full: 'πλήρης',
    gender: 'φύλο',
    goal: 'στόχος',
    goals: 'στόχοι',
    health: 'υγεία',
    height: 'ύψος',
    history: 'ιστορικό',
    image: 'εικόνα',
    images: 'εικόνες',
    i: 'εγώ',
    information: 'πληροφορίες',
    interest: 'ενδιαφέρον',
    last: 'τελευταίο',
    lean: 'άλιπη',
    level: 'επίπεδο',
    mass: 'μάζα',
    measurement: 'μέτρηση',
    measurements: 'μετρήσεις',
    metric: 'μετρική',
    metrics: 'μετρικές',
    name: 'όνομα',
    new: 'νέο',
    no: 'όχι',
    not: 'δεν',
    page: 'σελίδα',
    password: 'κωδικός',
    posture: 'στάση',
    profile: 'προφίλ',
    rating: 'βαθμολογία',
    remove: 'αφαίρεση',
    report: 'αναφορά',
    request: 'αίτημα',
    result: 'αποτέλεσμα',
    results: 'αποτελέσματα',
    scan: 'σάρωση',
    scans: 'σαρώσεις',
    select: 'επιλογή',
    shape: 'σχήμα',
    status: 'κατάσταση',
    submit: 'υποβολή',
    summary: 'σύνοψη',
    survey: 'ερωτηματολόγιο',
    user: 'χρήστης',
    users: 'χρήστες',
    view: 'προβολή',
    visible: 'ορατό',
    what: 'τι',
    waist: 'μέση',
    weight: 'βάρος',
    wellness: 'ευεξία',
    win: 'νίκη',
    wins: 'νίκες',
    your: 'δικό σας',
    do: 'κάνω',
  },
  hr: {
    access: 'pristup',
    account: 'račun',
    action: 'radnja',
    actions: 'radnje',
    active: 'aktivan',
    add: 'dodaj',
    additional: 'dodatno',
    age: 'dob',
    all: 'sve',
    available: 'dostupno',
    back: 'natrag',
    baseline: 'referenca',
    body: 'tijelo',
    cancel: 'odustani',
    change: 'promijeni',
    client: 'klijent',
    clients: 'klijenti',
    coach: 'trener',
    coaches: 'treneri',
    compare: 'usporedi',
    comparison: 'usporedba',
    complete: 'dovršeno',
    completed: 'dovršeno',
    confirm: 'potvrdi',
    current: 'trenutno',
    dashboard: 'nadzorna ploča',
    data: 'podaci',
    date: 'datum',
    delete: 'izbriši',
    diff: 'razlika',
    difference: 'razlika',
    download: 'preuzmi',
    edit: 'uredi',
    email: 'e-pošta',
    error: 'pogreška',
    facility: 'objekt',
    fat: 'masnoća',
    filter: 'filtriraj',
    first: 'prvi',
    fitness: 'fitness',
    full: 'puni',
    gender: 'spol',
    goal: 'cilj',
    goals: 'ciljevi',
    health: 'zdravlje',
    height: 'visina',
    history: 'povijest',
    image: 'slika',
    images: 'slike',
    i: 'ja',
    information: 'informacije',
    interest: 'interes',
    last: 'zadnji',
    lean: 'nemasna',
    level: 'razina',
    mass: 'masa',
    measurement: 'mjerenje',
    measurements: 'mjerenja',
    metric: 'metrika',
    metrics: 'metrike',
    name: 'ime',
    new: 'novo',
    no: 'ne',
    not: 'nije',
    page: 'stranica',
    password: 'lozinka',
    posture: 'držanje',
    profile: 'profil',
    rating: 'ocjena',
    remove: 'ukloni',
    report: 'izvješće',
    request: 'zahtjev',
    result: 'rezultat',
    results: 'rezultati',
    scan: 'skeniranje',
    scans: 'skeniranja',
    select: 'odaberi',
    shape: 'oblik',
    status: 'status',
    submit: 'pošalji',
    summary: 'sažetak',
    survey: 'upitnik',
    user: 'korisnik',
    users: 'korisnici',
    view: 'prikaži',
    visible: 'vidljivo',
    what: 'što',
    waist: 'struk',
    weight: 'težina',
    wellness: 'wellness',
    win: 'pobjeda',
    wins: 'pobjede',
    your: 'vaš',
    do: 'učiniti',
  },
}

const WRAPPING_QUOTE_PATTERN = /^(['"])(.*)\1$/
const TRAILING_PUNCTUATION_PATTERN = /^(.+?)([:.!?])$/
const PARENTHETICAL_UNIT_PATTERN = /^(.+?)\s+\((lbs?|kg|cm|in\.?|inches|years?|%)\)$/i
const NUMBERED_YEARS_PATTERN = /^(-?\d+(?:\.\d+)?)\s+(years?)$/i
const PARENTHETICAL_NUMBER_PATTERN = /^(.+?)\s+\((-?\d+(?:\.\d+)?)\)$/
const COMPOSABLE_WORD_PATTERN = /[A-Za-z][A-Za-z'’-]*/g
const MAX_COMPOSABLE_WORDS = 5

const preserveLowercaseStart = (source, translated) => {
  if (!source || source[0] !== source[0].toLowerCase()) {
    return translated
  }

  return `${translated.charAt(0).toLowerCase()}${translated.slice(1)}`
}

const getUppercasePhraseAlias = (phrase) => {
  if (phraseAliases[phrase]) {
    return phraseAliases[phrase]
  }

  if (!/[A-Z]/.test(phrase) || /[a-z]/.test(phrase)) {
    return null
  }

  return phrase
    .toLowerCase()
    .replace(/\b[a-z]/g, (letter) => letter.toUpperCase())
}

const getDictionaryPhraseTranslations = (language) => {
  if (!dictionaryPhraseTranslations[language]) {
    const english = dictionaries[DEFAULT_LANGUAGE] || {}
    const translated = dictionaries[language] || {}

    dictionaryPhraseTranslations[language] = Object.keys(english).reduce(
      (phrases, key) => {
        const source = english[key]
        const target = translated[key]

        if (target && target !== source) {
          phrases[source] = target
        }

        return phrases
      },
      {}
    )
  }

  return dictionaryPhraseTranslations[language]
}

const normalizeComposableWord = (word) =>
  word
    .toLowerCase()
    .replace(/[’']/g, "'")
    .replace(/'s$/, '')
    .replace(/^e-mail$/, 'email')

const getComposableWordTranslation = (language, word) => {
  const translations = {
    ...(composableWordTranslations[language] || {}),
    ...(composableDirectionTranslations[language] || {}),
  }

  if (!Object.keys(translations).length) {
    return null
  }

  return translations[normalizeComposableWord(word)] || null
}

const preserveComposableWordCase = (source, translated) => {
  if (source === source.toUpperCase()) {
    return translated.toUpperCase()
  }

  if (source[0] === source[0].toUpperCase()) {
    return `${translated.charAt(0).toUpperCase()}${translated.slice(1)}`
  }

  return translated
}

const translateComposablePhrase = (language, phrase) => {
  if (
    !composableWordTranslations[language] &&
    !composableDirectionTranslations[language]
  ) {
    return null
  }

  const words = phrase.match(COMPOSABLE_WORD_PATTERN) || []

  if (!words.length || words.length > MAX_COMPOSABLE_WORDS) {
    return null
  }

  if (!words.every((word) => getComposableWordTranslation(language, word))) {
    return null
  }

  const translatedPhrase = phrase.replace(COMPOSABLE_WORD_PATTERN, (word) => {
    return preserveComposableWordCase(
      word,
      getComposableWordTranslation(language, word)
    )
  })

  return translatedPhrase !== phrase ? translatedPhrase : null
}

const getPhraseTranslationCandidates = (language, phrase) => {
  const translations = phraseTranslations[language] || {}
  const supplementalTranslations =
    supplementalPhraseTranslations[language] || {}
  const comparisonTranslations =
    comparisonEmptyStateTranslations[language] || {}
  const wellnessReportTranslations =
    wellnessReportPhraseTranslations[language] || {}
  const fullReportTranslations = fullReportPhraseTranslations[language] || {}
  const renderedPageTranslations =
    renderedPagePhraseTranslations[language] || {}
  const coachRenderedPageTranslations =
    coachRenderedPagePhraseTranslations[language] || {}
  const sourceAuditTranslations = sourceAuditPhraseTranslations[language] || {}
  const sourceAuditRemainder = sourceAuditRemainderTranslations[language] || {}
  const longFormSourceTranslations =
    longFormSourcePhraseTranslations[language] || {}
  const downloadableReportTranslations =
    downloadableReportPhraseTranslations[language] || {}
  const glossarySurfaceTranslations =
    glossarySurfacePhraseTranslations[language] || {}
  const sharedWellnessActionPhrases =
    sharedWellnessActionTranslations[language] || {}
  const dictionaryTranslations = getDictionaryPhraseTranslations(language)
  const composableTranslation = translateComposablePhrase(language, phrase)

  return [
    wellnessReportTranslations[phrase],
    fullReportTranslations[phrase],
    translations[phrase],
    supplementalTranslations[phrase],
    comparisonTranslations[phrase],
    renderedPageTranslations[phrase],
    coachRenderedPageTranslations[phrase],
    sourceAuditTranslations[phrase],
    sourceAuditRemainder[phrase],
    longFormSourceTranslations[phrase],
    downloadableReportTranslations[phrase],
    glossarySurfaceTranslations[phrase],
    sharedWellnessActionPhrases[phrase],
    dictionaryTranslations[phrase],
    composableTranslation,
  ]
}

export const hasPhraseTranslation = (language, phrase) => {
  if (getPhraseTranslationCandidates(language, phrase).some(Boolean)) {
    return true
  }

  const wrappingQuoteMatch = phrase.match(WRAPPING_QUOTE_PATTERN)

  if (
    wrappingQuoteMatch &&
    hasPhraseTranslation(language, wrappingQuoteMatch[2])
  ) {
    return true
  }

  const trailingPunctuationMatch = phrase.match(TRAILING_PUNCTUATION_PATTERN)

  if (
    trailingPunctuationMatch &&
    hasPhraseTranslation(language, trailingPunctuationMatch[1])
  ) {
    return true
  }

  const parentheticalUnitMatch = phrase.match(PARENTHETICAL_UNIT_PATTERN)

  if (
    parentheticalUnitMatch &&
    hasPhraseTranslation(language, parentheticalUnitMatch[1])
  ) {
    return true
  }

  const numberedYearsMatch = phrase.match(NUMBERED_YEARS_PATTERN)

  if (
    numberedYearsMatch &&
    translatePhrase(language, numberedYearsMatch[2].toLowerCase()) !==
      numberedYearsMatch[2].toLowerCase()
  ) {
    return true
  }

  const parentheticalNumberMatch = phrase.match(PARENTHETICAL_NUMBER_PATTERN)

  if (
    parentheticalNumberMatch &&
    hasPhraseTranslation(language, parentheticalNumberMatch[1])
  ) {
    return true
  }

  const uppercaseAlias = getUppercasePhraseAlias(phrase)

  if (
    uppercaseAlias &&
    uppercaseAlias !== phrase &&
    hasPhraseTranslation(language, uppercaseAlias)
  ) {
    return true
  }

  const titleCaseAlias = phrase
    .toLowerCase()
    .replace(/\b[a-z]/g, (letter) => letter.toUpperCase())

  return (
    titleCaseAlias !== phrase && hasPhraseTranslation(language, titleCaseAlias)
  )
}

export const translatePhrase = (language, phrase) => {
  const candidates = getPhraseTranslationCandidates(language, phrase)
  const translated = candidates.find(
    (candidate) => candidate && candidate !== phrase
  )

  if (translated) {
    return translated
  }

  const wrappingQuoteMatch = phrase.match(WRAPPING_QUOTE_PATTERN)

  if (wrappingQuoteMatch) {
    const quote = wrappingQuoteMatch[1]
    const innerPhrase = wrappingQuoteMatch[2]
    const innerTranslation = translatePhrase(language, innerPhrase)

    if (innerTranslation !== innerPhrase) {
      return `${quote}${innerTranslation}${quote}`
    }
  }

  const trailingPunctuationMatch = phrase.match(TRAILING_PUNCTUATION_PATTERN)

  if (trailingPunctuationMatch) {
    const basePhrase = trailingPunctuationMatch[1]
    const punctuation = trailingPunctuationMatch[2]
    const baseTranslation = translatePhrase(language, basePhrase)

    if (baseTranslation !== basePhrase) {
      return `${baseTranslation}${punctuation}`
    }
  }

  const parentheticalUnitMatch = phrase.match(PARENTHETICAL_UNIT_PATTERN)

  if (parentheticalUnitMatch) {
    const basePhrase = parentheticalUnitMatch[1]
    const unit = parentheticalUnitMatch[2]
    const baseTranslation = translatePhrase(language, basePhrase)

    if (baseTranslation !== basePhrase) {
      return `${baseTranslation} (${unit})`
    }
  }

  const numberedYearsMatch = phrase.match(NUMBERED_YEARS_PATTERN)

  if (numberedYearsMatch) {
    const value = numberedYearsMatch[1]
    const unit = numberedYearsMatch[2]
    const unitTranslation = translatePhrase(language, unit.toLowerCase())

    if (unitTranslation !== unit.toLowerCase()) {
      return `${value} ${unitTranslation}`
    }
  }

  const parentheticalNumberMatch = phrase.match(PARENTHETICAL_NUMBER_PATTERN)

  if (parentheticalNumberMatch) {
    const basePhrase = parentheticalNumberMatch[1]
    const value = parentheticalNumberMatch[2]
    const baseTranslation = translatePhrase(language, basePhrase)

    if (baseTranslation !== basePhrase) {
      return `${baseTranslation} (${value})`
    }
  }

  const uppercaseAlias = getUppercasePhraseAlias(phrase)

  if (uppercaseAlias && uppercaseAlias !== phrase) {
    const aliasTranslation = translatePhrase(language, uppercaseAlias)

    if (aliasTranslation !== uppercaseAlias) {
      return aliasTranslation
    }
  }

  const titleCaseAlias = phrase
    .toLowerCase()
    .replace(/\b[a-z]/g, (letter) => letter.toUpperCase())

  if (titleCaseAlias !== phrase) {
    const titleCaseTranslation = translatePhrase(language, titleCaseAlias)

    if (titleCaseTranslation !== titleCaseAlias) {
      return preserveLowercaseStart(phrase, titleCaseTranslation)
    }
  }

  return phrase
}
